export default {
    "cy": {
        "translations": {
            "English": "Saesneg",
            "Cymraeg": "Cymraeg",
            "is_loading": "yn llwytho",
            "please_be_patient": "Peidiwch â adnewyddu eich porwr os gwelwch yn dda",
            "loading_browser_support_message": "Os bydd y cais yn methu llwytho, gwnewch yn si_r eich bod yn defnyddio porwr a gefnogir - Chrome, MS Edge, Safari (10+) a Firefox",
            "ie11_heading": "Porwr Heb G gefnogi",
            "ie11_message": "Rydych yn ceisio llwytho ap askmyGP ar borwr na gefnogir. Mae ap askmyGP yn cefnogi Chrome, MS Edge, Safari (10+) a Firefox.",
            "ie11_help_link": "Cliciwch yma am ganllawiau ar sut i newid IE11 fel eich porwr diofyn ar gyfer askmyGP.",
            "ie11_password_reset": "I ailosod eich cyfrinair, copïwch y URL isod i mewn i borwr a gefnogir.",
            "application_failed_to_load": "Ymddiheuriadau, mae gennym broblem dechnegol. Rhowch gynnig arni yn nes ymlaen.",
            "edit_demand_capacity": "Golygu'r Galw am Ddefnydd a Chapasiti Gr_p",
            "save": "Cadw",
            "cancel": "Diddymu",
            "show": "Dangos",
            "hide": "Cuddio",
            "login": "Mewngofnodi",
            "log_in": "Mewngofnodi",
            "logout": "Allgofnodi",
            "edit": "Golygu",
            "delete": "Dileu",
            "help": "Help",
            "edit_patient": "Golygu claf",
            "send_assign": "Anfon / Neilltuo",
            "sar": "Lawrlwytho hanes",
            "update": "Diweddaru",
            "create": "Creu",
            "create_staff": "Creu staff",
            "spine_lookup": "Chwilio yn NHS Spine",
            "close": "Cau",
            "clear": "Clirio",
            "apply": "Gosod",
            "search": "Chwilio",
            "copy_to_patient_record": "Copïo i gofnod claf",
            "remove_site": "Dileu safle",
            "add_site": "Ychwanegu safle arall",
            "add_linked_provider": "Ychwanegu darparwr cysylltiedig",
            "update_settings": "Diweddaru Gosodiadau",
            "view_appointments_calendar": "Gweld calendr apwyntiadau",
            "view": "Gweld",
            "add": "Ychwanegu",
            "remove": "Dileu",
            "start_video_call": "Dechrau galw fideo",
            "advanced_search": "Chwilio Uwch",
            "create_new_request": "Creu cais newydd",
            "create_new_request_provider": "Cais newydd",
            "view_activity": "Gweld gweithgarwch",
            "reset_demo_questions": "Ailosod Cwestiynau Demo",
            "send_welcome_email_password": "Anfon e-bost croeso / ailosod cyfrinair",
            "reset_password": "Ailosod Cyfrinair",
            "create_password": "Creu Cyfrinair",
            "set_password": "Gosod Cyfrinair",
            "change_password": "Newid Cyfrinair",
            "send_password_reset_link": "Anfon Dolen Ailosod Cyfrinair",
            "confirm_password": "Cadarnhau Cyfrinair",
            "confirm": "Cadarnhau",
            "register": "Cofrestru",
            "register_patient": "Cofrestru claf",
            "add_another_patient": "Ychwanegu claf arall",
            "add_another_person": "Ychwanegu person arall",
            "next": "Nesaf",
            "back": "Yn ôl",
            "prev": "Yn ôl",
            "previous": "Blaenorol",
            "email_address": "Cyfeiriad e-bost",
            "email": "E-bost",
            "email_or_user_id": "E-bost neu Id Defnyddiwr",
            "password": "Cyfrinair",
            "current_password": "Cyfrinair Presennol",
            "new_password": "Cyfrinair Newydd",
            "forename": "Enw Cyntaf",
            "first_names": "Enw(au) Cyntaf",
            "gender": "Rhyw",
            "DOB": "Dyddiad Geni",
            "date_of_birth": "Dyddiad Geni",
            "postcode": "Cod Post",
            "on": "Ar",
            "off": "Ddim ar gael",
            "yes": "Ydw",
            "no": "Nac ydw",
            "set_service_availability": "Gosod argaeledd y gwasanaeth",
            "time_requests_return_waiting": "Amser pan fydd ceisiadau yn dychwelyd o'r aros",
            "set_waiting_days": "Gosod diwrnodau aros diofyn",
            "relationship_type": "Math Perthynas",
            "relationship": "Perthynas",
            "select_site": "Dewis safle",
            "site": "Safle",
            "scope_of_message": "Ystod y neges *",
            "all_sites": "Pob safle",
            "combined_sites": "Safleoedd cyfun",
            "please_select": "Dewiswch os gwelwch yn dda",
            "out_of_hours_requests": "Ceisiadau y tu allan i oriau gwaith",
            "closed_to_new_requests": "Wedi cau i geisiadau newydd",
            "availability_until_previous": "Bydd statws yn cael ei gymryd o'r diwrnod blaenorol.",
            "availability_until_previous_help1": "Mae'r gosodiad hwn yn dweud wrth y system sut i drin ceisiadau a gyflwynir rhwng amser cau'r dydd presennol a chyfnod agoriad y dydd nesaf sydd â rhywfaint o argaeledd wedi'i osod.",
            "availability_until_previous_help2": "Pan nad oes gan ddyddiad agoriad, bydd y gosodiad yn cael ei gymryd o'r dyddiad blaenorol cyntaf lle mae argaeledd wedi'i osod.",
            "availability_until_previous_help3": "Er enghraifft, os nad oes gan ddydd Sadwrn a dydd Sul unrhyw amseroedd argaeledd wedi'u gosod, bydd argaeledd y gwasanaeth yn cael ei gymryd o ddydd Gwener, a'i gweithredu ar y ddwy ddydd tan a chynnwys y cyfnod cyn agoriad ar y dydd Llun canlynol.",
            "availability_until_previous_help4": "Os ydych chi'n dymuno tynnu'r system yn ddibynnol yn dros dro, ystyriwch ddefnyddio'r gosodiad argaeledd cyffredinol uchod.",
            "global": "Cyffredinol",
            "is": "yw",
            "is_not": "nid yw",
            "contains": "yn cynnwys",
            "does_not_contain": "nid yw'n cynnwys",
            "field": "Maes",
            "NHS_spine": "NHS Spine",
            "current": "Presennol",
            "NHS_number": "Rhif NHS/CHI",
            "provider_code": "Cod Darparwr",
            "title": "Teitl",
            "surname": "Cyfenw",
            "forenames": "Enw(au) Cyntaf",
            "phone": "Ffôn",
            "address_line_1": "Llinell Cyfeiriad 1",
            "address_line_2": "Llinell Cyfeiriad 2",
            "address_line_3": "Llinell Cyfeiriad 3",
            "address_line_4": "Llinell Cyfeiriad 4",
            "address_line_5": "Llinell Cyfeiriad 5",
            "day": "Dydd",
            "predicted_demand": "Galwad am Ddisgrifiadol",
            "in_hours_service_times": "Amseroedd Gwasanaeth yn ystod oriau gwaith",
            "service_until_next_opening": "Gwasanaeth hyd at yr agoriad nesaf",
            "day_of_week": "Dydd o'r Wythnos",
            "availability": "Argaeledd",
            "unavailable": "Ddim ar gael",
            "capacity_requests": "Capasiti (ceisiadau)",
            "date": "Dyddiad",
            "session": "Sesiwn",
            "max_book_ahead_time": "Amser Mwyaf ymlaen llaw i archebu",
            "min_book_ahead_time": "Amser Gwaelaf ymlaen llaw i archebu",
            "appointments_interval": "Amser rhwng apwyntiadau",
            "session_name": "Enw'r Sesiwn",
            "start_date": "Dyddiad Dechrau",
            "end_date": "Dyddiad Gorffen",
            "actions": "Gweithredoedd",
            "digital_triage": "Trais Digidol",
            "request_solved_by_mode": "Cais Meddyg Teulu a ddatryswyd gan fodd",
            "other_clinician": "Gweithiwr Clinigol Arall",
            "admin": "Gweinyddu",
            "no_availability": "Dim argaeledd",
            "message": "neges",
            "telephone": "Ffôn",
            "face_to_face": "Wyneb yn wyneb",
            "GP": "Meddyg Teulu",
            "total_requests": "Cyfanswm ymholiadau",
            "min_request": "Min/y cais",
            "total_minutes": "Cyfanswm munudau",
            "is_proxy_for": "Yw procsy am",
            "in_care_of": "Dan ofal",
            "average_consult_time_min": "Amser ymgynghori cyfartalog/munud",
            "name_of_session": "enw sesiwn",
            "7_days": "7 diwrnod",
            "15_mins": "15 munud",
            "no_standard_availability": "Dim argaeledd safonol wedi'i ddarganfod",
            "none_listed": "Dim un wedi'i restru",
            "enter_only_one": "Rhowch dim ond un",
            "see_settings_groups": "Gweler hefyd Gosodiadau > Grwpiau i sicrhau aelodaeth gywir",
            "tooltip_one_field_is_enough": "Dim ond dyddiad geni sy'n gweithio orau",
            "news_and_updates": "Newyddion a Diweddariadau",
            "create_new": "Creu newydd",
            "settings": "Gosodiadau",
            "reports": "Adroddiadau",
            "diagnostics": "Diagnosteg",
            "digital_triage_results": "Canlyniadau Trîag Digidol",
            "update_your_details": "Diweddaru eich manylion",
            "register_for_account": "Cofrestru am gyfrif",
            "self_help": "Cymorth i'ch Hunan",
            "service_times": "Amseroedd Gwasanaeth",
            "service_status": "Statws y Gwasanaeth",
            "messages": "Negeseuon",
            "sites": "Safleoedd",
            "availability_exceptions": "Eithriadau Argaeledd",
            "appointment_settings": "Gosodiadau Apwyntiadau",
            "appointment_session_types": "Mathau sesiwn apwyntiadau",
            "appointment_sessions": "Sesiynau apwyntiadau",
            "booking_availability": "Argaeledd archebu",
            "select_relationship": "Dewis Perthynas",
            "staff_login_to": "Mewngofnodi i Staff",
            "link_forgotten_password": "Wedi anghofio Cyfrinair?",
            "forgotten_password": "Wedi anghofio Cyfrinair",
            "password_reset_sucess_message": "Mae eich cyfrinair wedi'i ailosod yn llwyddiannus. Gallwch nawr fewngofnodi gan ddefnyddio eich cyfrinair newydd.",
            "password_reset_email_sent_message": "Mae e-bost ailosod cyfrinair wedi'i anfon i'ch cyfeiriad e-bost, os yw wedi'i gofrestru. Dilynwch y cyfarwyddiadau yn yr e-bost i ailosod eich cyfrinair.",
            "home": "Hafan",
            "dashboard": "Dangosfwrdd",
            "request": "Cais",
            "requests": "Ceisiadau",
            "patients": "Clafon",
            "accounts": "Comptes",
            "staff": "Staff",
            "appointments": "Apwyntiadau",
            "my_profile": "Fy Mhroffil",
            "profile": "Proffil",
            "preset_messages": "Negeseuon Ymgot",
            "preset_message_search": "Chwiliad Neges Ymgot",
            "patient_search": "Chwilio Claf",
            "news_items": "Eitemau Newyddion",
            "log_entries": "Cofnodion Log",
            "feedback_entries": "Cofnodion Adborth",
            "staff_members": "Aelodau Staff",
            "user_groups": "Grwpiau Defnyddwyr",
            "duplicate_patients": "Clafon Dyblyg",
            "manage_duplicates": "Rheoli dyblygiadau",
            "groups": "Grwpiau",
            "system": "System",
            "system_logs": "Logiau",
            "guide": "Canllaw",
            "feedback": "Adborth",
            "send_feedback": "Anfon Adborth",
            "patient_feedback": "Adborth gan Gleifion",
            "news": "Newyddion",
            "version": "Fersiwn",
            "demand_and_capacity": "Galwad & Capasiti",
            "filtered": "wedi'i hidlo",
            "filter": "hidlo",
            "show_all_clinicians": "dangos pob clinigwr",
            "new": "Newydd",
            "assigned": "Wedi'i neilltuo",
            "assigned_now": "Wedi'i neilltuo (nawr)",
            "assigned_today": "Wedi'i neilltuo hyd yn hyn heddiw",
            "share": "Rhannu",
            "shared": "rhannwyd",
            "stop_share": "Dad-rhannu",
            "assigned_to": "Neilltuo i",
            "assigned_to_me_or_my_groups": "Neilltuo i mi neu fy nhimau",
            "waiting_for_patient_assigned_to_me_or_my_groups": "Yn aros am glaf, wedi'i neilltuo i mi neu fy nhimau",
            "include": "Cynnwys",
            "waiting_for_patient": "Yn aros am glaf",
            "new_today": "Newydd heddiw",
            "completed_today": "Wedi cwblhau heddiw",
            "today": "Heddiw",
            "copy": "Copïo",
            "copy_to_clipboard": "Copïo i'r clipfwrdd",
            "copy_rs": "Copïo i'r system cofnodi",
            "copy_rso": "Copïo i system cofnodi'r darparwr wreiddiol",
            "copy_and_transfer": "Copïo a thrwydro",
            "copy_and_transfer_rs": "Copïo i'r system cofnodi a throsglwyddo",
            "skip_and_transfer": "Neidio a throsglwyddo",
            "copy_and_transfer_message": "Os oes angen, copïwch i'ch cofnod cyn trosglwyddo",
            "wait_and_transfer_message": "Os oes angen, gallwch osod y neges i aros am ateb cyn trosglwyddo",
            "copy_and_share": "Copïo a rhannu",
            "copy_and_share_rs": "Copïo i'r system cofnodi a rhannu",
            "skip_and_share": "Neidio a rhannu",
            "copy_and_share_message": "Os oes angen, copïwch i'ch cofnod cyn rhannu",
            "wait_and_share_message": "Os oes angen, gallwch osod y neges i aros am ateb cyn rhannu",
            "thread_originated_at": "Wedi'i ddechrau yn",
            "shared_with": "Rhannwyd gyda",
            "set_follow_up": "Gosod dilyniant",
            "cancel_follow_up": "Canslo dilyniant",
            "re-open": "Ailagor",
            "send": "Anfon",
            "now": "Nawr",
            "waiting": "Yn aros",
            "clinician": "Clinigwr",
            "clinician_group": "Person/Gr_p",
            "team": "Tîm",
            "network": "Rhwydwaith",
            "completed": "Wedi'i gwblhau",
            "mine": "Eiddo fi",
            "closed": "Wedi'i gau",
            "archived": "Archifedig",
            "capacity": "Capasiti",
            "complete": "Cwblhau",
            "born": "Genedigol",
            "address": "Cyfeiriad",
            "emergency": "Argyfwng",
            "urgent": "Brys",
            "routine": "Arferol",
            "visit_request": "Cais Ymweld",
            "elevated": "Uwch",
            "lower": "Is",
            "download": "Lawrlwytho",
            "wrote": "ysgrifennodd",
            "create_follow_up": "Creu dilyniant",
            "requestID": "ID y cais",
            "name": "Enw",
            "month": "Mis",
            "year": "Blwyddyn",
            "group": "Gr_p",
            "user_not_assigned_to_any_groups": "Nid yw'r defnyddiwr hwn wedi'i neilltuo i unrhyw grwpiau",
            "all": "Pob",
            "provider": "Darparwr",
            "providers": "Darparwyr",
            "forename(s)": "Enw(yddion)",
            "alias": "Enw byr, a ddangosir i gleifion",
            "IDStatus": "Statws ID",
            "patientID": "ID y Claf",
            "age": "Oed",
            "comment": "Sylw",
            "profession": "Proffesiwn",
            "gpad_profession": "Gr_p Proffesiynol",
            "scope": "Ystod",
            "content": "Cynnwys",
            "updated": "wedi'i ddiweddaru",
            "estimated_capacity": "capasiti amcangyfrifedig",
            "so_far_today": "Hyd yn hyn heddiw",
            "filter_no_users_found": "Dim defnyddwyr wedi'u canfod ar gyfer y hidlydd a ddewiswyd ar hyn o bryd.",
            "patient_read_all": "Mae'r claf wedi darllen yr holl negeseuon",
            "new_message_patient_read_all": "Neges Newydd a darllenwyd gan y claf yr holl negeseuon",
            "patient_unread": "Mae gan y claf ymateb sydd heb ei ddarllen",
            "new_message_patient_unread": "Neges Newydd a ymateb heb ei ddarllen gan y claf",
            "unread_message": "neges heb ei darllen",
            "unread_messages": "Negeseuon heb eu darllen",
            "phone_and_email": "Ffôn ac e-bost",
            "requested_GP": "Gofynnwyd am feddyg teuluol",
            "demo_mode": "Modd Demo",
            "demo_create_50_reqests_message": "Os yw'r modd demo wedi'i droi ymlaen, bydd gan y superddefnydd 50 o geisiadau demo a grëwyd ar ei gyfer, felly byddwch yn amyneddgar pan fyddwch yn clicio \"creu\".",
            "service_availability": "Argaeledd y Gwasanaeth",
            "video_available": "Fideo Ar Gael",
            "video_enabled": "Fideo Galluogi",
            "appointment_booking_enabled": "Apwyntiadau Galluogi",
            "clinician_gender_selection_enabled": "Gallu Dewis Rhywedd Clinigydd",
            "campaigns_enabled": "Camgymeriadau Galluogi",
            "list_size": "maint y rhestr",
            "practice_type": "Math Practis",
            "practice_status": "Statws Practis",
            "provider_type": "Math Darparwr",
            "patient_link": "Dolen Claf",
            "no_items_found": "Ni chanfuwyd eitemau",
            "qa_in_progress": "ARBED YN CAEL EU PROFI:",
            "no_subject": "dim pwnc",
            "subject_id": "ID y Pwnc",
            "causer_id": "ID Ysgogi",
            "item_id": "ID Eitem",
            "user_id": "ID Defnyddiwr",
            "set_default_language": "Gosod iaith ragosodedig",
            "language": "Iaith",
            "update_filter_options": "Diweddaru dewisiadau hidlydd",
            "read": "Darllen",
            "how_was_this_request_resolved?": "Sut y cafodd y cais ei ddatrys?",
            "session_times": "Amseroedd sesiwn",
            "no_sessions_available": "Dim sesiynau ar gael",
            "no_appointments_available": "Nid oes unrhyw apwyntiadau ar gael ar hyn o bryd. Cliciwch \"yn ôl\" a dewiswch ddiwrnod arall.",
            "choose_appointment_day": "Dewiswch y diwrnod agosaf cyfleus",
            "choose_appointment_time": "Dewiswch amser ar gyfer eich apwyntiad",
            "change_booking": "Newid y Bwcio",
            "availability_of_the_service": "Argaeledd y gwasanaeth",
            "default_language": "Iaith ragosodedig",
            "history_from_patient": "Hanes gan y claf",
            "date_of_birth_copied_to_clipboard": "Dyddiad Geni wedi'i gopïo i'r clipfwrdd",
            "no_site_specified": "Dim safle wedi'i nodi",
            "unsaved_changes_title": "Newidiadau heb eu cadw",
            "unsaved_changes_text": "Mae gennych ddata heb ei gadw a bydd yn cael ei golli os byddwch yn symud oddi ar y sgrin hon. Ydych chi'n si_r eich bod am barhau?",
            "incomplete_qa_text": "Mae gennych asesiad ansawdd diweddar nad yw wedi'i gwblhau sydd ar y gweill. Ydych chi'n si_r eich bod am barhau?",
            "incomplete_qa_text_saved": "Mae gennych asesiad ansawdd diweddar nad yw wedi'i gwblhau. Byddwn yn ceisio cadw eich cynnydd yn ddiogel yn y porwr gwe hwn, er mwyn i chi allu parhau â'r asesiad yn nes ymlaen. Ydych chi'n si_r eich bod am barhau?",
            "thread_created_by_staff": "Staff member creodd y cais hwn",
            "thread_created_by_proxy": "Porwr creodd y cais hwn",
            "assigned_thread_to": "neilltuwyd y cais i",
            "user_set_priority_to": "{user} gosod blaenoriaeth i {priority}",
            "form_set_priority_to": "Ffurflen '{form}' gosod blaenoriaeth i {priority}",
            "blood_pressure_range_set_priority_to": "Amrediad pwysedd gwaed gosod blaenoriaeth i {priority}",
            "user_assigned_thread_to": "{user} neilltuo cais i {to}",
            "shared_thread_with": "rhannu cais gyda",
            "user_shared_thread_with": "{user} rhannu cais gyda {provider}",
            "unshared_thread_with": "atal rhannu gyda",
            "user_unshared_thread_with": "{user} atal rhannu gyda {provider}",
            "transferred_ownership_of_thread_to": "trosglwyddo berchnogaeth y llinell i",
            "user_transferred_ownership_of_thread_to": "{user} trosglwyddo berchnogaeth y llinell i {provider}",
            "set_thread_as_unassigned": "gosod cais heb ei neilltuo",
            "user_set_thread_as_unassigned": "{user} gosod cais heb ei neilltuo",
            "completed_this_request": "{user} cwblhaodd y cais hwn",
            "autocomplete_request_timeout": "Mae'r cais hwn wedi'i gwblhau'n awtomatig ar ôl aros.",
            "autocomplete_request_custom_action": "Mae'r cais hwn wedi'i gwblhau'n awtomatig gan ei fod wedi'i greu o gam gweithredu cyfaddasol gyda chwilio awtomatig wedi'i alluogi.",
            "re-opened_this_request": "{user} ailagorodd y cais hwn",
            "closed_response_to_patient": "Diolch, mae'r gwasanaeth ar gau ar hyn o bryd ar gyfer gofynion askmyGP. Rydym wedi derbyn eich cais a byddwn yn ymateb pan fydd y gwasanaeth yn ailagor. Edrychwch am unrhyw e-byst o no-reply@askmygp.uk. Sicrhewch fod eich ffôn ar gael gan efallai y bydd angen i ni alw chi. Gall yr ymarfer feddygol recordio galwadau at ddibenion hyfforddi, monitro ac adolygu.",
            "open_service_response_to_patient": "Diolch, mae'r gwasanaeth ar agor, a byddwn yn ymateb cyn gynted â phosibl. Edrychwch am unrhyw e-byst o no-reply@askmygp.uk. Sicrhewch fod eich ffôn ar gael gan efallai y bydd angen i ni alw chi. Gall yr ymarfer feddygol recordio galwadau at ddibenion hyfforddi, monitro ac adolygu.",
            "duplicate_patient_details": "Manylion Claf Ddyblyg",
            "considerations": "Ystyriadau",
            "consider_the_following_before_merging": "Dylech ystyried y pwyntiau canlynol am y ddau gofnod Claf cyn eu cyfuno",
            "both_patient_accounts_active_and_logged_in": "Mae'r ddau gyfrif Claf yn weithredol ac wedi'u defnyddio gan y claf i fewngofnodi. Efallai y byddwch yn dymuno ymgynghori â'r claf i ganfod pa gyfrif y dymunant ei gadw.",
            "patient_A_active_used_by_patient_to_login": "Mae Claf A yn weithredol ac wedi'i ddefnyddio gan y claf i fewngofnodi.",
            "patient_B_active_used_by_patient_to_login": "Mae Claf B yn weithredol ac wedi'i ddefnyddio gan y claf i fewngofnodi.",
            "both_patient_accounts_email_set_neither_logged_in": "Mae'r ddau gyfrif Claf yn cynnwys cyfeiriad e-bost, er nad yw'r un o'r cyfrifau wedi'i ddefnyddio i fewngofnodi eto.",
            "patient_A_email_set_not_logged_in": "Mae gan Glaf A gyfeiriad e-bost wedi'i osod, felly mae'n bosibl i'r claf fewngofnodi i'r cyfrif hwnnw, er nad yw wedi gwneud hynny eto.",
            "patient_B_email_set_not_logged_in": "Mae gan Glaf B gyfeiriad e-bost wedi'i osod, felly mae'n bosibl i'r claf fewngofnodi i'r cyfrif hwnnw, er nad yw wedi gwneud hynny eto.",
            "neither_account_has_email": "Nid oes gan unrhyw gyfrif gyfeiriad e-bost, ac felly nid yw'r claf wedi defnyddio'r cyfrif i fewngofnodi.",
            "patient_A_has_NHS_CHI_number": "Mae gan Glaf A rif GIG/CHI yn bresennol.",
            "patient_B_has_NHS_CHI_number": "Mae gan Glaf B rif GIG/CHI yn bresennol.",
            "verification_statuses_of_patients_different": "Mae statws dilysu Claf A a Chlaf B yn wahanol.",
            "both_patients_have_requests_all_will_assign_to_chosen_patient": "Mae gan y ddau glaf gaision blaenorol. Bydd yr holl geisiadau'n cael eu neilltuo i'r claf a ddewisir, os dewiswch gyfuno.",
            "patient_A_has_requests": "Mae gan Glaf A geisiadau blaenorol.",
            "patient_B_has_requests": "Mae gan Glaf B geisiadau blaenorol.",
            "both_patients_have_carers_all_will_be_assigned_to_chosen_patient": "Mae gan y ddau glaf ofalwyr wedi'u rhestru ar eu cyfer. Bydd yr holl ofalwyr yn cael eu neilltuo i'r claf a ddewisir.",
            "patient_A_has_carers_those_will_be_copied_to_chosen_patient": "Mae gan Glaf A ofalwyr wedi'u rhestru ar eu cyfer. Bydd y rhain yn cael eu copïo i'r claf a ddewisir, os dewiswch gyfuno.",
            "patient_B_has_carers_those_will_be_copied_to_chosen_patient": "Mae gan Glaf B ofalwyr wedi'u rhestru ar eu cyfer. Bydd y rhain yn cael eu copïo i'r claf a ddewisir, os dewiswch gyfuno.",
            "differences_in_the_details_for_the_patient_records_are": "Mae gwahaniaethau yn y manylion ar gyfer cofnodion y claf wedi'u",
            "highlighted": "amlygu",
            "in_the_above_table": "yn y tabl uchod.",
            "keeping_patient_A": "Cadw Claf A",
            "if_details_for_patient_A_correct_you_should_keep_Patient_A_merge_all_from_B_to_A_delete_B": "Os yw manylion y defnyddiwr ar gyfer Claf A yn gywir, dylech gadw Claf A. Bydd hyn yn cyfuno'r holl geisiadau presennol, procsïon, ac ofalwyr o Glaf B i Glaf A. Bydd hyn hefyd yn dileu Claf B wedyn.",
            "keep_patient_A": "Cadw Claf A",
            "keeping_patient_B": "Cadw Claf B",
            "if_details_for_patient_B_correct_you_should_keep_Patient_A_merge_all_from_A_to_B_delete_A": "Os yw manylion y defnyddiwr ar gyfer Claf B yn gywir, dylech gadw Claf B. Bydd hyn yn cyfuno'r holl geisiadau presennol, procsïon, ac ofalwyr o Glaf A i Glaf B. Bydd hyn hefyd yn dileu Claf A wedyn.",
            "keep_patient_B": "Cadw Claf B",
            "merge_patients": "Cyfuno Clafyddion",
            "merge_patients_confirmation_text": "Rydych ar fin cyfuno'r ddau gofnod Claf hyn. A ydych yn sicr eich bod am barhau?",
            "patient_records_have_been_merged": "Mae'r gofnodion Claf wedi'u cyfuno.",
            "edit_merged_patient_record": "Golygu gofnod claf wedi'i gyfuno",
            "provider_assignment_status": "Statws",
            "message_to_patient": "Neges at y claf",
            "invite_title": "teitl gwahoddiad",
            "invite_message": "neges gwahoddiad",
            "invite_call_to_action": "galwad i weithredu gwahoddiad",
            "reminder_title": "teitl atgoffa",
            "reminder_message": "neges atgoffa",
            "reminder_call_to_action": "galwad i weithredu atgoffa",
            "internal_note": "Nodyn Mewnol",
            "attach_document": "Atodi dogfen",
            "video_call": "Galw Fideo",
            "edit_codes": "Golygu codau",
            "forms": "Ffurflenni",
            "form": "Ffurflen",
            "url": "URL",
            "form_search": "Chwilio am Ffurflen",
            "properties": "Priodweddau",
            "form_submitted_successfully": "Ffurflen wedi'i gyflwyno'n llwyddiannus",
            "form_progress_saved": "Cynnydd y ffurflen wedi'i gadw",
            "couldnt_load_form": "Methwyd â llwytho'r ffurflen",
            "fill_in_form": "Llenwch y ffurflen",
            "view_form": "Gweld y ffurflen",
            "fill_form_blurb": "Er mwyn ein helpu i ymateb i'ch cais, a fyddech gystal â chwblhau'r ffurflen sydd wedi'i hatodi?",
            "await_reply": "Aros am ateb",
            "end_wait": "Cychwyn aros",
            "start_QA": "Dechrau Aro",
            "skip_QA": "Heb Aro",
            "assign_to": "Neilltuo i",
            "unassigned": "Heb ei neilltuo",
            "unassign": "datgloi",
            "loading_image": "Llwytho delwedd ...",
            "downloaded": "Wedi ei lawrlwytho",
            "remove_image": "Tynnu delwedd",
            "remove_image_confirmation": "Ydych chi'n sicr eich bod am dynnu'r ddelwedd hon?",
            "remove_document": "Tynnu dogfen",
            "remove_document_confirmation": "Ydych chi'n sicr eich bod am dynnu'r ddogfen hon?",
            "preparing_download": "Paratoi llwytho ...",
            "await_reply_from_patient": "Aros am ateb gan y claf",
            "set_waiting": "Gosod aros",
            "inform_patient_that_request_is_waiting": "Hysbysu'r claf bod y cais wedi'i osod i aros",
            "if_no_reply_return_to": "Os na fydd ateb, dychwelyd i",
            "current_assignee": "Asgnwr Presennol",
            "send_on_date": "Anfon ar ddyddiad",
            "await_reply_for": "Aros am ateb am",
            "if_no_reply_move_to": "Os na fydd ateb, symud i",
            "send_video_request_to": "Rydych ar fin anfon cais fideo at",
            "send_video_request": "Anfon Cais Fideo",
            "video_not_enabled": "Nid yw'r fideo ar gael ar hyn o bryd, mae'n bosibl fod hynny oherwydd bod y porwr yn IE11 neu'n h_n.",
            "waiting_for_video_to_initialise": "Yn aros i'r fideo gychwyn",
            "waiting_for_patient_to_init_video": "Nid yw'r claf wedi ymuno â'r alwad eto. Gallwch weithio ar achosion eraill a byddwn yn rhoi gwybod i chi pan fydd y claf yn cyrraedd.",
            "request_details": "Manylion y Cais",
            "patient_details": "Manylion y Claf",
            "button_override_lock": "Gwrideiddio Clo",
            "staff_name": "Enw'r Staff",
            "patient_name": "Enw'r Claf",
            "patient_phone": "Ffôn y Claf",
            "alternative_phone": "Ffôn Amgen",
            "previous_requests": "Ceisiadau Blaenorol",
            "load_previous_requests": "Llwytho ceisiadau blaenorol",
            "request_locked_by": "Mae'r ceisiad wedi'i gloi gan",
            "characters_remaining": "nifer o gymeriadau sydd ar ôl",
            "no_preset_messages_available": "Dim negeseuon rhagffurfwedig ar gael",
            "no_forms_available": "Dim ffurflenni ar gael",
            "user_role": "Rôl Defnyddiwr",
            "usual_GP": "Ymddiriedolwr Arferol",
            "away": "ym ddiffaeth",
            "preferred_site": "Safle Dymunol",
            "preferred_site*": "Safle Dymunol *",
            "telephone_number": "Rhif Ffôn",
            "phone_number": "Rhif Ffôn",
            "alternative_telephone": "Teledu Ffôn Amgen",
            "alternative_phone_number": "Rhif Ffôn Amgen",
            "invalid_nhs_number": "Rhif NHS/CHI Annilys",
            "mrs_no_nhs_number": "Nid oes rhif NHS/CHI wedi'i osod ar y claf felly nid yw'n bosibl copïo'n uniongyrchol i'ch system cofnodion meddygol. Gallwch olygu manylion y claf, gan ddefnyddio'r chwiliad Spine, ac yna dychwelyd a rhoi cynnig arall arni. Fel arall, bydd y botwm \"Copïo\" isod yn copïo i'ch Clipfwrdd chi i'w roi yn eich system cofnodion yn llawerol",
            "mrs_no_nhs_number_originator": "Nid oes rhif NHS/CHI wedi'i osod ar y claf felly nid yw'n bosibl copïo'n uniongyrchol i unrhyw systemau cofnodion meddygol. Dim ond y darparwr gwreiddiol sy'n gallu cywiro manylion y claf",
            "mrs_copied_successfully_id": "Copïwyd y cais i'r system gofnodi gyda'r ID {id}",
            "mrs_already_copied_successfully_id": "Copïwyd y cais i'r system gofnodi eisoes gyda'r ID {id}",
            "mrs_copy_initiated": "Cychwyn proses copïo i'r system gofnodi",
            "mrs_copy_pending": "Cychwyn proses copïo i'r system gofnodi. Ar ddiolchgarwch ...",
            "mrs_copy_pending_id": "Cychwyn proses copïo i'r system gofnodi gyda'r ID {id}. Ar ddiolchgarwch ...",
            "mrs_copy_pending_already": "Mae copi i'ch system gofnodi eisoes ar y gweill. Dylech adael i'r broses gopi gwblhau cyn ceisio copïo arall.",
            "mrs_copy_pending_already_id": "Mae copi i'ch system gofnodi eisoes ar y gweill gyda'r ID {id}. Dylech adael i'r broses gopi gwblhau cyn ceisio copïo arall.",
            "mrs_failed": "Methodd copïo i'r system cofnodion meddygol. Gallech dal gopi'r cais drwy eich Clipfwrdd yn lle hynny.",
            "mrs_failed_id": "Methodd copïo i'r system cofnodion meddygol gyda'r ID {id}. Gallech dal gopi'r cais drwy eich Clipfwrdd yn lle hynny.",
            "mrs_failed_previous": "Methodd copïo i'ch system cofnodion meddygol eisoes. Os yw'r problem wedi'i datrys, gallwch gychwyn copi newydd i'ch system cofnodion meddygol, neu gallwch gopïo'r cais drwy eich Clipfwrdd yn lle hynny.",
            "mrs_failed_previous_id": "Methodd copïo i'ch system cofnodion meddygol eisoes gyda'r ID {id}. Os yw'r problem wedi'i datrys, gallwch gychwyn copi newydd i'ch system cofnodion meddygol, neu gallwch gopïo'r cais drwy eich Clipfwrdd yn lle hynny.",
            "mrs_failed_reason": "Y rheswm a adroddwyd yw:",
            "mrs_timed_out": "Mae'r broses o gopïo i'r system gofnodi wedi gorffen yn hwyr.",
            "mrs_existing_pending": "Mae copi i'r system gofnodi eisoes ar y gweill.",
            "mrs_clear_status": "Clirio statws ffeilio",
            "failed_filings": "Materion Ffeilio",
            "request_copied_to_clipboard": "Copïwyd y cais i'r Clipfwrdd",
            "record_system_integration_type": "Math o Gysylltiad i System Cofnodion Meddygol",
            "weekly_rota": "Rota Wythnosol",
            "potential_duplicate_records": "Cofnodion Posibl Duplicated",
            "created_by": "Creu gan",
            "service_message": "Neges Gwasanaeth",
            "service_message_start_at": "Amser Dechrau'r Neges Gwasanaeth",
            "service_message_end_at": "Amser Gorffen'r Neges Gwasanaeth",
            "overall_rating": "Sgôr Cyffredinol",
            "created_at": "Creu Ar",
            "view_request": "Gweld y Cais",
            "title_password_guidance": "Canllawiau Cyfrinair Cadarn",
            "password_guidance1": "Rhaid i gyfrineiriau fod o leiaf 8 nod, ac ni allant fod yn bethau fel \"cyfrinair\", \"12345678\" neu \"abcdefgh\".",
            "password_guidance2": "Y peth pwysicaf yw peidio â defnyddio cyfrineiriau byrion (rydym yn awgrymu mwy na 8 nod). Mae lle i spaces, felly gallwch ddefnyddio frawddeg hir o dri neu bedwar gair hirion. Bydd cyfrinair byrrach gyda chyfuniad o fathau o gymeriadau hefyd yn gweithio oni bai ei fod yn batrwm cyffredin iawn.",
            "subtitle_user_details": "Manylion Defnyddiwr",
            "shown_to_patients": "a ddangosir i gleifion",
            "note_multi_provider_not_yet_editable": "Mae hon yn gyfrif staff aml-ddarparwr. Nid yw golygu rolau staff, nac dileu'r cyfrif, ar gael i weinyddwyr rhwydwaith (eto).",
            "availability_help_text": "I fod i aelod staff fod ar gael i'w ddewis yn rhyngwyneb y claf, rhaid iddynt fod ar gael dros y 14 awr nesaf, ac mae ganddynt unrhyw argaeledd yn y safle a ddewiswyd gan y claf. Y rheswm am hyn yw y gall yr aelod staff drafod mater gydag y claf ar-lein heddiw, gan eu bod ar gael (yn rhywle), ac os bydd yn angenrheidiol gweld y claf yn bersonol, gallant wneud apwyntiad pan fyddant nesaf yng nghefnogaeth y safle a ddewiswyd gan y claf.",
            "alert_info_weekly_rota_part1": "Bydd unrhyw amseroedd a nodir yma yn gwrthdaro â'r rhai a nodir yn y Rota Wythnosol uchod. Er enghraifft, os ydych am osod rhywun i fod ar gael dim ond yn y bore, gallwch ychwanegu'r dydd penodol hwnnw isod a nodi'r argaeledd fel",
            "alert_info_weekly_rota_part2": "Mae eithriadau yn gwrthdaro â'r diwrnod cyfan, ond maent yn ymgorffori'n gyfunol, felly os byddai aelod o staff yn mynd i fod ar gael rhwng 11{00} - 14{00}, byddech yn nodi dau eithriad argaeledd isod, un ar gyfer",
            "alert_info_weekly_rota_part3": "a'r llall ar gyfer",
            "alert_info_weekly_rota_part4": "Os ydych am osod rhywun i fod i ffwrdd am y dydd cyfan, dim ond ychwanegwch y dyddiad (neu ystod o ddyddiadau) a gadewch yr amseroedd argaeledd yn wag.",
            "link_more_information": "Mwy o wybodaeth",
            "add_to_home_screen": "Ychwanegu i'r sgrin gartref",
            "group_can_have_requests_assigned": "Gall gan y gr_p gael ceisiadau wedi'u neilltuo",
            "members_can_have_requests_assigned": "Gall aelodau'n unig gael ceisiadau ac yn ymddangos ar y ddeinmynnau",
            "patients_can_choose_group_members": "Gall cleifion ddewis aelodau'r gr_p",
            "can_complete_on_behalf_of_another": "Gall cwblhau ar ran un arall",
            "members": "Aelodau",
            "description": "Disgrifiad",
            "event_triggered_by": "Digwyddiad a Gamsgorwyd Gan",
            "PATIENT": "CLAF",
            "STAFF": "STAFF",
            "no_properties_specified": "Dim priodolebau wedi'u nodi",
            "patient": "Claf",
            "account_status": "Statws y Cyfrif",
            "patient_never_logged_in": "Nid yw'r Claf wedi mewngofnodi erioed",
            "alert_scope_global": "Mae sgôp y neges hon yn fyd-eang. Dim ond gweinyddwyr rhwydwaith askmyGP all ei olygu.",
            "alert_scope_organisational": "Mae sgôp y neges hon yn seiliedig ar sefydliad. Dim ond gweinyddwr all ei olygu.",
            "owner": "perchennog",
            "ownership": "perchnogaeth",
            "set_owner": "gosod perchennog",
            "transfer": "trosglwyddo",
            "organisational": "Sefydliadol",
            "personal": "Personol",
            "welcome_to": "Croeso i",
            "welcome_to_askmyGP": "Croeso i askmyGP",
            "patient_intro": "Cael help gan eich practis. Gofynnwch unrhyw bryd, byddwn ni'n ymateb yn oriau gwaith.",
            "you_may_add_more_detail_later": "Gallwch ychwanegu mwy o fanylion yn nes ymlaen",
            "is_currently_unavailable_for_online_requests": "ar gael ar hyn o bryd ar gyfer ceisiadau ar-lein",
            "is_currently_available_for_some_requests": "ar gael ar hyn o bryd. Gallwch dal gael mynediad at rai gwasanaethau. Byddwn ni'n adolygu ceisiadau pan fyddwn ni'n dod ar-lein nesaf.",
            "network_is_currently_unavailable_for_online_requests": "Yn anffodus, oherwydd problem dechnegol gyda AskMyGP, ni allwn dderbyn ceisiadau ar-lein newydd ar hyn o bryd. Rydym yn gobeithio y bydd y system yn gweithio eto'n fuan, er mwyn osgoi unrhyw oedi, ffoniwch y feddygfa a siaradwch â'r dderbynfa er mwyn i ni ymateb i'ch anghenion.",
            "get_self_help": "Cael help hunan",
            "quick_self_help": "NHS cael help",
            "consult_your_GP": "Ymgynghori â clinigydd",
            "login_to_consult_your_GP": "Cofrestrwch neu fewngofnodi i ymgynghori â clinigydd",
            "do_not_use_in_emergencies": "Peidiwch â'i ddefnyddio mewn argyfwng - Cyngor y GIG yma",
            "the_end_user_licence_agreement": "Cytundeb trwydded defnyddwyr terfynol",
            "end_user_licence_agreement": "Cytundeb trwydded defnyddwyr terfynol",
            "privacy_policy": "Polisi Preifatrwydd",
            "characters_left": "cymeriadau ar ôl",
            "terms_of_use": "Telerau Defnydd",
            "hello": "Helo",
            "you_have_new_messages_in": "Mae gennych negeseuon newydd yn",
            "thread": "linc",
            "are_these_details_correct_if_not_contact_your_practice": "Yw'r manylion hyn yn gywir? Os na fyddwch yn cysylltu â'ch Practis Meddyg Teulu",
            "remember_to_click_save_below": "Cofiwch glicio Cadarnhau isod",
            "your_user_details_were_updated_successfully": "Diweddarwyd eich manylion defnyddiwr yn llwyddiannus.",
            "new_request": "Cais Newydd",
            "view_past_requests": "Gweld ceisiadau blaenorol",
            "edit_my_details": "Golygu fy manylion",
            "patients_i_care_for": "Cleifion yr wyf yn gofalu amdanynt",
            "people_i_care_for": "Pobl yr wyf yn gofalu amdanynt",
            "our_service_times": "Ein horiau gwasanaeth",
            "when_is_your_GP_working": "Pryd mae eich clinigydd ar gael?",
            "offline": "Heb gysylltu",
            "i_am_asking_as_a": "Rwy'n gofyn fel",
            "parent_or_carer": "Rhiant neu Ofalwr",
            "do_you_have_an_askmyGP_login": "A oes gennych fewnforio i {article_app_name}",
            "sign_up_as_a_new_user": "Cofrestrwch fel defnyddiwr newydd",
            "login_existing_user": "Mewngofnodi i ddefnyddiwr presennol",
            "logged_out_successfully": "Wedi allgofnodi yn llwyddiannus",
            "logged_out_automatically_message": "Rydych wedi cael eich allgofnodi'n awtomatig o system askmyGP oherwydd anweithrediad",
            "logged_out_manually_message": "Rydych wedi allgofnodi o system askmyGP yn llwyddiannus",
            "logged_out_not_logged_in": "I ddefnyddio'r system askmyGP bydd angen i chi fewngofnodi i'ch cyfrif",
            "log_back_in": "Mewngofnodi eto",
            "404_not_found": "404 Hebddi'r Canfod",
            "page_not_found": "Heb ddod o hyd i'r dudalen",
            "not_found": "Heb ei ddod o hyd",
            "sorry_item_requested_not_found_in_system": "Ymddiheuriwch, ni allwn ddod o hyd i'r dudalen rydych yn chwilio amdani",
            "return_to_site_index": "Dychwelwch i'r dudalen gartref",
            "im_sorry_we_cant_find_the_page_you_are_looking_for": "Mae'n ddrwg gennym, nid ydym yn gallu dod o hyd i'r dudalen rydych yn chwilio amdani",
            "create_your_password": "Creu eich cyfrinair",
            "secure_your_account": "Diogelu eich cyfrif drwy greu cyfrinair",
            "reset_your_password": "Ailosodwch eich cyfrinair",
            "strong_password_guidance": "Canllawiau Cyfrinair Cryf",
            "password_reset_email_sent": "Cyflwynwyd e-bost ailosod cyfrinair",
            "password_reset_successfully": "Ailosodwyd y cyfrinair yn llwyddiannus",
            "attach_photo_or_document": "Atodi llun neu ddogfen?",
            "attach_another_photo_or_document": "Atodi llun neu ddogfen arall?",
            "message_updated": "Neges wedi'i diweddaru",
            "new_message": "Neges newydd",
            "message_deleted": "Neges wedi'i dileu",
            "sign_up_to": "Cofrestru i",
            "you_can_do_it_here_and_now_your_email_address_may_be_used_only_once": "Gallwch ei wneud yma ac yn awr. Gall eich cyfeiriad e-bost gael ei ddefnyddio dim ond unwaith.",
            "unable_to_register_message": "Yn anffodus, nid ydych yn gallu cofrestru gyda askmyGP gan nad ydym yn gwybod pa ymarfer rydych am gofrestru gyda. Sicrhewch eich bod yn dilyn y ddolen a ddarperir ar wefan eich ymarfer.",
            "please_accept": "Derbynwch os gwelwch yn dda",
            "my_details": "Fy manylion",
            "privacy_message_overview": "Mae askmyGP yn prosesu eich data personol a gofal iechyd ar ran eich meddyg teulu sy'n rheolwr y data. Defnyddir data anhysbys i bwrpasau ymchwil a datblygu. Nid ydym yn defnyddio gwybodaeth bersonol at ddibenion marchnata.",
            "isabel_checks_symptoms_for_possible_conditions": "Mae Isabel yn gwirio symptomau ar gyfer cyflyrau posibl",
            "powered_by_isabel_healthcare": "Pwerwyd gan Isabel Healthcare",
            "input_placeholder_self_help": "Nodwch deitl eich broblem (mwyaf 50 nod)",
            "placeholder_enter_problem_self_help": "Nodwch broblem ar gyfer hunan-help",
            "no_search_results_found": "Ni chanfuwyd canlyniadau chwilio",
            "we_try_to_respond_soon_during_these_hours": "Rydym yn ceisio ymateb yn fuan yn ystod ystodau hyn",
            "it_helps_us_if_you_send_your_request_on_the_same_day": "Mae'n ein helpu os byddwch yn anfon eich cais ar yr un diwrnod",
            "provider_details": "Manylion y Darparwr",
            "provider_name": "Enw'r Darparwr",
            "practice_code": "Cod Ymarfer",
            "site_name": "Enw'r Safle",
            "superuser_gender": "Rhyw'r Uwchddefnyddiwr",
            "superuser_forenames": "Enwau Cyntaf'r Uwchddefnyddiwr",
            "superuser_surname": "Cyfenw'r Uwchddefnyddiwr",
            "superuser_email": "Ebost yr Uwchddefnyddiwr",
            "robot_name": "Enw'r robot",
            "robot_forenames": "Enwau cyntaf y robot",
            "robot_surname": "Cyfenw'r robot",
            "robot_email": "E-bost y robot",
            "leave_blank_to_auto_populate_with": "Gadael gwag i'w lenwi'n awtomatig gyda",
            "click_to_view": "Cliciwch i weld",
            "copied_to_clipboard": "copïwyd i'r clipfwrdd",
            "disable_notifications": "Analluogi Hysbysiadau",
            "enable_notifications": "Galluogi Hysbysiadau",
            "DD/MM/YYYY": "DD/MM/BBBB",
            "DD/MM/YYYY-HH-MM": "DD/MM/BBBB HH{MM}",
            "video_request_from": "Gofyniad fideo gan",
            "video_request": "Cais fideo",
            "delete_message": "Dileu Neges",
            "message_will_be_deleted_continue": "Bydd cynnwys y neges hon yn cael ei ddileu. Ydych chi'n si_r eich bod am barhau?",
            "message_content_deleted": "Cynnwys y neges wedi'i ddileu",
            "thread_reopened": "Ailagor y ffrwd",
            "delete_request": "Dileu'r Cais",
            "you_are_about_to_delete_request": "Rydych ar fin dileu'r cais",
            "for": "ar gyfer",
            "are_you_sure_you_want_to_continue": "Ydych chi'n si_r eich bod am barhau?",
            "finish": "Gorffen",
            "awaiting_reply_then_closed_until": "Mae'r practis yn disgwyl am eich ateb. Os ydych am ateb, gwnewch hynny cyn {waiting_until}, ar ôl hynny bydd y cwrs yn cau.",
            "awaiting_reply_then_reassigned_until": "Mae'r practis yn disgwyl am eich ateb. Os ydych am ateb, gwnewch hynny cyn {waiting_until}, ar ôl hynny bydd y cwrs yn cael ei drosglwyddo i {clinician}.",
            "awaiting_reply_then_unassigned_until": "Mae'r practis yn disgwyl am eich ateb. Os ydych am ateb, gwnewch hynny cyn {waiting_until}, ar ôl hynny bydd y cwrs yn cael ei adolygu eto gan aelod o'n tîm.",
            "completed_message_intro": "Diolch am ddefnyddio gwasanaeth askmyGP.",
            "completed_message_manual": "Rydym wedi cwblhau eich cais yn awr.",
            "completed_message_auto": "Gan nad ydym wedi derbyn ateb gennych, rydym nawr wedi cau eich cais.",
            "completed_message_auto_custom_action": "Mae eich cais wedi'i gwblhau'n awtomatig, ac nid oes angen unrhyw gamau pellach.",
            "completed_message_feedback": "Rydych yn groesawu i adael sylw ar ein ffurflen adborth.",
            "ended_the_wait_state_for_this_request": "Mae {user} wedi dod i ben y cyfnod aros ar gyfer y cais hwn.",
            "set_thread_waiting": "Gosod y deunydd ar aros",
            "wait_ended": "Aros wedi dod i ben",
            "send_message": "Anfon Neges",
            "request_will_go_to_patient_confirmation": "Bydd y negeseuon hyn yn mynd at y claf. Cadarnhewch eich bod am eu hanfon?",
            "okay": "Iawn",
            "request_updated": "Cais wedi'i ddiweddaru",
            "basic_search": "Chwiliad Sylfaenol",
            "oldest_on_top": "Henaf yn uwch",
            "newest_on_top": "Nesaf yn uwch",
            "Male": "Gwryw",
            "Female": "Benyw",
            "Unspecified": "Heb ei nodi",
            "monday": "dydd Llun",
            "tuesday": "dydd Mawrth",
            "wednesday": "dydd Mercher",
            "thursday": "dydd Iau",
            "friday": "dydd Gwener",
            "saturday": "dydd Sadwrn",
            "sunday": "dydd Sul",
            "Claimed": "Wedi'i hawlio",
            "Identified": "Wedi'i adnabod",
            "Verified": "Wedi'i wirio",
            "Mr": "Mr",
            "Ms": "Ms",
            "Mrs": "Mrs",
            "Miss": "Miss",
            "Dr": "Dr",
            "Mx": "Mx",
            "skip": "Neidio",
            "check": "Gwirio",
            "deleted": "wedi'i ddileu",
            "undefined": "heb ei ddiffinio",
            "Parent/Guardian": "Rhiant/Gwarcheidwad",
            "Carer": "Gofalwr/Ffrind/Perthynas",
            "select": "dewis",
            "select_clinician": "Dewis clinigwr",
            "edit_session_data": "Golygu data sesiwn",
            "edit_availability": "Golygu argaeledd",
            "select_clinician_view_calendar": "Dewiswch glinigydd i weld eu calendr",
            "selected_clinician_has_no_sessions": "Nid oes gan y clinigwr detholiad o sesiynau apwyntiadau",
            "cancel_appointment": "Canslo Archebu",
            "appointment_booking": "Archebu Apwyntiad",
            "enable_appointment_bookings": "Galluogi archebion apwyntiadau",
            "book_appointment": "Archebu Apwyntiad",
            "restricted_patient_search": "Clafydd",
            "network_availabile_for_new_requests": "System ar gael ar gyfer ceisiadau newydd",
            "network_up": "System ar gael i ddarparwyr a chleifion",
            "network_softdown_message": "Yn anffodus, mae askmyGP ar gau ar hyn o bryd. Rhowch gynnig arni yn nes ymlaen.",
            "network_unavailable_for_new_requests_message": "Yn anffodus, mae askmyGP ar gau ar gyfer ceisiadau newydd ar hyn o bryd. Rhowch gynnig arni yn nes ymlaen.",
            "network_settings": "Gosodiadau Rhwydwaith",
            "capacity_planning": "cynllunio capasiti",
            "demand_per_week": "gofyniad yr wythnos",
            "typical": "tybygol",
            "actual": "gwirioneddol",
            "clinical": "clyweddol",
            "other": "eraill",
            "total": "cyfanswm",
            "capacity_per_session": "capasiti fesul sesiwn",
            "sessions": "sesiynau",
            "save_to_dashboard": "cadw i'r ddeunyddlen",
            "demand_per_day_as_percent_of_week": "Gofyniad fesul dydd fel % o'r wythnos",
            "search_cant_select": "Ni allwch ddewis yr eitem hon",
            "search_item_already_exists": "Mae'r eitem eisoes yn bodoli",
            "search_cant_select_provider_xref": "Ni allwch ddewis yr un darparwr yr ydych yn ychwanegu'r ddolen ar gyfer.",
            "search_item_already_exists_provider_xref": "Mae dolen ar gyfer y darparwr hwn eisoes yn bodoli.",
            "cant_share_non_verified_user_request": "Dim ond i gleifion sydd â statws ID 'Wedi'i wirio' ac sydd â rhif NHS/CHI wedi'u gosod y gallwch rannu/trosi ceisiadau ar eu cyfer.",
            "continue_search_in_archive": "Dangos ceisiadau cynharach",
            "closed_at_range": "Wedi'u cwblhau rhwng dyddiadau",
            "show_available_all_option": "Dangos Yn Galwedigaethol / Y Cyfan",
            "show_all_waiting": "Dangos pob un",
            "show_all": "Dangos pob un",
            "show_pending": "Dangos ar ddiweddariad",
            "sms_sent": "Mae neges SMS wedi'i hanfon at y defnyddiwr ar {phone}",
            "sms_smtp_gateway_domain": "Parth SMTP negesau SMS",
            "id": "ID",
            "email_verification_text": "Cod pedwar digid wedi'i anfon at y cyfeiriad e-bost a ddarparwyd gennych",
            "password_verification_text": "I awdurdodi'r newid hwn, mae'n rhaid i chi wirio eich cyfrinair",
            "password_verification_for_email": "Wrth newid eich cyfeiriad e-bost, mae'n rhaid i chi hefyd wirio eich cyfrinair presennol",
            "verify": "Gwirio",
            "tags": "tagiau",
            "tag": "tag",
            "tag_entries": "Cofnodau Tag",
            "tag_uses": "Defnyddiau Tag",
            "icon": "Eicon",
            "position": "Safle",
            "custom_actions": "gweithredoedd cyflym",
            "custom_action": "gweithred benodol",
            "cohorts": "cohorteau",
            "cohort": "cohort",
            "campaigns": "ymgyrchoedd",
            "campaign": "ymgyrch",
            "campaign_not_found": "Yn anffodus, nid yw'r ymgyrch rydych wedi'i ddewis yn bodoli bellach.",
            "start_campaign": "dechrau ymgyrch",
            "reset_campaign": "ailosod ymgyrch",
            "stop_campaign": "atal ymgyrch",
            "campaign_started": "Mae {name} wedi'i ddechrau a bydd yn dechrau prosesu yn y rhediad prosesu nesaf (fel arfer o fewn munud)",
            "campaign_stopped": "Mae {name} wedi gorffen",
            "campaign_reset": "Mae data ar gyfer {name} wedi cael ei ailosod",
            "campaign_reminder_at": "Mae atgoffa ar gyfer {name} wedi'i chychwyn",
            "start_at": "dechrau am",
            "end_at": "diweddu am",
            "total_users": "nifer cyfansawdd",
            "invite_sent": "gwahoddiad wedi'i anfon",
            "reminder_sent": "atgoffa wedi'i anfon",
            "send_reminder": "anfon atgoffa",
            "automatically_assign": "wedi'i neilltuo'n awtomatig i",
            "AUTOMATED_FORM_SUBMISSION": "Ffurflen {form_title} wedi'i gyflwyno'n llwyddiannus gan {name}",
            "AUTOMATED_FORM_SAVE": "Ffurflen {form_title} wedi'i gadw (yn y broses) gan {name}",
            "record_system_test_user_id": "ID Defnyddiwr System Cofnodion Meddygol",
            "mrs_user_id": "ID Defnyddiwr System Cofnodion Meddygol",
            "oauth_authorisation": "Galluogi Mynediad i'r Cyfrif",
            "authorise": "awdurdodi",
            "oauth_requesting_permission": "<strong>{client_name}</strong> yn gofyn am ganiatâd i gael mynediad at eich cyfrif.",
            "oauth_application_abilities": "Bydd y cais hwn yn gallu",
            "oauth_token_can_profile": "Gweld gwybodaeth am eich proffil",
            "terms_conditions": "Telerau ac Amodau",
            "terms_message": "I barhau i ddefnyddio gwasanaeth askmyGP, rhaid i chi dderbyn y cytundebau trwyddedu canlynol.",
            "codes": "Codau",
            "consultation": "Ymgynghoriad",
            "add_code": "Ychwanegu cod",
            "no_codes": "Dim codau wedi'u nodi",
            "code_header": "Pennyn",
            "code_scheme": "Cynllun",
            "code_code": "Cod",
            "code_description_id": "Disgrifiad ID",
            "description_id": "Disgrifiad ID",
            "code_term": "Tymor",
            "code_units": "Unedau",
            "code_value": "Gwerth",
            "code": "Cod",
            "blood_pressure": "Pwysedd Gwaed",
            "blood_pressure_ranges": "Amrediadau Pwysedd Gwaed",
            "blood_pressure_ranges_help": "Pan fydd pwysedd gwaed yn cael ei fewnforio yn y rhyngwyneb codio, neu drwy feiswn maes ffurflen, bydd y gwerthoedd yn cael eu cymharu â'r amrediadau hyn ac yn cael eu blaenoriaethu'n awtomatig fel y nodir.",
            "blood_pressure_ranges_and_or": "I fewnforio amrediad a fydd yn cyfateb i ddiafolig neu systolaidd, osodwch y berthynas i <em>NEU</em>. I fewnforio amrediad a fydd yn cyfateb i ddiafolig a systolaidd gyda'i gilydd, osodwch y berthynas i <em>A</em>.",
            "add_blood_pressure": "Ychwanegu pwysedd gwaed",
            "add_blood_pressure_range": "Ychwanegu amrediad pwysedd gwaed",
            "no_blood_pressures": "Dim pwysedd gwaed wedi'u nodi",
            "no_blood_pressure_ranges": "Dim amrediad pwysedd gwaed wedi'u nodi",
            "systolic": "Systolaidd",
            "diastolic": "Diafolig",
            "min": "lleiaf",
            "max": "mwyaf",
            "term": "Tymor",
            "unit": "Uned",
            "value": "Gwerth",
            "code_descriptive_text": "Testun disgrifiadol",
            "attachments": "Atodiadau",
            "session_saved_for_later": "Mae eich cynnydd cyflwyno presennol wedi'i gadw'n ddiogel yn eich porwr, felly os byddwch yn defnyddio'r un porwr pan fydd eich practis yn ailagor ar gyfer cyflwyno ceisiadau, byddwch yn cael eich annog i adfer eich cais wedi'i gadw a pharhau â'ch cyflwyniad.",
            "recover_in_progress_qa_title": "Parhau â chais ddrafft",
            "recover_in_progress_qa_text": "Mae gennych gyflwyniad cais ddrafft wedi'i gadw. Hoffech chi barhau â'r drafft?",
            "save_qa": "Cadw cynnydd",
            "dont_save_qa": "Peidiwch â chadw cynnydd",
            "continue_qa": "Parhau i olygu",
            "not_authorised_to_search_snomed": "Nid oes gennych awdurdod i chwilio codau SNOMED",
            "who_is_this_service_for": "I bwy y mae'r gwasanaeth hwn?",
            "custom_action_not_found": "Ni chafodd gweithrediad cyfystyried.",
            "allow_when_closed": "Caniatewch pan fydd ar gau",
            "content_requests_submit_someone_else_visible": "Mae cynnwys ceisiadau a gyflwynwch ar gyfer rhywun arall yn weladwy i'r person hwnnw.",
            "number_open_requests_for_patient": "Nifer y ceisiadau agored ar gyfer y claf hwn",
            "no_session_types_found": "Dim mathau sesiynau wedi'u canfod",
            "no_sessions_found": "Dim sesiynau wedi'u canfod",
            "no_availibility_exceptions_found": "Dim eithriadau argaeledd wedi'u canfod",
            "preview": "Rhagolwg",
            "colour": "Lliw",
            "use": "Defnydd",
            "search_min_3_characters": "Chwilio (3 o nodau ar y llai)",
            "problem": "Problem",
            "history": "Hanes",
            "examination": "Archwiliad",
            "family_history": "Hanes Teulu",
            "social": "Cymdeithasol",
            "procedure": "Gweithdrefn",
            "attachments_auto_copy_to_record_system": "Bydd y prydfeithiau hyn hefyd yn cael eu copïo'n awtomatig i'ch system gofnodi:",
            "notification_updated_successfully": "diweddaru'n llwyddiannus",
            "notification_created_successfully": "creuwyd yn llwyddiannus",
            "notification_deleted_successfully": "dileuwyd yn llwyddiannus",
            "you_are_about_to_remove_access_to_provider_account_for": "Rydych ar fin tynnu mynediad i'ch cyfrif darparwr askmyGP ar gyfer",
            "shared_transferred": "Rhannwyd/Ailadrodd",
            "demand_capacity_updated_success": "Diweddaru'r galw a'r capasiti yn llwyddiannus",
            "set_followup_for_request_at": "{user} gorchymyn yn",
            "assigned_request_to": "asignio gorchymyn i",
            "removed_follow_up_for_request": "{user} y dilyniant ar gyfer y cais hwn gan y defnyddiwr.",
            "set_request_to_wait_until": "{user} gosod y cais hwn i aros tan {waiting_until}",
            "custom_action_type": "Math gweithred gweithredol cyfaddas",
            "submission_message": "Neges gyflwyno (a gyrrir at y defnyddiwr pan gaiff y ffurflen ei chyflwyno a chreu'r cais newydd)",
            "automatically_share_requests_with": "Trosi'r cais newydd yn awtomatig i",
            "when_shared_completes_automatically_or_autocompletes_writeback_with_user": "Pan fo cais wedi'i drosglwyddo wedi'i gwblhau, neu pan fydd ceisiadau wedi'u cwblhau'n awtomatig, ysgrifennir yn awtomatig yn ôl gan ddefnyddio",
            "when_transferred_request_completes_automatically_writeback": "Pan fydd y cais wedi'i drosglwyddo wedi'i gwblhau, ysgrifennir yn ôl yn awtomatig",
            "do_not_automatically_writeback": "Peidiwch ag ysgrifennu yn ôl yn awtomatig",
            "user_selectable": "Gall defnyddiwr ddewis y gweithred (yn ymddangos fel botwm cyfaddas yn y cais cleifion)",
            "autocomplete_custom_action": "Cwblhau gweithred yn awtomatig pan gyflwynir y ffurflen",
            "autocomplete_custom_action_info": "Caiff cwblhau awtomatig ei oresgyn bob amser pan gaiff y cais ei flaenoriaethu uwch na 'Rheolaidd'. Gellir rhoi blaenoriaeth i geisiadau drwy ffurflenni naill ai'n benodol (AMGFLAG) neu'n ddiddorol drwy ddarlleniadau o Bwysau Gwaed (AMGBP)",
            "none": "Dim",
            "automatically_assign_requests_to": "Trosi ceisiadau'n awtomatig i",
            "do_not_automatically_assign": "Peidiwch ag atodi'n awtomatig",
            "do_not_automatically_transfer": "Peidiwch â throsi'n awtomatig",
            "automatically_tag_requests_as": "Atodi'n awtomatig tagiau i geisiadau fel",
            "search_for_a_tag": "Chwilio am farc",
            "no_results": "Dim Canlyniadau",
            "you_have": "Gennych",
            "view_messages": "Gweld negeseuon",
            "view_all_prev_requests": "Gweld yr holl geisiadau blaenorol",
            "nhs_covid": "Cyngor y GIG ar Coronafeirws (COVID-19)",
            "at": "yn",
            "third_party_apps_account_access": "Apiau trydydd parti gyda mynediad i gyfrif",
            "oauth_revoke_access": "Tynnu mynediad i gyfrif",
            "remove_access": "Dileu mynediad?",
            "remove_access_confirmation": "fydd gan {client} fynediad i'ch cyfrif askmyGP mwyach. Bydd angen i chi ganiatáu mynediad os ydych am ddefnyddio'r ap neu'r gwasanaeth hwn eto.",
            "include_internal_messages": "Cynnwys negeseuon mewnol",
            "include_internal_messages_when_copying": "Diofyn i gynnwys negeseuon mewnol yn y copi/ysgrifennu yn ôl?",
            "include_datetime_when_copying": "Cynnwys dyddiad/amser ar gyfer negeseuon yn y copi/ysgrifennu yn ôl?",
            "messages_thread": "Llinyn negeseuon",
            "introduction": "Cyflwyniad",
            "select_service": "Dewis gwasanaeth",
            "profile_details": "Manylion proffil",
            "register_proxy": "Cofrestru procsïwr",
            "select_caree": "Dewis gofalwr",
            "staff_availability": "Argaeledd staff",
            "oauth": "oauth",
            "terms": "telerau",
            "profile_edit": "Golygu Proffil",
            "user_import": "mewngludo defnyddwyr",
            "user_imports": "mewngludo defnyddwyr",
            "new_users": "defnyddwyr newydd",
            "existing_users": "defnyddwyr presennol",
            "bad_data_users": "defnyddwyr gyda data gwael",
            "in_other_provider_users": "defnyddwyr presennol mewn darparwyr eraill",
            "test_email_sent_to": "Anfonwyd e-bost prawf i {email}",
            "egl_app_paired": "Parwyd ap cleifion EGL",
            "user_csv_file": "Ffeil CSV Defnyddiwr",
            "uploaded_file": "Ffeil wedi'i Uwchlwytho",
            "download_csv": "Llwytho'r Ffeil CSV i Lawr",
            "open_menu": "Agor Dewislen",
            "close_menu": "Cau'r Dewislen",
            "priority": "Blaenoriaeth",
            "priority_20": "Brys",
            "priority_10": "Brys",
            "priority_5": "Cais Ymweld",
            "priority_0": "Rheolaidd",
            "priority_-10": "Is",
            "creating_new_message_title": "Creu llwybr neges newydd",
            "add_attachment_to_message": "Ychwanegu atodiad i neges",
            "relation_and": "A",
            "relation_or": "NEU",
            "email_verification_code": "Rhowch y cod isod os gwelwch yn dda.",
            "change_email_address": "Newid cyfeiriad e-bost",
            "verify_email_address": "Cadarnhau cyfeiriad e-bost",
            "up_to_date": "Rydych chi i gyd yn gyfredol.",
            "someone_else": "Rhywun arall"
        },
        "passwords": {
            "password": "Rhaid i gyfrineiriau fod o leiaf wyth nod.",
            "reset": "Mae eich cyfrinair wedi cael ei ailosod!",
            "sent": "Rydym wedi anfon eich dolen ailosod cyfrinair drwy e-bost!",
            "token": "Mae'r tocyn ailosod cyfrinair hwn wedi dod i ben. <a href=\"RESET_LINK\">Gwneud cais am tocyn newydd</a>",
            "user": "Ni allwn ddod o hyd i ddefnyddiwr gydag yr cyfeiriad e-bost hwnnw."
        },
        "auth": {
            "failed": "Nid yw'r e-bost neu'r cyfrinair yn cyfateb i'n cofnodion. Rhowch gynnig ar \"Wedi anghofio'r Cyfrinair\" isod.",
            "throttle": "Gormod o ymgais i fewngofnodi. Rhowch gynnig arni eto mewn {seconds} eiliad."
        },
        "emails": {
            "welcome_to_app_from": "Croeso i askmyGP gan",
            "please_login_now": "Mewngofnodwch nawr os gwelwch yn dda.",
            "account_created_choose_password_and_login": "Gwnewch yn si_r eich bod o fewn rhwydwaith GIG diogel i fewngofnodi a chreu eich cyfrinair.",
            "set_your_login": "Gosodwch eich mewngofnodi i askmyGP",
            "if_login_expired": "Os yw'r ddolen uchod wedi dod i ben, cliciwch i fewngofnodi yn",
            "if_login_created_may_request_new_link": "Os yw eich mewngofnodi wedi'i greu, gallwch gaisio am ddolen newydd o \"Wedi anghofio'r Cyfrinair\"",
            "kind_regards": "Cofion cynnes",
            "app_on_behalf_of": "askmyGP ar ran",
            "do_not_reply_responses_not_monitored": "Peidiwch ag ateb yr e-bost hwn, gan nad yw ymatebion yn cael eu monitro.",
            "always_use_secure_service_to_message": "Defnyddiwch y gwasanaeth diogel askmyGP bob amser i anfon negeseuon.",
            "create_your_new_app_password": "Creu eich cyfrinair newydd askmyGP",
            "patient_welcome_message": "Croeso i askmyGP. Rydych nawr wedi'i gymeradwyo ar gyfer mynediad cyflymach, haws at eich meddyg teulu hun.",
            "create_new_password": "Creu cyfrinair newydd",
            "with_login_you_can_request_help_welcome_message": "Gyda'ch mewngofnodi diogel gallwch gaisio am help gyda phroblem feddygol unrhyw fath. Gallwch ofyn drosoch chi eich hun neu rywun yr ydych yn gofalu amdano, cyn belled â bod y claf wedi'i gofrestru yn y practis. Mewn oriau gwaith byddwn yn ymateb yn gyflym, y tu allan i oriau gwaith byddwn yn ymateb ar y diwrnod gwaith nesaf.",
            "please_use_app_for_all_enquiries": "Defnyddiwch askmyGP ar gyfer yr holl ymholiadau yn y dyfodol a'n helpu i'n helpu chi.",
            "sent_you_a_message": "wedi anfon neges i chi ar askmyGP",
            "click_to_login_do_not_reply": "Cliciwch isod i fewngofnodi a gweld eich neges. Peidiwch ag ateb yr e-bost hwn, gan nad yw ymatebion yn cael eu monitro. Defnyddiwch y gwasanaeth diogel askmyGP bob amser i anfon negeseuon.",
            "do_not_reply_always_use_secure_askmygp_to_message": "Peidiwch ag ateb yr e-bost hwn gan nad yw ymatebion yn cael eu monitro. Defnyddiwch y gwasanaeth diogel askmyGP bob amser i anfon negeseuon.",
            "see_my_message": "Gweld neges",
            "open_message_with_egl_app": "Agor neges yn ap Evergreen Life",
            "open_message_with_web_app": "Agor neges yn y porwr",
            "you_have_a_message": "Mae gennych neges ar askmyGP",
            "regards": "Cofion",
            "security_notice": "Hysbysiad Diogelwch",
            "security_notice_from": "Dyma hysbysiad diogelwch gan",
            "message": "Neges",
            "app_password_reset": "ailosod cyfrinair askmyGP",
            "set_password": "Gosod Cyfrinair",
            "link_will_expire": "Gellir defnyddio'r ddolen hon unwaith ac fe fydd hi'n dod i ben ar ôl 24 awr.",
            "password_reset_request": "Gofynnwyd i ailosod cyfrinair y cyfrif askmyGP a gofrestrwyd i",
            "no_changes_yet_click_reset_pass": "Nid yw newidiadau wedi'u gwneud eto. Cliciwch y botwm isod i ailosod eich cyfrinair.",
            "did_not_request_no_action_required": "Os nad ydych wedi gofyn am ailosod cyfrinair, gallwch anwybyddu'r e-bost hwn: nid oes angen gweithredu ychwanegol. Peidiwch â ateb yr e-bost hwn, gan nad yw ymatebion yn cael eu monitro.",
            "find_out_more": "Darganfyddwch fwy",
            "you_can_download_our_app": "Nawr gallwch lawrlwytho ein hap"
        },
        "security": {
            "not_authorised_to_list_feedback": "Nid oes gennych ganiatâd i restru adborth.",
            "not_authorised_to_view_feedback_items": "Nid oes gennych ganiatâd i weld eitemau adborth.",
            "not_authorised_to_view_this_feedback": "Nid oes gennych ganiatâd i weld yr eitem adborth hon.",
            "not_authorised_to_delete_feedback": "Nid oes gennych ganiatâd i ddileu eitemau adborth.",
            "not_allowed_view_messages": "Nid oes gennych ganiatâd i weld negeseuon.",
            "not_allowed_view_messages_from_another_provider": "Nid oes gennych ganiatâd i weld negeseuon gan ddarparwr arall.",
            "not_allowed_view_messages_from_this_request": "Nid oes gennych ganiatâd i weld negeseuon o'r cais hwn.",
            "attempting_to_access_another_users_message": "Ymgeisio i gael mynediad at neges rhywun arall.",
            "attempting_to_access_another_provider": "Ymgeisio i gael mynediad at ddarparwr arall.",
            "not_permitted_to_view_messages_in_this_thread": "Nid oes gennych ganiatâd i weld y negeseuon yn y ffrwd hwn.",
            "patients_not_allowed_post_internal_messages": "Nid oes caniatâd i gleifion i bostio negeseuon mewnol.",
            "not_able_top_post_messages_until_provider_response": "Ymddiheuriadau, nid ydych yn gallu postio negeseuon tan y cewch ymateb gan eich darparwr.",
            "cannot_delete_other_peoples_messages": "Nid ydych yn gallu dileu negeseuon pobl eraill.",
            "this_is_a_test_please_disregard": "Mae hwn yn brofiad diogelwch. Anwybyddwch os gwelwch yn dda.",
            "not_authorised_to_request_video_calls": "Nid oes gennych ganiatâd i ofyn am alwadau fideo.",
            "not_authorised_to_send_video_requests_to_this_thread": "Nid oes gennych ganiatâd i anfon ceisiadau fideo i'r ffrwd hwn.",
            "not_authorised_to_view_this_document": "Nid oes gennych ganiatâd i weld y ddogfen hon.",
            "not_authorised_to_view_documents": "Nid oes gennych ganiatâd i weld dogfennau.",
            "permission_denied_to_delete_message_documents": "Nid oes gennych ganiatâd i ddileu dogfennau neges.",
            "message_to_closed_request": "Mae'r cais hwn wedi'i gau. Os ydych am gysylltu â'ch darparwr eto, dechreuwch gais newydd os gwelwch yn dda.",
            "not_authorised_to_view_this_image": "Nid oes gennych ganiatâd i weld y ddelwedd hon.",
            "not_authorised_to_view_images": "Nid oes gennych ganiatâd i weld delweddau.",
            "permission_denied_delete_message_images": "Nid oes gennych ganiatâd i ddileu delweddau neges.",
            "not_authorised_to_view_news_items": "Nid oes gennych ganiatâd i weld eitemau newyddion.",
            "permission_denied_create_news_items": "Nid oes gennych ganiatâd i greu eitemau newyddion.",
            "permission_denied_edit_news_items": "Nid oes gennych ganiatâd i olygu eitemau newyddion.",
            "permission_denied_delete_news_items": "Nid oes gennych ganiatâd i ddileu eitemau newyddion.",
            "not_authorised_to_view_user": "Nid oes gennych ganiatâd i weld y defnyddiwr hwn.",
            "practice_code_supplied_does_not_exist": "Nid yw'r cod practis a ddarparwyd yn bodoli.",
            "permission_denied_update_verification_statuses": "Nid oes gennych ganiatâd i ddiweddaru statwsau dilysu.",
            "permission_denied_view_subject_access_requests": "Nid oes gennych ganiatâd i weld ymholiadau mynediad pwnc.",
            "permission_denied_merge_patient_accounts": "Nid oes gennych ganiatâd i uno cyfrifon cleifion.",
            "can_only_merge_patients_belonging_to_your_provider": "Dim ond eich darparwr chi y gallwch uno cleifion sy'n perthyn i chi.",
            "permission_denied_view_preset_messages": "Nid oes gennych ganiatâd i weld negeseuon rhagfynnol.",
            "permission_denied_create_preset_messages": "Nid oes gennych ganiatâd i greu negeseuon rhagfynnol.",
            "permission_denied_edit_preset_messages": "Nid oes gennych ganiatâd i olygu negeseuon rhagfynnol.",
            "permission_denied_delete_preset_messages": "Nid oes gennych ganiatâd i ddileu negeseuon rhagfynnol.",
            "permission_denied_edit_item": "Nid oes gennych ganiatâd i olygu'r eitem hon.",
            "permission_denied_delete_item": "Nid oes gennych ganiatâd i ddileu'r eitem hon.",
            "user_not_found_for_preset_message_assignment": "Heb ddod o hyd i ddefnyddiwr ar gyfer aseiniad neges rhagfynnol.",
            "permission_denied_view_tags": "Nid oes gennych hawl i weld tagiau.",
            "permission_denied_create_tags": "Nid oes gennych hawl i greu tagiau.",
            "permission_denied_edit_tags": "Nid oes gennych hawl i olygu tagiau.",
            "permission_denied_delete_tags": "Nid oes gennych hawl i ddileu tagiau.",
            "permission_denied_view_item": "Nid oes gennych hawl i weld eitem hon.",
            "permission_denied_view_custom_action": "Nid oes gennych hawl i weld eitem hon.",
            "permission_denied_create_custom_action": "Nid oes gennych hawl i greu gweithredoedd mewnol.",
            "permission_denied_edit_custom_action": "Nid oes gennych hawl i olygu gweithredoedd mewnol.",
            "permission_denied_delete_custom_action": "Nid oes gennych hawl i ddileu gweithredoedd mewnol.",
            "permission_denied_view_cohort": "Nid oes gennych hawl i weld eitem hon.",
            "permission_denied_create_cohort": "Nid oes gennych hawl i greu cohorti.",
            "permission_denied_edit_cohort": "Nid oes gennych hawl i olygu cohorti.",
            "permission_denied_delete_cohort": "Nid oes gennych hawl i ddileu cohorti.",
            "permission_denied_view_campaign": "Nid oes gennych hawl i weld eitem hon.",
            "permission_denied_create_campaign": "Nid oes gennych hawl i greu ymgyrchoedd.",
            "permission_denied_edit_campaign": "Nid oes gennych hawl i olygu ymgyrchoedd.",
            "permission_denied_delete_campaign": "Nid oes gennych hawl i ddileu ymgyrchoedd.",
            "not_authorised_to_list_logs": "Nid ydych wedi cael awdurdod i restru logiau.",
            "not_authorised_to_view_log_items": "Nid ydych wedi cael awdurdod i weld eitemau log.",
            "not_authorised_to_view_this_log_item": "Nid ydych wedi cael awdurdod i weld eitem log hon.",
            "permission_denied_delete_activity_log_entries": "Nid oes gennych hawl i ddileu cofnodion y log gweithgarwch.",
            "not_authorised_to_update_provider_details": "Nid ydych wedi cael awdurdod i ddiweddaru manylion darparwr.",
            "not_authorised_to_update_other_providers": "Nid ydych wedi cael awdurdod i ddiweddaru darparwyr eraill.",
            "not_authorised_to_create_providers": "Nid ydych wedi cael awdurdod i greu darparwyr.",
            "not_authorised_to_delete_providers": "Nid ydych wedi cael awdurdod i ddileu darparwyr.",
            "not_authorised_to_access_smsp": "Nid ydych wedi cael awdurdod i gael mynediad i SMSP.",
            "not_authorised_to_check_duplicate_staff": "Nid ydych wedi cael awdurdod i wirio am aelodau staff dyblyg.",
            "not_authorised_grant_access_external_staff": "Nid ydych wedi cael awdurdod i roi mynediad i staff allanol.",
            "not_authorised_to_submit_response_for_thread": "Nid ydych wedi cael awdurdod i gyflwyno ymatebion i'r cais hwn.",
            "not_authorised_to_view_this_form_subimission": "Nid ydych wedi cael awdurdod i weld y ffurflen hon.",
            "not_authorised_to_view_this_thread": "Nid ydych wedi cael awdurdod i weld y thraed hon.",
            "not_authorised_to_assign_threads": "Nid ydych wedi cael awdurdod i neilltuo thraciau.",
            "not_authorised_set_wait_state_on_threads": "Nid oes gennych awdurdod i osod cyflwr aros ar drafodion.",
            "not_authorised_set_follow_up_for_threads": "Nid oes gennych awdurdod i osod dilyniant ar gyfer drafodion.",
            "not_authorised_to_prioritise_threads": "Nid oes gennych awdurdod i flaenoriaethu drafodion.",
            "not_authorised_to_prioritise_threads_from_other_providers": "Nid oes gennych awdurdod i flaenoriaethu drafodion gan ddarparwyr eraill.",
            "not_authorised_close_threads_you_do_not_own": "Nid oes gennych awdurdod i gau drafodion nad ydych chi'n berchen arnynt.",
            "not_authorised_to_access_this_thread": "Nid oes gennych awdurdod i gael mynediad at y drafodyn hwn.",
            "not_authorised_to_reopen_threads_you_do_not_own": "Nid oes gennych awdurdod i ail-agor drafodion nad ydych chi'n berchen arnynt.",
            "not_authorised_to_create_threads_on_behalf_of_this_user": "Nid oes gennych awdurdod i greu drafodion ar ran y defnyddiwr hwn.",
            "not_authorised_to_create_threads_on_behalf_of_other_users": "Nid oes gennych awdurdod i greu drafodion ar ran defnyddwyr eraill.",
            "not_authorised_to_delete_threads": "Nid oes gennych awdurdod i ddileu drafodion.",
            "not_authorised_to_list_users": "Nid oes gennych awdurdod i restru defnyddwyr.",
            "not_authorised_to_view_users_from_other_providers": "Nid oes gennych awdurdod i weld defnyddwyr o ddarparwyr eraill.",
            "permission_denied_update_other_user_accounts": "Nid oes gennych ganiatâd i ddiweddaru cyfrifon defnyddwyr eraill.",
            "permission_denied_update_non_patient_user_accounts": "Nid oes gennych ganiatâd i ddiweddaru cyfrifon defnyddwyr sy'n ddi-brif.",
            "permission_denied_modify_user_roles": "Nid oes gennych ganiatâd i newid swyddogaethau defnyddwyr.",
            "permission_denied_create_non_patient_user_accounts": "Nid oes gennych ganiatâd i greu cyfrifon defnyddwyr sy'n ddi-brif.",
            "permission_denied_add_users_with_roles": "Nid oes gennych ganiatâd i ychwanegu defnyddwyr gyda swyddogaethau.",
            "permission_denied_add_superusers": "Nid oes gennych ganiatâd i ychwanegu defnyddwyr hynod o awdurdodol.",
            "patients_cannot_be_added_with_roles": "Ni ellir ychwanegu cleifion gyda swyddogaethau.",
            "permission_denied_delete_this_user_account": "Nid oes gennych awdurdod i ddileu'r cyfrif defnyddiwr hwn.",
            "permission_denied_delete_multi_provider_accounts_yet": "Nid oes gennych awdurdod i ddileu cyfrifon aml-ddarparwr (hyd yn hyn).",
            "permission_denied_send_emails_to_user_accounts": "Nid oes gennych awdurdod i anfon e-byst at gyfrifon defnyddwyr.",
            "permission_denied_create_demo_questions": "Nid oes gennych awdurdod i greu cwestiynau demo.",
            "permission_denied_create_demo_questions_for_staff_in_other_providers": "Nid oes gennych awdurdod i greu cwestiynau demo ar gyfer staff mewn darparwyr eraill.",
            "not_authorised_to_list_duplicate_users": "Nid ydych wedi cael awdurdod i restru defnyddwyr dyblyg.",
            "non_staff_user_attempting_access_usergroup_index": "Defnyddiwr nad yw'n aelod staff yn ceisio cael mynediad at UserGroup index.",
            "permission_denied_view_user_groups": "Nid oes gennych awdurdod i weld grwpiau defnyddwyr.",
            "permission_denied_edit_user_groups": "Nid oes gennych awdurdod i olygu grwpiau defnyddwyr.",
            "not_allowed_add_non_staff_users_to_groups": "Nid oes gennych hawl i ychwanegu defnyddwyr nad ydynt yn aelodau staff i grwpiau.",
            "permission_denied_create_user_groups": "Nid oes gennych awdurdod i greu grwpiau defnyddwyr.",
            "not_authorised_to_send_video_control_requests_to_this_thread": "Nid ydych wedi cael awdurdod i anfon ymholiadau rheoli fideo at y drafodyn hwn.",
            "permission_denied_delete_appointment": "Nid oes gennych awdurdod i ddileu'r apwyntiad hwn.",
            "permission_denied_edit_network_settings": "Nid oes gennych awdurdod i olygu gosodiadau rhwydwaith.",
            "not_authorised_to_set_ownership": "Nid ydych wedi cael awdurdod i osod perchnogaeth y cais.",
            "only_owner_can_transfer_ownership": "Dim ond y perchennog sy'n gallu trosglwyddo perchnogaeth cais.",
            "token_not_found": "Ni chafwyd token cyfrif newydd"
        },
        "qa": {
            "new": "Yw hyn yn ymwneud â:",
            "sc_new": "Newydd/Bresennol/Arall",
            "about": "Eich cais mewn ychydig o eiriau. Mae lle i fwy o fanylion nes ymlaen.",
            "sc_about": "Yngl_n â",
            "about_medication_subject": "Llinell destun eich ymholiad. Mae lle i fwy o fanylion nes ymlaen.",
            "sc_about_medication_subject": "Yngl_n â",
            "how_long": "Am ba hyd ydych chi wedi cael y broblem hon?",
            "sc_how_long": "Pa hyd?",
            "symptoms": "Disgrifio'ch symptomau a syniad o'r achos, beth yw eich pryderon heddiw, a sut hoffech i ni eich helpu?",
            "sc_symptoms": "Symptomau/Achos/Pryderon/Atebolrwydd",
            "contact_by": "Sut hoffech i ni ddatrys eich cais?",
            "sc_contact_by": "Rhif cyswllt ffôn",
            "call_time": "Pryd hoffech i ni eich ffonio?",
            "sc_call_time": "Amser ffôn hoffech",
            "availability": "Dywedwch pryd rydych chi'n rhydd. Byddwn yn ceisio dod o hyd i amser addas.",
            "sc_availability": "Argaeledd",
            "changes": "Disgrifiwch unrhyw newidiadau diweddar.\\nBeth yw eich pryderon heddiw?\\nSut hoffech i ni helpu?",
            "sc_changes": "Newidiadau/Pryderon/Atebolrwydd",
            "clinician": "Ni allwn addo, ond byddwn yn gwneud ein gorau i chi os oes gennych gleifwr a ddewiswyd.",
            "sc_clinician": "Meddyg a ddewiswyd",
            "appointment_time": "Os bydd y meddyg yn penderfynu bod angen cyfarfod wyneb yn wyneb, a oes amser penodol gennych, fel arfer heddiw?",
            "sc_appointment_time": "Amser apwyntiad penodol",
            "like_help_from": "Pwy hoffech gael cymorth oddi wrthym?",
            "sc_like_help_from": "Hoffwn gael cymorth oddi wrth",
            "resolve_by": "Sut cafodd y cais hwn ei ddatrys?",
            "sc_resolve_by": "Sut ei ddatrys",
            "if_notes_resolve_by": "Pe byddai nodiadau ar gael, byddwn yn datrys drwy:",
            "explain_question": "Eglurwch eich cwestiwn os gwelwch yn dda",
            "sc_explain_question": "Cwestiwn",
            "explain_medication_query": "Manylion pellach am eich ymholiad am feddyginiaeth",
            "sc_explain_medication_query": "Ymholiad",
            "completed_by_other": "A gafodd y cais hwn ei gwblhau ar ran meddyg arall?",
            "sc_completed_by_other": "Wedi'i gwblhau gan feddyg arall",
            "completed_behalf_of": "Meddyg y gwnaeth gwblhau'r cais ar ei ran",
            "sc_completed_behalf_of": "Wedi'i gwblhau ar ran",
            "option_new_medical_problem": "Problem feddygol newydd",
            "option_val_new_medical_problem": "Problem meddygol newydd",
            "option_existing_problem": "Problem presennol",
            "option_val_existing_problem": "Problem presennol",
            "option_any_other_question": "Unrhyw gwestiwn arall",
            "option_val_any_other_question": "Cwestiwn arall",
            "option_medication_query": "Ymholiad am feddyginiaeth",
            "option_val_medication_query": "Ymholiad am feddyginiaeth",
            "option_email_message": "Neges e-bost",
            "option_val_email_message": "Neges e-bost",
            "option_telephone": "Ffôn",
            "option_val_telephone": "Ffôn",
            "option_face_to_face_appointment": "Apwyntiad wyneb yn wyneb",
            "option_val_face_to_face_appointment": "Apwyntiad wyneb yn wyneb",
            "option_asap": "Cyn gynted â phosib",
            "option_val_asap": "Cyn gynted â phosib",
            "option_explain_availability": "Mae angen i mi egluro fy argaeledd",
            "option_val_explain_availability": "Egluro",
            "option_anyone": "Unrhyw un",
            "option_val_anyone": "Unrhyw un",
            "option_someone_by_name": "Rhywun yn enw",
            "option_val_someone_by_name": "Rhywun yn enw",
            "option_female_clinician": "Gweithiwr meddygol benywaidd",
            "option_val_female_clinician": "Gweithiwr meddygol benywaidd",
            "option_male_clinician": "Gweithiwr meddygol gwrywaidd",
            "option_val_male_clinician": "Gweithiwr meddygol gwrywaidd",
            "option_message": "Neges",
            "option_val_message": "Neges",
            "option_face_to_face": "Wyneb yn wyneb",
            "option_val_face_to_face": "Wyneb yn wyneb",
            "option_abandoned": "Wedi'i adael",
            "option_val_abandoned": "Wedi'i adael",
            "option_admin": "Gweinyddu",
            "option_val_admin": "Gweinyddu",
            "option_other_clinician": "Gweithiwr meddygol arall",
            "option_val_other_clinician": "Gweithiwr meddygol arall",
            "option_anytime_not_urgent": "Unrhyw amser, nid oes frys",
            "option_val_anytime_not_urgent": "Unrhyw amser, nid oes frys",
            "option_video": "Fideo",
            "option_val_video": "Fideo",
            "option_visit": "Ymweld",
            "option_val_visit": "Ymweld",
            "option_yes": "Ie",
            "option_val_yes": "Ie",
            "option_no": "Na",
            "option_val_no": "Na",
            "option_view_online_resources": "Gweld adnoddau ar-lein",
            "option_val__view_online_resources": "Lansio chwiliad",
            "option_continue_to_askmyGP": "Parhau i ddefnyddio askmyGP",
            "option_val_continue_to_askmyGP": "Parhau i ddefnyddio askmyGP"
        },
        "pagination": {
            "previous": "&laquo;  Blaenorol",
            "next": "Nesaf &raquo;"
        },
        "validation": {
            "phone": "Mae'r maes {attribute} yn cynnwys rhif annilys.",
            "accepted": "Rhaid derbyn y maes {attribute}.",
            "active_url": "Nid yw {attribute} yn URL dilys.",
            "after": "Rhaid i'r maes {attribute} fod yn ddyddiad ar ôl {date}.",
            "after_or_equal": "Rhaid i'r maes {attribute} fod yn ddyddiad ar ôl neu yn gyfartal â {date}.",
            "alpha": "Gall y maes {attribute} gynnwys llythrennau yn unig.",
            "alpha_dash": "Gall y maes {attribute} gynnwys llythrennau, rhifau, a dashau yn unig.",
            "alpha_num": "Gall y maes {attribute} gynnwys llythrennau a rhifau yn unig.",
            "array": "Rhaid i'r maes {attribute} fod yn array.",
            "before": "Rhaid i'r maes {attribute} fod yn ddyddiad cyn {date}.",
            "before_or_equal": "Rhaid i'r maes {attribute} fod yn ddyddiad cyn neu'n gyfartal â {date}.",
            "between": {
                "numeric": "Rhaid i'r maes {attribute} fod rhwng {min} a {max}.",
                "file": "Rhaid i'r maes {attribute} fod rhwng {min} a {max} kilobytes.",
                "string": "Rhaid i'r maes {attribute} fod rhwng {min} a {max} nod.",
                "array": "Rhaid i'r maes {attribute} gael rhwng {min} a {max} eitem."
            },
            "boolean": "Rhaid i'r maes {attribute} fod yn wir neu'n anwir.",
            "confirmed": "Nid yw cadarnhad {attribute} yn cyfateb.",
            "date": "Nid yw {attribute} yn ddyddiad dilys.",
            "date_format": "Nid yw {attribute} yn cyfateb â'r fformat {format}.",
            "different": "Rhaid i'r maes {attribute} a {other} fod yn wahanol.",
            "digits": "Rhaid i'r maes {attribute} fod yn {digits} digidau.",
            "digits_between": "Rhaid i'r maes {attribute} fod rhwng {min} a {max} digid.",
            "dimensions": "Mae gan y ddelwedd {attribute} dimensiynau annilys.",
            "distinct": "Mae gan y maes {attribute} gwerth dwbl.",
            "email": "Rhaid i'r maes {attribute} fod yn gyfeiriad e-bost dilys.",
            "exists": "Mae'r {attribute} detholiedig yn annilys.",
            "file": "Rhaid i'r maes {attribute} fod yn ffeil.",
            "filled": "Rhaid i'r maes {attribute} gael gwerth.",
            "image": "Rhaid i'r maes {attribute} fod yn ddelwedd.",
            "in": "Mae'r {attribute} detholiedig yn annilys.",
            "in_array": "Nid yw maes {attribute} yn bodoli yn {other}.",
            "integer": "Rhaid i'r maes {attribute} fod yn gyfanrif.",
            "ip": "Rhaid i'r maes {attribute} fod yn gyfeiriad IP dilys.",
            "ipv4": "Rhaid i'r maes {attribute} fod yn gyfeiriad IPv4 dilys.",
            "ipv6": "Rhaid i'r maes {attribute} fod yn gyfeiriad IPv6 dilys.",
            "json": "Rhaid i'r maes {attribute} fod yn llinyn JSON dilys.",
            "max": {
                "numeric": "Ni ddylai {attribute} fod yn fwy na {max}.",
                "file": "Ni ddylai {attribute} fod yn fwy na {max} kilobytes.",
                "string": "Ni ddylai {attribute} fod yn fwy na {max} nod.",
                "array": "Ni ddylai {attribute} gael mwy na {max} eitem."
            },
            "mimes": "Rhaid i'r maes {attribute} fod yn ffeil o'r math: {values}.",
            "mimetypes": "Rhaid i'r maes {attribute} fod yn ffeil o'r math: {values}.",
            "min": {
                "numeric": "Rhaid i'r maes {attribute} fod o leiaf {min}.",
                "file": "Rhaid i'r maes {attribute} fod o leiaf {min} kilobytes.",
                "string": "Rhaid i'r maes {attribute} fod o leiaf {min} nod.",
                "array": "Rhaid i'r maes {attribute} fod o leiaf â {min} eitem."
            },
            "not_in": "Mae'r {attribute} detholiedig yn annilys.",
            "not_regex": "Mae'r fformat {attribute} yn annilys.",
            "numeric": "Mae angen maes {attribute}.",
            "present": "Mae angen maes {attribute} pan fo {other} yn {value}.",
            "regex": "Mae angen maes {attribute} oni bai bod {other} yn ymhlith {values}.",
            "required": "Mae angen maes {attribute} pan fo {values} yn bresennol.",
            "required_if": "Mae angen maes {attribute} pan fo {values} yn bresennol.",
            "required_unless": "Mae angen maes {attribute} pan nad oes {values} yn bresennol.",
            "required_with": "Mae angen maes {attribute} pan nad oes unrhyw un o {values} yn bresennol.",
            "required_with_all": "Rhaid i'r {attribute} a {other} fod yn cyfatebol.",
            "required_without": "Rhaid i'r maes {attribute} fod yn {size}.",
            "required_without_all": "Rhaid i'r maes {attribute} fod yn {size} kilobytes.",
            "same": "Rhaid i'r maes {attribute} fod yn {size} nod.",
            "size": {
                "numeric": "Rhaid i'r maes {attribute} gynnwys {size} eitem.",
                "file": "Rhaid i'r maes {attribute} fod yn llinyn.",
                "string": "Rhaid i'r maes {attribute} fod yn barth dilys.",
                "array": "Mae'r {attribute} eisoes wedi'i gymryd."
            },
            "string": "Methodd {attribute} lanlwytho.",
            "timezone": "Mae'r fformat {attribute} yn annilys.",
            "unique": "Mae'r {attribute} eisoes wedi'i gymryd.",
            "uploaded": "Methodd uwchlwytho {attribute}.",
            "url": "Mae'r fformat {attribute} yn annilys.",
            "password": "Cyfrinair annilys",
            "custom": {
                "tags_tag_use": {
                    "required": "Dewiswch o leiaf un defnydd ar gyfer y tag"
                },
                "forenames": {
                    "required": "Rhowch y cyfenw(au) i mewn os gwelwch yn dda"
                },
                "surname": {
                    "required": "Rhowch y cyfenw i mewn os gwelwch yn dda"
                },
                "dob": {
                    "required": "Rhowch y dyddiad geni i mewn os gwelwch yn dda",
                    "date": "Rhowch dyddiad geni dilys i mewn os gwelwch yn dda",
                    "before": "Rhowch dyddiad geni dilys i mewn os gwelwch yn dda",
                    "in": "Nid yw'r dyddiad geni a roddwyd yn cyd-fynd â'r cofnodion sydd gan y practis",
                    "regex": "Rhowch dyddiad geni yn y fformat DD/MM/BBBB os gwelwch yn dda"
                },
                "gender": {
                    "required": "Dewiswch yr rhyw"
                },
                "provider": {
                    "site_id": {
                        "required": "Dewiswch y safle a ddewisir"
                    },
                    "id": {
                        "required": "Dewiswch ddarparwr"
                    },
                    "user_role_id": {
                        "required": "Dewiswch swyddogaeth defnyddiwr"
                    }
                },
                "capacity": {
                    "*": {
                        "capacity": {
                            "*": "Rhaid i'r capasiti fod yn rif cyfan, dim ond sero neu fwy"
                        }
                    }
                },
                "verification_status_id": {
                    "required": "Dewiswch statws ID"
                },
                "demand": {
                    "*": {
                        "demand": {
                            "*": "Rhaid i'r galw fod yn rif cyfan, dim ond sero neu fwy"
                        }
                    }
                },
                "email": {
                    "required": "Rhowch eich cyfeiriad e-bost os gwelwch yn dda"
                },
                "phone_number": {
                    "required": "Rhowch eich rhif ffôn os gwelwch yn dda"
                },
                "postcode": {
                    "required": "Rhowch eich cod post os gwelwch yn dda",
                    "regex": "Rhowch cod post dilys os gwelwch yn dda"
                },
                "terms": {
                    "required": "Derbynwch y cytundeb trwydded defnyddwyr terfynol"
                },
                "locale": {
                    "required": "Dewiswch iaith"
                },
                "user_relationship_type_id": {
                    "required": "Dewiswch y berthynas rhwng eich hun a'r claf"
                },
                "site_id": {
                    "required": "Dewiswch eich safle delfrydol"
                },
                "message": {
                    "required": "Teipiwch rhywbeth yn y blwch neges os gwelwch yn dda"
                },
                "attached_images": {
                    "*": {
                        "*": "Nid yw'ch delwedd atodedig yn ymddangos fel ffeil delwedd ddilys (jpg, jpeg a png yn unig yn cael eu cefnogi)"
                    }
                },
                "attached_documents": {
                    "*": {
                        "mimetypes": "Nid yw'ch dogfen atodedig yn ymddangos fel ffeil ddogfen ddilys (pdf, doc, docx, odt, xls, xlsx, ods yn unig yn cael eu cefnogi)",
                        "clamav": "Canfyddwyd feirws yn eich ffeil uwchlwytho. Efallai y byddwch yn dymuno rhedeg rhaglen wrth-feirws ar eich cyfrifiadur i wirio am feirws. Mae'r uwchlwythiad wedi cael ei wrthod.",
                        "*": {
                            "mimetypes": "Nid yw'ch dogfen atodedig yn ymddangos fel ffeil ddogfen ddilys (pdf, doc, docx, odt, xls, xlsx, ods yn unig yn cael eu cefnogi)",
                            "clamav": "Canfyddwyd feirws yn eich ffeil uwchlwytho. Efallai y byddwch yn dymuno rhedeg rhaglen wrth-feirws ar eich cyfrifiadur i wirio am feirws. Mae'r uwchlwythiad wedi cael ei wrthod."
                        }
                    }
                },
                "email_verification_code": "CY AWAITING TRANSLATION: Invalid code entered. Please type the code as shown in the email. If you haven\\'t received the email, please check your junk/spam email folder"
            }
        },
        "errors": {
            "too_many_page_requests": "Mae'r gweinydd yn adrodd bod gennych chi ormod o geisiadau data/tudalennau. Arhoswch, a rhowch gynnig arni eto'n nes ymlaen.",
            "data_sending_too_large_rejected": "Mae'r gweinydd wedi adrodd bod y data rydych chi'n ei anfon yn rhy fawr, ac mae wedi ei wrthod. Rhowch gynnig ar anfon atodiad llai.",
            "item_requested_not_found_maybe_deleted_by_another": "Nid yw'r eitem rydych yn ei gofyn am wedi'i ddarganfod. Gall hyn fod oherwydd ei fod wedi'i ddileu gan ddefnyddiwr arall.",
            "data_endpoint_not_found": "Nid yw'r pen fynedfa data rydych yn ceisio ei gyrchu wedi'i ddarganfod.",
            "an_error_occured_try_again": "Digwyddodd gwall. Rhowch gynnig arni eto os gwelwch yn dda.",
            "security_risk": "Mae'r gweinydd wedi gweld cynnwys sy'n cael ei ystyried yn risg diogelwch. Os ydych yn credu bod hyn yn gamgymeriad, rhowch wybod i ni yn: <ul><li><a href='mailto:askmyGP@evergreen-life.co.uk?Subject=askmyGP%20user%20report'>askmyGP@evergreen-life.co.uk</a></li></ul>Mae ein tîm diogelwch wedi cael gwybod am y digwyddiad hwn, ac mae eich manylion defnyddiwr, a'ch cyfeiriad IP wedi'u cofnodi i'n helpu i gymryd camau priodol.",
            "unexpected_response_from_server": "Derbynwyd ymateb annisgwyl gan y gweinydd. Os bydd hyn yn parhau i ddigwydd, rhowch wybod i weinyddwr.",
            "application_version_too_old": "Mae'r fersiwn o'r gweithrediad yr ydych chi'n ei redeg yn hen. Cliciwch y botwm isod i orfodi'r gweithrediad i adnewyddu. Os ydych yn parhau i weld y neges hon ar ôl adnewyddu, efallai y bydd angen i chi roi cynnig arni eto'n nes ymlaen.\n<br /><div style=\"text-align: center\"><button onclick=\"window.location.reload(true)\" class=\"btn btn-primary\">Adnewyddu i ddefnyddio'r fersiwn diweddaraf o'r gweithrediad</button></div>",
            "admin_restricted_patient_not_found": "Nid oes claf wedi'i ddarganfod gydag ID neu gyfeiriad e-bost hwnnw.",
            "max_websocket_reconnects": "Mae'r gweithrediad yn cael trafferth yn cysylltu â'r gweinydd. Cliciwch y botwm isod i orfodi'r gweithrediad i adnewyddu. Os ydych yn parhau i weld y neges hon ar ôl adnewyddu, efallai y bydd angen i chi roi cynnig arni eto'n nes ymlaen.\n<br /><div style=\"text-align: center\"><button onclick=\"window.location.reload(true)\" class=\"btn btn-primary\">Adnewyddu'r gweithrediad</button></div>",
            "writeback_max_pending_age_warning": "Mae yna ffiliadau sy'n aros yn eich cwêl ysgrifennu a ydynt yn h_n na {oriau} awr. Sicrhewch fod eich system archwilio yn gweithio'n iawn gan na fydd gofynion yn cael eu cyflwyno i'ch system glinigol hyd nes bydd hyn wedi'i ddatrys. I ymarferion SystmOne, gwiriwch i sicrhau bod eich poler yn rhedeg ac fod SystmOne wedi mewngofnodi ochr yn ochr â hwn. <a target=\"helpdesk\" href=\"https://evergreenlife.freshdesk.com/support/solutions/articles/14000145209-systmone-poller-troubleshooting\">Gellir dod o hyd i ragor o ganllawiau yma</a>."
        }
    },
    "en": {
        "brand": {
            "base": {
                "app_name": "AskMyProvider",
                "article_app_name": "an AskMyProvider",
                "provider_generic_term": "provider",
                "mail_noreply": "noreply@askmygp.uk",
                "online_service_login_message": "This is not the same as other online services you may use",
                "client": "translations.client",
                "clients": "translations.clients",
                "is_proxy_for": "Is proxy for",
                "request": "translations.request",
                "requests": "translations.requests",
                "people_i_care_for": "translations.people_i_care_for",
                "add_another_person": "translations.add_another_person",
                "our_service_times": "translations.our_service_times",
                "web_link": "https",
                "branch_link": "https://link.evergreenlife.co.uk/b6fBoaZl3rb",
                "phr_app_name": "Evergreen Life",
                "conf_show_new_request": "1",
                "conf_view_past_requests": "1",
                "conf_edit_my_details": "1",
                "conf_edit_my_details_menu": "1",
                "conf_proxy": "1",
                "conf_proxy_menu": "1",
                "conf_emergency_banner": "1",
                "conf_covid_19_banner": "1",
                "conf_our_service_times": "1",
                "conf_when_is_your_clinician_working": "1",
                "conf_show_logout": "1",
                "conf_notification_option": "1",
                "conf_install_option": "1",
                "conf_show_licence_agreement": "1",
                "conf_quick_self_help": "1",
                "conf_show_menu": "1",
                "conf_show_top_nav": "1",
                "conf_show_global_previous": "",
                "conf_surveyjs_question_heading_tag": ""
            },
            "askmygp_uk": {
                "app_name": "askmyGP",
                "article_app_name": "an askmyGP",
                "provider_generic_term": "GP practice",
                "online_service_login_message": "This is not the same as other GP online services you may use",
                "client": "translations.patient",
                "clients": "translations.patients",
                "people_i_care_for": "translations.patients_i_care_for",
                "add_another_person": "translations.add_another_patient",
                "training_link": "https://askmygp.uk/private/academy/"
            },
            "evergreen_connect_co_uk": {
                "app_name": "Evergreen",
                "article_app_name": "an Evergreen",
                "provider_generic_term": "GP practice",
                "mail_noreply": "dr-iq@mail.evergreen-connect.co.uk",
                "online_service_login_message": "This is not the same as other GP online services you may use",
                "client": "translations.patient",
                "clients": "translations.patients",
                "people_i_care_for": "translations.patients_i_care_for",
                "add_another_person": "translations.add_another_patient",
                "training_link": "https://askmygp.uk/private/academy/",
                "our_service_times": "translations.online_consultation_availability",
                "web_link": "",
                "branch_link": "https://link.evergreenlife.co.uk/b6fBoaZl3rb",
                "conf_our_service_times": ""
            },
            "askmyinsurer_redpixelyellowpixel_com": {
                "app_name": "Evergreen",
                "article_app_name": "an Evergreen",
                "provider_generic_term": "GP practice",
                "mail_noreply": "dr-iq@mail.evergreen-connect.co.uk",
                "online_service_login_message": "This is not the same as other GP online services you may use",
                "client": "translations.patient",
                "clients": "translations.patients",
                "people_i_care_for": "translations.patients_i_care_for",
                "add_another_person": "translations.add_another_patient",
                "training_link": "https://askmygp.uk/private/academy/",
                "our_service_times": "translations.online_consultation_availability",
                "web_link": "",
                "branch_link": "",
                "conf_our_service_times": ""
            },
            "OLD_askmyinsurer_redpixelyellowpixel_com": {
                "app_name": "Virtual Therapy Clinics",
                "article_app_name": "a Virtual Therapy Clinics",
                "mail_noreply": "noreply@redpixelyellowpixel.com",
                "online_service_login_message": "",
                "is_proxy_for": "Family/Friend",
                "request": "translations.case",
                "requests": "translations.cases"
            },
            "virtualhealthclinic_co_uk": {
                "app_name": "Virtual Therapy Clinics",
                "article_app_name": "a Virtual Therapy Clinics",
                "mail_noreply": "noreply@virtualhealthclinic.co.uk",
                "online_service_login_message": "",
                "is_proxy_for": "Family/Friend",
                "request": "translations.case",
                "requests": "translations.cases"
            },
            "vhc_askmygp_uk": {
                "app_name": "Virtual Therapy Clinics",
                "article_app_name": "a Virtual Therapy Clinics",
                "online_service_login_message": "",
                "mail_noreply": "noreply_vhc@redpixelyellowpixel.com",
                "is_proxy_for": "Family/Friend",
                "request": "translations.case",
                "requests": "translations.cases"
            },
            "provider_C83060": {
                "conf_quick_self_help": ""
            },
            "embed_1": {
                "conf_show_new_request": "1",
                "conf_view_past_requests": "1",
                "conf_edit_my_details": "",
                "conf_proxy": "",
                "conf_emergency_banner": "1",
                "conf_covid_19_banner": "1",
                "conf_when_is_your_clinician_working": "1",
                "conf_show_logout": "",
                "conf_notification_option": "",
                "conf_install_option": "",
                "conf_show_licence_agreement": "",
                "conf_quick_self_help": "",
                "conf_show_menu": "1",
                "conf_show_top_nav": "1"
            },
            "embed_nhs": {
                "conf_show_new_request": "",
                "conf_view_past_requests": "",
                "conf_edit_my_details": "",
                "conf_proxy": "",
                "conf_emergency_banner": "",
                "conf_covid_19_banner": "",
                "conf_our_service_times": "",
                "conf_when_is_your_clinician_working": "",
                "conf_show_logout": "",
                "conf_notification_option": "",
                "conf_install_option": "",
                "conf_show_licence_agreement": "",
                "conf_quick_self_help": "",
                "conf_show_menu": "",
                "conf_show_top_nav": "",
                "conf_show_global_previous": "1",
                "conf_surveyjs_question_heading_tag": "h1"
            },
            "embed_extreme": {
                "conf_show_new_request": "",
                "conf_view_past_requests": "",
                "conf_edit_my_details": "",
                "conf_proxy": "",
                "conf_emergency_banner": "",
                "conf_covid_19_banner": "",
                "conf_our_service_times": "",
                "conf_when_is_your_clinician_working": "",
                "conf_show_logout": "",
                "conf_notification_option": "",
                "conf_install_option": "",
                "conf_show_licence_agreement": "",
                "conf_quick_self_help": "",
                "conf_show_menu": "",
                "conf_show_top_nav": ""
            }
        },
        "translations": {
            "English": "English",
            "Cymraeg": "Cymraeg",
            "is_loading": "is loading",
            "please_be_patient": "Please do not refresh your browser",
            "loading_browser_support_message": "If the application fails to load, please ensure you are using a supported browser - Chrome, MS Edge, Safari (10+) and Firefox",
            "ie11_heading": "Unsupported Browser",
            "ie11_message": "You are attempting to load the {app_name} application on an unsupported browser. The {app_name} application supports Chrome, MS Edge, Safari (10+) and Firefox.",
            "ie11_help_link": "Click for instructions on how to change IE11 as your default browser for {app_name}.",
            "ie11_password_reset": "To reset your password, copy the URL below into a supported browser.",
            "application_failed_to_load": "Sorry, we have a technical problem.  Please try later.",
            "edit_demand_capacity": "Edit Demand and Group Capacity",
            "save": "Save",
            "cancel": "Cancel",
            "show": "Show",
            "hide": "Hide",
            "login": "Login",
            "log_in": "Log in",
            "logout": "Log out",
            "edit": "Edit",
            "delete": "Delete",
            "help": "Help",
            "edit_patient": "Edit {client}",
            "send_assign": "Send / Assign",
            "sar": "Download history",
            "update": "Update",
            "create": "Create",
            "create_staff": "Create staff",
            "spine_lookup": "NHS Spine lookup",
            "close": "Close",
            "clear": "Clear",
            "apply": "Apply",
            "search": "Search",
            "copy_to_patient_record": "Writeback to {client} record",
            "remove_site": "Remove site",
            "add_site": "Add another site",
            "add_linked_provider": "Add linked provider",
            "update_settings": "Update Settings",
            "view_appointments_calendar": "View appointments calendar",
            "view": "View",
            "add": "Add",
            "remove": "Remove",
            "start_video_call": "Start a video call",
            "advanced_search": "Advanced Search",
            "create_new_request": "Create a new {request}",
            "create_new_request_provider": "New {request}",
            "view_activity": "View activity",
            "reset_demo_questions": "Reset Demo Questions",
            "send_welcome_email_password": "Send welcome email/password reset",
            "reset_password": "Reset Password",
            "create_password": "Create Password",
            "set_password": "Set Password",
            "change_password": "Change Password",
            "send_password_reset_link": "Send Password Reset Link",
            "confirm_password": "Confirm Password",
            "confirm": "Confirm",
            "register": "Register",
            "register_patient": "Register {client}",
            "add_another_patient": "Add another {client}",
            "add_another_person": "Add another person",
            "next": "Next",
            "back": "Back",
            "prev": "Prev",
            "previous": "Previous",
            "email_address": "Email Address",
            "email": "Email",
            "email_or_user_id": "Email or User ID",
            "password": "Password",
            "current_password": "Current Password",
            "new_password": "New Password",
            "forename": "Forename",
            "first_names": "First Name(s)",
            "gender": "Gender",
            "DOB": "DOB",
            "date_of_birth": "Date of birth",
            "postcode": "Postcode",
            "on": "On",
            "off": "Off",
            "yes": "Yes",
            "no": "No",
            "set_service_availability": "Set the availability of the service",
            "time_requests_return_waiting": "Time when {requests} return from waiting",
            "set_waiting_days": "Set waiting days default",
            "relationship_type": "Relationship Type",
            "relationship": "Relationship",
            "select_site": "Select site",
            "site": "Site",
            "source": "Source",
            "scope_of_message": "Scope of message *",
            "all_sites": "All sites",
            "combined_sites": "Combined sites",
            "please_select": "Please select",
            "out_of_hours_requests": "Out of hours {requests}",
            "closed_to_new_requests": "Closed to new {requests}",
            "availability_until_previous": "Status will be taken from the previous day.",
            "availability_until_previous_help1": "This setting tells the system how to handle {requests} that are submitted between the closing time of the current day and the opening time of the next day which has some availability set.",
            "availability_until_previous_help2": "When a day has no opening times set, the setting will be taken from the first day prior to that, where availability has been set.",
            "availability_until_previous_help3": "For example, if both Saturday and Sunday have no availability times set, the service availability will be taken from Friday, and applied to both days up to and including the period before opening on the following Monday.",
            "availability_until_previous_help4": "If you wish to simply take the system offline temporarily, consider using the global availability setting above.",
            "global": "Global",
            "is": "is",
            "is_not": "is not",
            "contains": "contains",
            "does_not_contain": "does not contain",
            "field": "Field",
            "NHS_spine": "NHS Spine",
            "current": "Current",
            "NHS_number": "NHS/CHI Number",
            "provider_code": "Provider Code",
            "title": "Title",
            "surname": "Surname",
            "forenames": "Forename(s)",
            "phone": "Phone",
            "address_line_1": "Address Line 1",
            "address_line_2": "Address Line 2",
            "address_line_3": "Address Line 3",
            "address_line_4": "Address Line 4",
            "address_line_5": "Address Line 5",
            "day": "Day",
            "predicted_demand": "predicted demand",
            "in_hours_service_times": "In hours service times",
            "service_until_next_opening": "Service until next opening",
            "day_of_week": "Day of Week",
            "availability": "Availability",
            "availability_same_as_provider": "Same as provider availability",
            "availability_always": "Always available",
            "availability_custom": "Custom",
            "unavailable": "Unavailable",
            "capacity_requests": "Capacity ({requests})",
            "date": "Date",
            "session": "Session",
            "max_book_ahead_time": "Maximum book ahead time",
            "min_book_ahead_time": "Minimum book ahead time",
            "appointments_interval": "Interval between appointments (minutes)",
            "session_name": "Session name",
            "start_date": "Start Date",
            "end_date": "End Date",
            "actions": "Actions",
            "digital_triage": "Digital triage",
            "request_solved_by_mode": "{request} resolved by mode",
            "other_clinician": "Other Clinician",
            "admin": "Admin",
            "no_availability": "No availability",
            "message": "message",
            "telephone": "Telephone",
            "face_to_face": "Face to face",
            "GP": "GP",
            "total_requests": "Total {requests}",
            "min_request": "Min/{request}",
            "total_minutes": "Total minutes",
            "average_consult_time_min": "Average consult time/min",
            "name_of_session": "name of session",
            "7_days": "7 days",
            "15_mins": "15 minutes",
            "no_standard_availability": "No standard availability found",
            "none_listed": "None listed",
            "enter_only_one": "Enter only one",
            "see_settings_groups": "See also Settings > Groups  to ensure correct membership",
            "tooltip_one_field_is_enough": "Date of birth only works best",
            "news_and_updates": "News and Updates",
            "create_new": "Create new",
            "settings": "Settings",
            "diagnostics": "Diagnostics",
            "digital_triage_results": "Digital Triage Results",
            "update_your_details": "Update your details",
            "register_for_account": "Register for an account",
            "self_help": "Self Help",
            "service_times": "Service Times",
            "service_status": "Service status",
            "messages": "Messages",
            "sites": "Sites",
            "availability_exceptions": "Availability Exceptions",
            "appointment_settings": "Appointment settings",
            "appointment_session_types": "Appointment session types",
            "appointment_sessions": "Appointment sessions",
            "booking_availability": "Booking availability",
            "is_proxy_for": "Is proxy for",
            "in_care_of": "In the care of",
            "select_relationship": "Select Relationship",
            "staff_login_to": "Staff Login to",
            "link_forgotten_password": "Forgotten Password?",
            "forgotten_password": "Forgotten Password",
            "password_reset_sucess_message": "Your password was reset successfully. You can now log in using your new password.",
            "password_reset_email_sent_message": "A password reset email has been sent to your email address, if it is registered. Please follow the directions in the email to reset your password.",
            "home": "Home",
            "dashboard": "Dashboard",
            "request": "request",
            "requests": "requests",
            "case": "case",
            "cases": "cases",
            "requests_title": "{requests}",
            "patients": "patients",
            "patient": "patient",
            "clients": "clients",
            "client": "client",
            "staff": "Staff",
            "robot": "Robot",
            "appointments": "Appointments",
            "my_profile": "My Profile",
            "profile": "Profile",
            "preset_messages": "Preset Messages",
            "preset_message_search": "Preset Message Search",
            "patient_search": "{Client} search",
            "news_items": "News Items",
            "log_entries": "Log Entries",
            "feedback_entries": "Feedback Entries",
            "staff_members": "Staff Members",
            "user_groups": "User Groups",
            "manage_duplicates": "Manage duplicates",
            "groups": "Groups",
            "system": "System",
            "system_logs": "Logs",
            "duplicate_patients": "Duplicate {clients}",
            "reports": "Reports",
            "guide": "Guide",
            "feedback": "Feedback",
            "send_feedback": "Send Feedback",
            "patient_feedback": "{Client} Feedback",
            "news": "News",
            "version": "Version",
            "demand_and_capacity": "Demand & Capacity",
            "filtered": "filtered",
            "filter": "filter",
            "show_all_clinicians": "show all clinicians",
            "new": "New",
            "assigned": "Assigned",
            "assigned_now": "Assigned (now)",
            "assigned_today": "Assigned so far today",
            "share": "Share",
            "shared": "shared",
            "transferred_now": "transferred (now)",
            "transferred_today": "transferred so far today",
            "shared_now": "shared (now)",
            "shared_today": "shared so far today",
            "stop_share": "Unshare",
            "assigned_to": "Assigned to",
            "assigned_to_me_or_my_groups": "Assigned to me or my groups",
            "waiting_for_patient_assigned_to_me_or_my_groups": "Waiting for {client}, assigned to me or my groups",
            "include": "Include",
            "waiting_for_patient": "Waiting for {client}",
            "new_today": "New today",
            "completed_today": "Completed today",
            "today": "Today",
            "copy": "Copy",
            "copy_to_clipboard": "Copy to clipboard",
            "copy_rs": "Writeback to record",
            "copy_rso": "Writeback to originating provider's record",
            "copy_and_transfer": "Copy to clipboard & transfer",
            "copy_and_transfer_rs": "Writeback to record & transfer",
            "skip_and_transfer": "Skip & transfer",
            "copy_and_transfer_message": "If required, copy to your record before transfer",
            "wait_and_transfer_message": "If required, you can set the message to await reply before transfer",
            "copy_and_share": "Copy to clipboard & share",
            "copy_and_share_rs": "Writeback to record & share",
            "skip_and_share": "Skip & share",
            "copy_and_share_message": "If required, copy to your record before sharing",
            "wait_and_share_message": "If required, you can set the message to await reply before sharing",
            "thread_originated_at": "Originated at",
            "shared_with": "Shared with",
            "set_follow_up": "Set follow up",
            "cancel_follow_up": "Cancel follow up",
            "re-open": "Re-open",
            "send": "Send",
            "now": "Now",
            "waiting": "Waiting",
            "clinician": "Clinician",
            "clinician_group": "Person/Group",
            "team": "Team",
            "network": "Network",
            "completed": "Completed",
            "mine": "Mine",
            "closed": "Closed",
            "archived": "Archived",
            "capacity": "Capacity",
            "complete": "Complete",
            "born": "Born",
            "address": "Address",
            "emergency": "Emergency",
            "urgent": "Urgent",
            "routine": "Routine",
            "visit_request": "Visit Request",
            "elevated": "Elevated",
            "lower": "Lower",
            "download": "Download",
            "wrote": "wrote",
            "create_follow_up": "Create a follow up",
            "requestID": "{request} ID",
            "name": "Name",
            "month": "Month",
            "year": "Year",
            "group": "Group",
            "user_not_assigned_to_any_groups": "This user is not assigned to any groups",
            "all": "All",
            "provider": "Provider",
            "providers": "Providers",
            "forename(s)": "Forename(s)",
            "alias": "Alias, shown to {clients}",
            "IDStatus": "ID Status",
            "patientID": "{Client} ID",
            "age": "Age",
            "comment": "Comment",
            "profession": "Profession",
            "gpad_profession": "Professional Group",
            "scope": "Scope",
            "content": "Content",
            "updated": "updated",
            "estimated_capacity": "estimated capacity",
            "so_far_today": "So far today",
            "filter_no_users_found": "No users found for currently selected filter.",
            "patient_read_all": "{Client} has read all messages",
            "new_message_patient_read_all": "New Message and {client} has read all messages",
            "patient_unread": "{Client} has an unread response",
            "new_message_patient_unread": "New message and {client} has an unread response",
            "unread_message": "unread message",
            "unread_messages": "Unread messages",
            "phone_and_email": "Phone and email",
            "requested_GP": "Requested staff member",
            "demo_mode": "Demo Mode",
            "demo_create_50_reqests_message": "If demo mode is turned on, the superuser will have 50 demo {requests} created for it, so please be patient when you click \"create\".",
            "service_availability": "Service Availability",
            "video_available": "Video Available",
            "video_enabled": "Video Enabled",
            "appointment_booking_enabled": "Appointments Enabled",
            "clinician_gender_selection_enabled": "Clinician Gender Selection Enabled",
            "campaigns_enabled": "Campaigns Enabled",
            "reports_enabled": "Reports Enabled",
            "list_size": "list size",
            "practice_type": "Practice Type",
            "practice_status": "Practice Status",
            "provider_type": "Provider Type",
            "patient_link": "{Client} link",
            "no_items_found": "No items found",
            "qa_in_progress": "QA IN PROGRESS:",
            "no_subject": "no subject",
            "subject_id": "Subject ID",
            "causer_id": "Causer ID",
            "item_id": "Item ID",
            "user_id": "User ID",
            "set_default_language": "Set default language",
            "language": "Language",
            "update_filter_options": "Update filter options",
            "read": "Read",
            "how_was_this_request_resolved?": "How was this {request} resolved?",
            "session_times": "Session Times",
            "no_sessions_available": "No sessions available",
            "no_appointments_available": "There are no appointments currently available. Click \"back\" and select another day.",
            "choose_appointment_day": "Please choose the earliest convenient day",
            "choose_appointment_time": "Choose a time for your appointment",
            "change_booking": "Change Booking",
            "availability_of_the_service": "Availability of the service",
            "default_language": "Default language",
            "history_from_patient": "History from {client}",
            "date_of_birth_copied_to_clipboard": "Date of Birth copied to clipboard",
            "no_site_specified": "No site specified",
            "unsaved_changes_title": "Unsaved changes",
            "unsaved_changes_text": "You have unsaved data that will be lost if you navigate away from this screen. Are you sure you want to continue?",
            "incomplete_qa_text": "You have an incomplete QA in progress which will be lost if you navigate away from this screen. Are you sure you want to continue?",
            "incomplete_qa_text_saved": "You have an incomplete QA in progress. We will attempt to save your progress securely in this web browser, so that you can continue the QA later. Are you sure you want to continue?",
            "thread_created_by_staff": "This {request} was created by a staff member",
            "thread_created_by_proxy": "This {request} was created by a proxy",
            "assigned_thread_to": "assigned {request} to",
            "user_set_priority_to": "{user} set priority to {priority}",
            "form_set_priority_to": "Form '{form}' set priority to {priority}",
            "blood_pressure_range_set_priority_to": "Blood pressure range set priority to {priority}",
            "user_assigned_thread_to": "{user} assigned {request} to {to}",
            "custom_action_assigned_thread_to": "Custom action '{custom_action}' auto-assigned {request} to {to}",
            "shared_thread_with": "shared {request} with",
            "user_shared_thread_with": "{user} shared {request} with {provider}",
            "unshared_thread_with": "stopped share with",
            "user_unshared_thread_with": "{user} stopped share with {provider}",
            "transferred_ownership_of_thread_to": "transferred ownership of thread to",
            "user_transferred_ownership_of_thread_to": "{user} transferred ownership of thread to {provider}",
            "set_thread_as_unassigned": "set {request} as unassigned",
            "user_set_thread_as_unassigned": "{user} set {request} as unassigned",
            "completed_this_request": "{user} completed this {request}",
            "autocomplete_request_timeout": "This {request} completed automatically after waiting.",
            "autocomplete_request_custom_action": "This {request} completed automatically because it was created from a custom action with autocompletion enabled.",
            "re-opened_this_request": "{user} re-opened this {request}",
            "closed_response_to_patient": "Thank you, the service is currently closed for {app_name} {requests}. We have received yours and will respond when the service re-opens. Look for any emails from {mail_noreply}. Please have your phone available as we may need to call you. Calls may be recorded by the practice for training, monitoring and audit purposes.",
            "open_service_response_to_patient": "Thank you, the service is open, and we will respond as soon as possible. Please look for any emails from {mail_noreply}. Please have your phone available as we may need to call you. Calls may be recorded by the practice for training, monitoring and audit purposes.",
            "duplicate_patient_details": "Duplicate {Client} Details",
            "considerations": "Considerations",
            "consider_the_following_before_merging": "You should consider the following points about the two {client} records before merging",
            "both_patient_accounts_active_and_logged_in": "Both of the {client} accounts are active and have been used by the {client} to log in. You may wish to consult with the {client} to find out which of the accounts they would like to keep.",
            "patient_A_active_used_by_patient_to_login": "{Client} A is active and has been used by the {client} to log in.",
            "patient_B_active_used_by_patient_to_login": "{Client} B is active and has been used by the {client} to log in.",
            "both_patient_accounts_email_set_neither_logged_in": "Both {client} accounts have an email address set, although neither account has been used to actively log in yet.",
            "patient_A_email_set_not_logged_in": "{Client} A has an email address set, so it is possible for the {client} to log in to that account, although they have not done so yet.",
            "patient_B_email_set_not_logged_in": "{Client} B has an email address set, so it is possible for the {client} to log in to that account, although they have not done so yet.",
            "neither_account_has_email": "Neither account has an email address, and therefore have not been used by the {client} to log in.",
            "patient_A_has_NHS_CHI_number": "{Client} A has an NHS/CHI number present.",
            "patient_B_has_NHS_CHI_number": "{Client} B has an NHS/CHI number present.",
            "verification_statuses_of_patients_different": "The verification statuses of {Client} A and {Client} B are different.",
            "both_patients_have_requests_all_will_assign_to_chosen_patient": "Both {clients} have previous {requests}. All {requests} will be assigned to the chosen {client}, if you choose to merge.",
            "patient_A_has_requests": "{Client} A has previous {requests}.",
            "patient_B_has_requests": "{Client} B has previous {requests}.",
            "both_patients_have_carers_all_will_be_assigned_to_chosen_patient": "Both {clients} have carers listed for them. All carers will be assigned to the chosen {client}.",
            "patient_A_has_carers_those_will_be_copied_to_chosen_patient": "{Client} A has carers listed for them. Those carers will be copied to the chosen {client}, if you choose to merge.",
            "patient_B_has_carers_those_will_be_copied_to_chosen_patient": "{Client} B has carers listed for them. Those carers will be copied to the chosen {client}, if you choose to merge.",
            "differences_in_the_details_for_the_patient_records_are": "Differences in the details for the {client} records are",
            "highlighted": "highlighted",
            "in_the_above_table": "in the above table.",
            "keeping_patient_A": "Keeping {Client} A",
            "if_details_for_patient_A_correct_you_should_keep_Patient_A_merge_all_from_B_to_A_delete_B": "If the user details for {Client} A are correct, you should keep {Client} A. This will merge all existing {requests}, proxies, and carers, from {Client} B in to {Client} A. This will also then delete {Client} B.",
            "keep_patient_A": "Keep {Client} A",
            "keeping_patient_B": "Keeping {Client} B",
            "if_details_for_patient_B_correct_you_should_keep_Patient_A_merge_all_from_A_to_B_delete_A": "If the user details for {Client} B are correct, you should keep {Client} B. This will merge all existing {requests}, proxies, and carers, from {Client} A in to {Client} B. This will also then delete {Client} A.",
            "keep_patient_B": "Keep {Client} B",
            "merge_patients": "Merge {Clients}",
            "merge_patients_confirmation_text": "You are about to merge these two {client} records. Are you sure you want to continue?",
            "patient_records_have_been_merged": "{Client} records have been merged.",
            "edit_merged_patient_record": "Edit merged {client} record",
            "provider_assignment_status": "Status",
            "message_to_patient": "Message to {client}",
            "invite_title": "invite title",
            "invite_message": "invite message",
            "invite_call_to_action": "invite call to action",
            "reminder_title": "reminder title",
            "reminder_message": "reminder message",
            "reminder_call_to_action": "reminder call to action",
            "internal_note": "Internal Note",
            "attach_document": "Attach a document",
            "video_call": "Video Call",
            "edit_codes": "Edit codes",
            "forms": "Forms",
            "form": "Form",
            "url": "URL",
            "form_search": "Form Search",
            "properties": "Properties",
            "form_submitted_successfully": "Form submitted successfully",
            "form_progress_saved": "Form progress saved",
            "couldnt_load_form": "Couldn't load form",
            "fill_in_form": "Fill in form",
            "view_form": "View form",
            "fill_form_blurb": "To help us respond to your {request}, could you please complete the attached form?",
            "await_reply": "Await reply",
            "end_wait": "End wait",
            "start_QA": "Start QA",
            "skip_QA": "Skip QA",
            "assign_to": "Assign to",
            "unassigned": "Unassigned",
            "unassign": "unassign",
            "loading_image": "Loading image ...",
            "downloaded": "Downloaded",
            "remove_image": "Remove image",
            "remove_image_confirmation": "Are you sure you wish to remove this image?",
            "remove_document": "Remove document",
            "remove_document_confirmation": "Are you sure you wish to remove this document?",
            "preparing_download": "Preparing download ...",
            "await_reply_from_patient": "Await reply from {client}",
            "set_waiting": "Set waiting",
            "inform_patient_that_request_is_waiting": "Inform {client} that the {request} has been set to waiting",
            "if_no_reply_return_to": "If no reply, return to",
            "current_assignee": "Current Assignee",
            "send_on_date": "Send on date",
            "await_reply_for": "Await reply for",
            "await_reply_until": "Await reply until",
            "if_no_reply_move_to": "If no reply, move to",
            "send_video_request_to": "You are about to send a video request to",
            "send_video_request": "Send Video Request",
            "video_not_enabled": "Video is not currently enabled, possibly because the browser is IE11 or older.",
            "waiting_for_video_to_initialise": "Waiting for video to initialise",
            "waiting_for_patient_to_init_video": "The {client} has not yet joined the call.  You can work on other cases and we will notify you when the {client} has arrived.",
            "request_details": "{request} Details",
            "patient_details": "{Client} Details",
            "client_details": "{Client} Details",
            "button_override_lock": "Override lock",
            "staff_name": "Staff Name",
            "patient_name": "{Client} Name",
            "patient_phone": "{Client} Phone",
            "alternative_phone": "Alternative Phone",
            "previous_requests": "Previous {requests}",
            "load_previous_requests": "Load previous {requests}",
            "request_locked_by": "{request} is locked by",
            "characters_remaining": "characters remaining",
            "no_preset_messages_available": "No preset messages available",
            "no_forms_available": "No forms available",
            "user_role": "User Role",
            "usual_GP": "Usual GP",
            "away": "away",
            "preferred_site": "Preferred Site",
            "preferred_site*": "Preferred Site *",
            "telephone_number": "Telephone Number",
            "phone_number": "Phone Number",
            "alternative_telephone": "Alternative Telephone",
            "alternative_phone_number": "Alternative Phone Number",
            "invalid_nhs_number": "Invalid NHS/CHI Number",
            "mrs_no_nhs_number": "The {client} has no NHS/CHI number set so it isn't possible to writeback to their record directly. You can edit the {client} details, using the Spine look-up, and then come back and try again. Otherwise you can manually copy the request via your clipboard instead",
            "mrs_no_nhs_number_originator": "The {client} has no NHS/CHI number set so it isn't possible to writeback to their record directly. Only the originating provider can correct the {client} details",
            "mrs_copied_successfully_id": "{Request} copied to record system with ID {id}",
            "mrs_already_copied_successfully_id": "{Request} has already been copied to record system with ID {id}",
            "mrs_copy_initiated": "Writeback to record initiated",
            "mrs_copy_pending": "Writeback to record initiated. Pending ...",
            "mrs_copy_pending_id": "Writeback to record initiated with ID {id}. Pending ...",
            "mrs_copy_pending_already": "There is already a writeback to record pending. You should let that writeback complete before attempting another writeback.",
            "mrs_copy_pending_already_id": "There is already a writeback to record pending with ID {id}. You should let that writeback complete before attempting another writeback.",
            "mrs_failed": "Failed to writeback to record. You may still copy the {request} via your clipboard instead.",
            "mrs_failed_id": "Failed to writeback to record with ID {id}. You may still copy the {request} via your clipboard instead.",
            "mrs_failed_previous": "The previous writeback to record failed. If the issue has been resolved, you can initiate a new writeback to record, or you may copy the {request} via your clipboard instead.",
            "mrs_failed_previous_id": "The previous copy to your medical records system failed with ID {id}. If the issue has been resolved, you can initiate a new copy to your medical records system, or you may copy the {request} via your clipboard instead.",
            "mrs_failed_reason": "The reason reported is:",
            "mrs_timed_out": "Writeback to record timed out.",
            "mrs_existing_pending": "A writeback to record is already pending.",
            "mrs_clear_status": "Clear filing status",
            "failed_filings": "Filing Issues",
            "request_copied_to_clipboard": "{request} copied to clipboard",
            "record_system_integration_type": "Medical Record System integration type",
            "weekly_rota": "Weekly Rota",
            "potential_duplicate_records": "Potential Duplicate Records",
            "created_by": "Created by",
            "service_message": "Service Message",
            "service_message_start_at": "Service Message Start Time",
            "service_message_end_at": "Service Message End Time",
            "overall_rating": "Overall Rating",
            "created_at": "Created At",
            "view_request": "View {request}",
            "title_password_guidance": "Strong Password Guidance",
            "password_guidance1": "Passwords must be at least 8 characters long, and can't be things like “password”, “12345678” or “abcdefgh”.",
            "password_guidance2": "The most important thing is not to use short passwords (we suggest more than 8 characters). Spaces are allowed, so you can use a long phrase of three or four random words. A shorter password with a mix of character types will also work unless it is a very common pattern.",
            "subtitle_user_details": "User Details",
            "shown_to_patients": "shown to {clients}",
            "note_multi_provider_not_yet_editable": "This is a multi-provider staff account. Editing of staff roles, or deletion of the account, is not (yet) available to network administrators.",
            "availability_help_text": "For a staff member to be available for selection in the {client} interface, they must have availability within the next 14 hours, and have <strong>any</strong> availability at the {client}'s selected site. The reason for this is that the staff member can discuss an issue with the {client} online today, because they are available (somewhere), and if it becomes necessary to see the {client} in person, they can make an appointment for when they are next at the {client}'s chosen site.",
            "alert_info_weekly_rota_part1": "Any times entered here will override those entered in the Weekly Rota, above. As an example, if you wish to set a person as only being available for the morning, you can add that specific day below and enter the availability as",
            "alert_info_weekly_rota_part2": "Exceptions override the entire day, but are cumulative, so if a member of staff was going to be unavailable between 11:00 - 14:00, you would enter two availability exceptions below, one for",
            "alert_info_weekly_rota_part3": "and one for",
            "alert_info_weekly_rota_part4": "If you want to set somebody as away for the whole day, simply add the date (or date range) and leave the availability times blank.",
            "alert_info_generic_availability_part1": "Any times entered here will override those entered above. As an example, if you wish to set an item as only being available for the morning, you can add that specific day below and enter the availability as",
            "alert_info_generic_availability_part2": "Exceptions override the entire day, but are cumulative, so if an item was going to be unavailable between 11:00 - 14:00, you would enter two availability exceptions below, one for",
            "alert_info_generic_availability_part3": "and one for",
            "alert_info_generic_availability_part4": "If you want to set an item as unavailable for the whole day, simply add the date (or date range) and leave the availability times blank.",
            "link_more_information": "More information",
            "add_to_home_screen": "Add to home screen",
            "group_can_have_requests_assigned": "Group can have {requests} assigned",
            "members_can_have_requests_assigned": "Members individually can have {requests} and show in dashboard",
            "patients_can_choose_group_members": "{Clients} can choose group members",
            "can_complete_on_behalf_of_another": "Can complete on behalf of another",
            "members": "Members",
            "description": "Description",
            "event_triggered_by": "Event Triggered By",
            "no_properties_specified": "No properties specified",
            "account_status": "Account Status",
            "patient_never_logged_in": "{Client} has never logged in",
            "alert_scope_global": "This scope of this message is global. It can only be edited by {article_app_name} network admin.",
            "alert_scope_organisational": "This scope of this message is organisational. It can only be edited by an administrator.",
            "owner": "owner",
            "ownership": "ownership",
            "set_owner": "set owner",
            "transfer": "transfer",
            "organisational": "Organisational",
            "personal": "Personal",
            "welcome_to": "Welcome to",
            "welcome_to_askmyGP": "Welcome to {app_name}",
            "patient_intro": "Get help from your practice. Ask any time, we respond in working hours.",
            "you_may_add_more_detail_later": "You may add more detail later",
            "is_currently_unavailable_for_online_requests": "is currently unavailable for online requests",
            "is_currently_available_for_some_requests": "is currently offline. You can still access some services. {Requests} will be reviewed when we are next online.",
            "network_is_currently_unavailable_for_online_requests": "Sorry, due to a technical issue with {app_name}, we cannot accept new online {requests} at present. We are hoping the system will be working again soon however, to avoid any delays, please call the surgery and speak to reception so we can respond to your needs.",
            "get_self_help": "Get self help",
            "quick_self_help": "NHS self help",
            "consult_your_GP": "Consult a clinician",
            "login_to_consult_your_GP": "Sign up or login to consult a clinician",
            "do_not_use_in_emergencies": "Do not use in emergency - NHS advice here",
            "the_end_user_licence_agreement": "The end-user licence agreement",
            "end_user_licence_agreement": "End user licence agreement",
            "privacy_policy": "Privacy Policy",
            "characters_left": "characters left",
            "terms_of_use": "Terms of Use",
            "hello": "Hello",
            "you_have_new_messages_in": "You have new messages in",
            "thread": "thread",
            "are_these_details_correct_if_not_contact_your_practice": "Are these details correct? If not contact your {provider_generic_term}",
            "remember_to_click_save_below": "Remember to click Confirm below",
            "your_user_details_were_updated_successfully": "Your user details were updated successfully.",
            "new_request": "New {request}",
            "view_past_requests": "View past {requests}",
            "edit_my_details": "Edit my details",
            "patients_i_care_for": "{Clients} I care for",
            "people_i_care_for": "People I care for",
            "our_service_times": "Our service times",
            "online_consultation_availability": "Online Consultation Availability",
            "when_is_your_GP_working": "When is your clinician available?",
            "offline": "Offline",
            "i_am_asking_as_a": "I am asking as a",
            "parent_or_carer": "Parent or Carer",
            "do_you_have_an_askmyGP_login": "Do you have {article_app_name} login",
            "patients_must_be_registered_at_provider": "{Clients} must be registered at {provider}",
            "sign_up_as_a_new_user": "Sign up as a new user",
            "login_existing_user": "Login existing user",
            "logged_out_successfully": "Logged out successfully",
            "logged_out_automatically_message": "You have been automatically logged out of the {app_name} system due to inactivity",
            "logged_out_manually_message": "You have successfully logged out of the {app_name} system",
            "logged_out_not_logged_in": "To use the {app_name} system you will need to log in to your account",
            "log_back_in": "Log back in",
            "404_not_found": "404 Not Found",
            "page_not_found": "Page not found",
            "not_found": "Not found",
            "sorry_item_requested_not_found_in_system": "Sorry, the item you requested was not found in the system.",
            "return_to_site_index": "Return to the site index",
            "im_sorry_we_cant_find_the_page_you_are_looking_for": "I'm sorry, we can't seem to find the page you are looking for",
            "create_your_password": "Create your password",
            "secure_your_account": "Secure your account by creating a password",
            "reset_your_password": "Reset your password",
            "strong_password_guidance": "Strong Password Guidance",
            "password_reset_email_sent": "Password reset email sent",
            "password_reset_successfully": "Password reset successfully",
            "attach_photo_or_document": "Attach a photo or document?",
            "attach_another_photo_or_document": "Attach another photo or document?",
            "message_updated": "Message updated",
            "new_message": "New message",
            "message_deleted": "Message deleted",
            "sign_up_to": "Sign up to",
            "you_can_do_it_here_and_now_your_email_address_may_be_used_only_once": "You can do it here and now. Your email address may be used only once.",
            "unable_to_register_message": "Unfortunately, you are unable to register with {app_name} because we do not know which practice you wish to register with. Please ensure you follow the link provided on your practice's web site.",
            "please_accept": "Please accept",
            "my_details": "My details",
            "privacy_message_overview": "{app_name} process your personal and health care data on behalf of your {provider_generic_term} which is the data controller.  Anonymised data is used for research and development purposes.  We do not use personal information for marketing purposes.",
            "isabel_checks_symptoms_for_possible_conditions": "Isabel checks symptoms for possible conditions",
            "powered_by_isabel_healthcare": "Powered by Isabel Healthcare",
            "input_placeholder_self_help": "Enter your problem heading (50 characters max)",
            "placeholder_enter_problem_self_help": "Enter problem for self help",
            "no_search_results_found": "No search results found",
            "we_try_to_respond_soon_during_these_hours": "We try to respond soon during these hours",
            "it_helps_us_if_you_send_your_request_on_the_same_day": "It helps us if you send your request on the same day",
            "provider_details": "Provider Details",
            "provider_name": "Provider Name",
            "practice_code": "Practice Code",
            "site_name": "Site name",
            "superuser_gender": "Superuser gender",
            "superuser_forenames": "Superuser forenames",
            "superuser_surname": "Superuser surname",
            "superuser_email": "Superuser email",
            "tooltipRobotName": "The robot name should be constructed so that it looks the same as the provider name. For example: The provider \"Bramley Surgery\" has a Robot forename of \"Bramley\", and a surname of \"Surgery\".",
            "robot_name": "Robot name",
            "robot_forenames": "Robot forenames",
            "robot_surname": "Robot surname",
            "robot_email": "Robot email",
            "leave_blank_to_auto_populate_with": "Leave blank to auto-populate with",
            "click_to_view": "Click to view",
            "copied_to_clipboard": "copied to clipboard",
            "disable_notifications": "Disable Notifications",
            "enable_notifications": "Enable Notifications",
            "DD/MM/YYYY": "DD/MM/YYYY",
            "DD/MM/YYYY-HH-MM": "DD/MM/YYYY HH:MM",
            "video_request_from": "Video request from ",
            "video_request": "Video request",
            "delete_message": "Delete Message",
            "message_will_be_deleted_continue": "This message's content will be deleted. Are you sure you want to continue?",
            "message_content_deleted": "Message content deleted",
            "thread_reopened": "Thread re-opened",
            "delete_request": "Delete {request}",
            "you_are_about_to_delete_request": "You are about to delete {request}",
            "for": "for",
            "are_you_sure_you_want_to_continue": "Are you sure you want to continue?",
            "finish": "Finish",
            "awaiting_reply_then_closed_until": "The practice is awaiting your reply.  If you wish to reply, please do so before {waiting_until} after which the case will be closed.",
            "awaiting_reply_then_reassigned_until": "The practice is awaiting your reply. If you wish to reply, please do so before {waiting_until} after which the case will be returned to {clinician}.",
            "awaiting_reply_then_unassigned_until": "The practice is awaiting your reply. If you wish to reply, please do so before {waiting_until} after which the case will be reviewed again by a member of our team.",
            "completed_message_intro": "Thank you for using the {app_name} service.",
            "completed_message_manual": "We have now completed your {request}.",
            "completed_message_auto": "We had set your {request} to wait to allow you the opportunity to respond should you need to. As there is no response, we have now closed your {request}.",
            "completed_message_auto_custom_action": "Your {request} has completed automatically, and no further action is required.",
            "completed_message_feedback": "You are welcome to leave a comment on our <strong><a href=\"{feedback_link}\">feedback form</a></strong>.",
            "completed_message_feedback_forms": "You are welcome to leave a comment on our feedback form below.",
            "ended_the_wait_state_for_this_request": "{user} ended the wait state for this {request}",
            "set_thread_waiting": "Set thread waiting",
            "wait_ended": "Wait ended",
            "send_message": "Send Message",
            "request_will_go_to_patient_confirmation": "This messages will go to the {client}. Please confirm that you wish to send it?",
            "okay": "Okay",
            "request_updated": "{Request} updated",
            "basic_search": "Basic Search",
            "oldest_on_top": "Oldest on top",
            "newest_on_top": "Newest on top",
            "Male": "Male",
            "Female": "Female",
            "Unspecified": "Unspecified",
            "monday": "monday",
            "tuesday": "tuesday",
            "wednesday": "wednesday",
            "thursday": "thursday",
            "friday": "friday",
            "saturday": "saturday",
            "sunday": "sunday",
            "Claimed": "Claimed",
            "Identified": "Identified",
            "Verified": "Verified",
            "Mr": "Mr",
            "Ms": "Ms",
            "Mrs": "Mrs",
            "Miss": "Miss",
            "Dr": "Dr",
            "Mx": "Mx",
            "skip": "Skip",
            "check": "Check",
            "deleted": "deleted",
            "undefined": "undefined",
            "Parent/Guardian": "Parent/Guardian",
            "Carer": "Carer/Friend/Relative",
            "select": "select",
            "select_clinician": "Select clinician",
            "edit_session_data": "Edit session data",
            "edit_availability": "Edit availability",
            "select_clinician_view_calendar": "Please select a clinician to view their calendar",
            "selected_clinician_has_no_sessions": "The selected clinician doesn't have any appointment sessions",
            "cancel_appointment": "Cancel Booking",
            "appointment_booking": "Appointment Booking",
            "enable_appointment_bookings": "Enable appointment bookings",
            "book_appointment": "Book Appointment",
            "restricted_patient_search": "{Clients}",
            "network_availabile_for_new_requests": "System available for new {requests}",
            "network_up": "System available for providers and {clients}",
            "network_softdown_message": "Sorry, {app_name} is currently offline.  Please try later",
            "network_unavailable_for_new_requests_message": "Sorry, {app_name} is offline for new {requests} at present.  Please try later",
            "network_settings": "Network Settings",
            "capacity_planning": "capacity planning",
            "demand_per_week": "demand per week",
            "typical": "typical",
            "actual": "actual",
            "clinical": "clinical",
            "other": "other",
            "total": "total",
            "capacity_per_session": "capacity per session",
            "sessions": "sessions",
            "save_to_dashboard": "save to dashboard",
            "demand_per_day_as_percent_of_week": "Demand per day as % of week",
            "search_cant_select": "You can't select this item",
            "search_item_already_exists": "Item already exists",
            "search_cant_select_provider_xref": "You can't select the same provider that you are adding the link for.",
            "search_item_already_exists_provider_xref": "A link for this provider already exists.",
            "cant_share_non_verified_user_request": "You can only share/transfer {requests} for {clients} who have an ID status of 'Verified', and have an NHS/CHI number set.",
            "continue_search_in_archive": "Show earlier {requests}",
            "closed_at_range": "Completed between dates",
            "show_available_all_option": "Show Available / All",
            "show_all_waiting": "Show all",
            "show_all": "Show all",
            "show_pending": "Show pending",
            "sms_sent": "An SMS message has been sent to the user on {phone}",
            "sms_smtp_gateway_domain": "SMS SMTP gateway domain",
            "id": "ID",
            "email_verification_text": "A four digit code has been sent to the email address you provided",
            "password_verification_text": "To authorise this change you must verify your password",
            "password_verification_for_email": "When changing your email address, you must also verify your current password",
            "verify": "Verify",
            "verify_client_id": "Verify {client} ID?",
            "tags": "tags",
            "tag": "tag",
            "tag_entries": "Tag Entries",
            "tag_uses": "Tag uses",
            "icon": "Icon",
            "position": "Position",
            "custom_actions": "custom actions",
            "custom_action": "custom action",
            "cohorts": "cohorts",
            "cohort": "cohort",
            "campaigns": "campaigns",
            "campaign": "campaign",
            "campaign_not_found": "Sorry, the campaign you have selected no longer exists.",
            "start_campaign": "start campaign",
            "reset_campaign": "reset campaign",
            "stop_campaign": "stop campaign",
            "campaign_started": "{name} has been started and will begin processing in the next processing run (usually within 10 minute)",
            "campaign_stopped": "{name} has ended",
            "campaign_reset": "Data for {name} has been reset",
            "campaign_reminder_at": "A reminder for {name} has been initiated",
            "start_at": "start at",
            "end_at": "end at",
            "total_users": "total users",
            "invite_sent": "invite sent",
            "reminder_sent": "reminder sent",
            "send_reminder": "send reminder",
            "automatically_assign": "automatically assigned to",
            "AUTOMATED_FORM_SUBMISSION": "Form {form_title} has been successfully submitted by {name}",
            "AUTOMATED_FORM_SAVE": "Form {form_title} has been saved (in progress) by {name}",
            "record_system_test_user_id": "Medical Record System test user ID",
            "mrs_user_id": "Medical Record System User ID",
            "oauth_authorisation": "Authorise Account Access",
            "authorise": "authorise",
            "oauth_requesting_permission": "<strong>{client_name}</strong> is requesting permission to access your account.",
            "oauth_application_abilities": "This application will be able to",
            "oauth_token_can_profile": "View information about your profile",
            "terms_conditions": "Terms & Conditions",
            "terms_message": "To continue using the {app_name} service, you must accept the following licence agreements.",
            "codes": "Codes",
            "consultation": "Consultation",
            "add_code": "Add code",
            "no_codes": "No codes specified",
            "code_header": "Header",
            "code_scheme": "Scheme",
            "code_code": "Code",
            "code_description_id": "Description ID",
            "description_id": "Description ID",
            "code_term": "Term",
            "code_units": "Units",
            "code_value": "Value",
            "code": "Code",
            "blood_pressure": "Blood Pressure",
            "blood_pressure_ranges": "Blood Pressure Ranges",
            "blood_pressure_ranges_help": "When a blood pressure is entered in the coding interface, or via a form field, the values will be compared to these ranges and automatically prioritised as specified.",
            "blood_pressure_ranges_and_or": "To enter a range that will match either diastolic or systolic, set the relationship to <em>OR</em>. To enter a range that will match both diastolic and systolic together, set the relationship to <em>AND</em>.",
            "blood_pressure_professional": "Please note: It is recommended that blood pressure ranges are set or updated by appropriately qualified clinicians",
            "blood_pressure_warning_title": "Blood Pressure Settings Changed",
            "blood_pressure_warning_text": "You are about to make changes to an existing blood pressure range and the automatic prioritsation of {requests}. Are you sure you want to continue?",
            "add_blood_pressure": "Add blood pressure",
            "add_blood_pressure_range": "Add blood pressure range",
            "no_blood_pressures": "No blood pressures specified",
            "no_blood_pressure_ranges": "No blood pressure ranges specified",
            "systolic": "Systolic",
            "diastolic": "Diastolic",
            "min": "min",
            "max": "max",
            "term": "Term",
            "unit": "Unit",
            "value": "Value",
            "code_descriptive_text": "Descriptive text",
            "attachments": "Attachments",
            "session_saved_for_later": "Your current submission progress has been safely saved in your browser, so if you use the same browser when your practice re-opens for {request} submissions, you will be prompted to recover your saved {request} and continue with your submission.",
            "recover_in_progress_qa_title": "Continue draft {request}",
            "recover_in_progress_qa_text": "You have a draft {request} submission saved. Would you like to continue with the draft?",
            "save_qa": "Save progress",
            "dont_save_qa": "Don't save progress",
            "continue_qa": "Continue editing",
            "recover_in_progress_form_title": "Continue draft form",
            "recover_in_progress_form_text": "You have a draft version of this form saved. Would you like to continue with the draft?",
            "not_authorised_to_search_snomed": "You are not authorised to search SNOMED codes",
            "who_is_this_service_for": "Who is this service for?",
            "custom_action_not_found": "Custom action not found.",
            "allow_when_closed": "Allow when closed",
            "content_requests_submit_someone_else_visible": "The content of {requests} you submit for someone else are visible to that person.",
            "number_open_requests_for_patient": "Number of open {requests} for this {client}",
            "no_session_types_found": "No sessions types found",
            "no_sessions_found": "No sessions found",
            "no_availibility_exceptions_found": "No availability exceptions found",
            "preview": "Preview",
            "colour": "Colour",
            "use": "Use",
            "search_min_3_characters": "Search (minimum 3 characters)",
            "problem": "Problem",
            "history": "History",
            "examination": "Examination",
            "family_history": "Family History",
            "social": "Social",
            "procedure": "Procedure",
            "attachments_auto_copy_to_record_system": "These attachments will also be included in the writeback to record:",
            "notification_updated_successfully": "updated successfully",
            "notification_created_successfully": "created successfully",
            "notification_deleted_successfully": "deleted successfully",
            "you_are_about_to_remove_access_to_provider_account_for": "You are about to remove access to your {app_name} provider account for",
            "shared_transferred": "Shared/Transferred",
            "transferred": "Transferred",
            "demand_capacity_updated_success": "Demand and capacity updated successfully",
            "set_followup_for_request_at": "{user} set a follow up for this {request} at {waiting_until}",
            "assigned_request_to": "assigned {request} to",
            "removed_follow_up_for_request": "{user} removed the follow up for this {request}.",
            "set_request_to_wait_until": "{user} set this {request} to wait until {waiting_until}",
            "custom_action_type": "Custom action type",
            "submission_message": "Submission message (sent to the user when the form is submitted and the new {request} is created)",
            "automatically_share_requests_with": "Automatically transfer the new {request} to",
            "when_shared_completes_automatically_or_autocompletes_writeback_with_user": "When transferred {requests} are completed, or {requests} are auto-completed, automatically writeback using",
            "when_transferred_request_completes_automatically_writeback": "When the transferred {request} is completed, automatically writeback",
            "do_not_automatically_writeback": "Do not automatically writeback",
            "user_selectable": "Action is user selectable (appears as a custom button in the {client} application)",
            "autocomplete_custom_action": "Automatically complete action when form is submitted",
            "autocomplete_custom_action_info": "Automatic completion is always overriden when the {request} is prioritised above 'Routine'. {Requests} can be prioritised via forms either explicity (AMGFLAG) or implicity via Blood Pressure readings (AMGBP)",
            "none": "None",
            "automatically_assign_requests_to": "Automatically assign {requests} to",
            "do_not_automatically_assign": "Do not automatically assign",
            "do_not_automatically_transfer": "Do not automatically transfer",
            "automatically_tag_requests_as": "Automatically tag {requests} as",
            "search_for_a_tag": "Search for a tag",
            "no_results": "No Results",
            "you_have": "You have",
            "view_messages": "View messages",
            "view_all_prev_requests": "View all previous {requests}",
            "nhs_covid": "NHS advice on Coronavirus (COVID-19)",
            "at": "at",
            "third_party_apps_account_access": "Third party apps with account access",
            "oauth_revoke_access": "Revoke account access",
            "remove_access": "Remove access?",
            "remove_access_confirmation": "{client} will no longer have access to your {app_name} account. You’ll need to grant access if you want to use this app or service again.",
            "include_internal_messages": "Include internal messages",
            "include_internal_messages_when_copying": "Default to including internal messages in copy/writeback?",
            "include_datetime_when_copying": "Include date/time for messages in copy/writeback?",
            "messages_thread": "Messages thread",
            "introduction": "Introduction",
            "select_service": "Select service",
            "profile_details": "Profile details",
            "register_proxy": "Register proxy",
            "select_caree": "Select caree",
            "staff_availability": "Staff availability",
            "oauth": "oauth",
            "terms": "terms",
            "profile_edit": "Profile Edit",
            "user_import": "user import",
            "user_imports": "user imports",
            "new_users": "new users",
            "existing_users": "existing users",
            "bad_data_users": "users with bad data",
            "in_other_provider_users": "existing users in other providers",
            "test_email_sent_to": "Test email sent to {email}",
            "egl_app_paired": "EGL {client} app paired",
            "has_nhs_login": "{Client} has NHS login",
            "user_csv_file": "User CSV file",
            "uploaded_file": "Uploaded file",
            "download_csv": "Download CSV",
            "open_menu": "Open Menu",
            "close_menu": "Close Menu",
            "priority": "Priority",
            "priority_20": "Emergency",
            "priority_10": "Urgent",
            "priority_5": "Visit Request",
            "priority_0": "Routine",
            "priority_-10": "Lower",
            "creating_new_message_title": "Creating new message thread",
            "add_attachment_to_message": "Add attachment to message",
            "relation_and": "AND",
            "relation_or": "OR",
            "provider_new_request_intro_text": "Select a pathway below to record the {request} details. Or, use the text box at the bottom to send a message to {client}/add an internal note:",
            "duration_in_minutes": "duration (minutes)",
            "email_verification_code": "Please enter the code below",
            "change_email_address": "Change email address",
            "verify_email_address": "Verify email address",
            "up_to_date": "You are all up to date",
            "someone_else": "Someone else",
            "branding": "Branding",
            "custom_css": "Custom CSS",
            "logo": "Logo",
            "current_logo": "Current logo",
            "remove_current_logo": "Remove current logo",
            "custom_brand_files": "Upload brand files",
            "custom_brand_info_files": "Custom files to include for branding. Can include image files [jpeg, jpg, png, svg], JavaScript source files [js], and/or CSS files [css].",
            "custom_brand_info_auto_include": "Note that CSS and JS files are included automatically once the user has logged in. Image files will need referencing from the CSS files that you upload (using the full URL branding path).",
            "existing_files": "Existing files",
            "filename": "filename",
            "video_request_message": "You have a video request on {app_name}. Log in to view it at {link}",
            "you_have_a_new_message": "You have a new message on {app_name}",
            "unable_to_send_message": "Unable to send message",
            "incomplete_message_unsent_completion": "You have an incomplete message pending (attachment without an accompanying message). Please add a message, or remove the attachment, before sending or completing.",
            "incomplete_message_unsent": "You have to include some message text to accompany your attachment(s).",
            "migration_in_progress": "Migration in progress",
            "migration_in_progress_notice": "Data for your {client} record is currently being migrated between providers, and will be unavailable until the migration completes. Please try again later, or contact your provider if you urgently need to review information contained in a {request} that is older than 3 months old. Thank you for your patience.",
            "migration_in_progress_notice_provider": "Data for this {client} record is currently being migrated between providers, and will be unavailable until the migration completes. Please try again later. Thank you for your patience.",
            "provider_url": "Provider URL",
            "provider_url_help": "The provider domain starts with either <code>provider</code> or <code>nhs</code> and is used to generate all the links to both the provider and {client} (<code>my</code>) applications. Do not change this if you do not know what you are doing. The provider URL for the current domain (that you are using to view the network admin application) is: <code>{default_provider_url}</code>",
            "untagged_requests": "Untagged {requests}",
            "include_extended_field_data": "Include extended field data in plain text form output?",
            "training": "training",
            "form_type": "form type",
            "feedback_form": "feedback form",
            "ios_video_breakout_link_pre": "Having difficulty viewing videos?",
            "ios_video_breakout_link": "Open {app_name} in a separate browser.",
            "linked_account_password_information": "Your account is linked to the Evergreen Life app. Changing your password here will not update it in the app. To keep your password in sync, please log in to the Evergreen Life app and change your password there, then you can use the new password on the website as well.",
            "linked_account_password_information_unknown": "If you use both the website and the Evergreen Life app, please note that changing your password here will not update it in the app. To keep your password in sync, please log in to the Evergreen Life app to change your password there, and then you can use the updated password on the website.",
            "default_internal_message": "Default to internal message",
            "message_view": "Message view (for form data)",
            "message_view_plain": "plain",
            "message_view_table": "table",
            "message_view_stacked": "stacked",
            "message_view_list": "list",
            "message_settings": "Message settings",
            "add_filter": "Add filter",
            "no_filters": "No filters specified",
            "patient_availability_filter": "patient availability filters",
            "operand": "operand",
            "keywords": "keywords",
            "keywords_for_signposting": "keywords for signposting",
            "keywords_help": "A comma separated list of keywords. Keywords are interpreted as regular expressions when surrounded by '/' characters (for example: <code>/co(rona&#124;vid)/</code>)",
            "signpost_title": "Based on your request, we have identified the following options:",
            "signpost_continue_existing": "Or to continue to get general help, if none of the above options match, click 'Next'",
            "update_completion_method": "update request resolution",
            "user_global": "access this preset message at all providers you are a member of?",
            "all_providers": "all providers",
            "default_writeback_user": "default writeback user"
        },
        "passwords": {
            "password": "Passwords must be at least eight characters.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token has expired. <a href=\"RESET_LINK\">Request a new token</a>",
            "user": "We can't find a user with that e-mail address."
        },
        "auth": {
            "failed": "Email or password does not match our records. Try \"Forgotten Password\" below.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "emails": {
            "welcome_to_app_from": "Welcome to {app_name} from",
            "please_login_now": "Please login now.",
            "account_created_choose_password_and_login": "Ensure you are within a secure NHS network to login and create your password.",
            "set_your_login": "Set your {app_name} login",
            "if_login_expired": "If the above link has expired, click to login at",
            "if_login_created_may_request_new_link": "If your login has been created, you may request a new link from \"Forgotten Password\"",
            "kind_regards": "Kind regards",
            "app_on_behalf_of": "{app_name} on behalf of",
            "do_not_reply_responses_not_monitored": "Do not reply to this email, as responses are not monitored.",
            "always_use_secure_service_to_message": "Always use the secure {app_name} service to send messages.",
            "create_your_new_app_password": "Create your new {app_name} password",
            "patient_welcome_message": "Welcome to {app_name}. You are now approved for faster, easier access to your own GP.",
            "create_new_password": "Create new password",
            "with_login_you_can_request_help_welcome_message": "With your secure login you can request help for any medical problem. You can ask for yourself or someone you care for, so long as the {client} is registered at the practice. In working hours we respond promptly, out of hours we respond on the next working day.",
            "please_use_app_for_all_enquiries": "Please use {app_name} for all future enquiries and help us to help you.",
            "sent_you_a_message": "sent you an {app_name} message",
            "click_to_login_do_not_reply": "Click below to login and see your message. Do not reply to this email, as responses are not monitored. Always use the secure {app_name} service to send messages.",
            "do_not_reply_always_use_secure_askmygp_to_message": "Do not reply to this email as responses are not monitored.  Always use the secure {app_name} service to send messages.",
            "see_my_message": "See message",
            "open_message_with_egl_app": "Open message in Evergreen Life app",
            "open_message_with_web_app": "Open message in browser",
            "you_have_a_message": "You have a message on {app_name}",
            "regards": "Regards",
            "security_notice": "Security Notice",
            "security_notice_from": "This is a security notice from",
            "message": "Message",
            "app_password_reset": "{app_name} password reset",
            "set_password": "Set Password",
            "link_will_expire": "This link can be used once and will expire after 24 hours.",
            "password_reset_request": "Someone asked to reset the password for the {app_name} account registered to ",
            "no_changes_yet_click_reset_pass": "No changes have been made yet. Click the button below to reset your password.",
            "did_not_request_no_action_required": "If you did not request a password reset, you can ignore this email: no further action is required. Please do not reply to this email, as responses are not monitored.",
            "find_out_more": "Find out more",
            "you_can_download_our_app": "You can now download our app"
        },
        "security": {
            "not_authorised_to_list_feedback": "You are not authorised to list feedback.",
            "not_authorised_to_view_feedback_items": "You are not authorised to view feedback items.",
            "not_authorised_to_view_this_feedback": "You are not authorised to view this feedback item.",
            "not_authorised_to_delete_feedback": "You are not authorised to delete feedback items.",
            "not_allowed_view_messages": "You are not allowed to view messages.",
            "not_allowed_view_messages_from_another_provider": "You are not allowed to view messages from another provider.",
            "not_allowed_view_messages_from_this_request": "You are not allowed to view messages from this {request}.",
            "attempting_to_access_another_users_message": "Attempting to access another users message.",
            "attempting_to_access_another_provider": "Attempting to access another provider.",
            "not_permitted_to_view_messages_in_this_thread": "You are not permitted to view the messages in this thread.",
            "patients_not_allowed_post_internal_messages": "{Clients} are not allowed to post internal messages.",
            "not_able_top_post_messages_until_provider_response": "Sorry, you're not able to post messages until you have had a response from your provider.",
            "cannot_delete_other_peoples_messages": "You cannot delete other people's messages.",
            "this_is_a_test_please_disregard": "This is a security test. Please disregard.",
            "not_authorised_to_request_video_calls": "You are not authorised to request video calls.",
            "not_authorised_to_send_video_requests_to_this_thread": "You are not authorised to send video requests to this thread.",
            "not_authorised_to_view_this_document": "You are not authorised to view this document.",
            "not_authorised_to_view_documents": "You are not authorised to view documents.",
            "permission_denied_to_delete_message_documents": "You do not have permission to delete message documents.",
            "message_to_closed_request": "This {request} has been closed. If you wish to contact your provider again, please start a new {request}.",
            "not_authorised_to_view_this_image": "You are not authorised to view this image.",
            "not_authorised_to_view_images": "You are not authorised to view images.",
            "permission_denied_delete_message_images": "You do not have permission to delete message images.",
            "not_authorised_to_view_news_items": "You are not authorised to view news items.",
            "permission_denied_create_news_items": "You do not have permission to create news items.",
            "permission_denied_edit_news_items": "You do not have permission to edit news items.",
            "permission_denied_delete_news_items": "You do not have permission to delete news items.",
            "not_authorised_to_view_user": "You are not authorised to view this user.",
            "practice_code_supplied_does_not_exist": "The practice code supplied does not exist.",
            "permission_denied_update_verification_statuses": "You do not have permission to update verification statuses.",
            "permission_denied_view_subject_access_requests": "You do not have permission to view subject access requests.",
            "permission_denied_merge_patient_accounts": "You do not have permission to merge {client} accounts.",
            "can_only_merge_patients_belonging_to_your_provider": "You can only merge {clients} that belong to your provider.",
            "permission_denied_view_preset_messages": "You do not have permission to view preset messages.",
            "permission_denied_create_preset_messages": "You do not have permission to create preset messages.",
            "permission_denied_edit_preset_messages": "You do not have permission to edit preset messages.",
            "permission_denied_delete_preset_messages": "You do not have permission to delete preset messages.",
            "permission_denied_edit_item": "You do not have permission to edit this item.",
            "permission_denied_delete_item": "You do not have permission to delete this item.",
            "user_not_found_for_preset_message_assignment": "User not found for preset message assignment.",
            "permission_denied_view_tags": "You do not have permission to view tags.",
            "permission_denied_create_tags": "You do not have permission to create tags.",
            "permission_denied_edit_tags": "You do not have permission to edit tags.",
            "permission_denied_delete_tags": "You do not have permission to delete tags.",
            "permission_denied_view_item": "You do not have permission to view this item.",
            "permission_denied_view_custom_action": "You do not have permission to view this item.",
            "permission_denied_create_custom_action": "You do not have permission to create custom actions.",
            "permission_denied_edit_custom_action": "You do not have permission to edit custom actions.",
            "permission_denied_delete_custom_action": "You do not have permission to delete custom actions.",
            "permission_denied_view_cohort": "You do not have permission to view this item.",
            "permission_denied_create_cohort": "You do not have permission to create cohorts.",
            "permission_denied_edit_cohort": "You do not have permission to edit cohorts.",
            "permission_denied_delete_cohort": "You do not have permission to delete cohorts.",
            "permission_denied_view_campaign": "You do not have permission to view this item.",
            "permission_denied_create_campaign": "You do not have permission to create campaigns.",
            "permission_denied_edit_campaign": "You do not have permission to edit campaigns.",
            "permission_denied_delete_campaign": "You do not have permission to delete campaigns.",
            "not_authorised_to_list_logs": "You are not authorised to list logs.",
            "not_authorised_to_view_log_items": "You are not authorised to view log items.",
            "not_authorised_to_view_this_log_item": "You are not authorised to view this log item.",
            "permission_denied_delete_activity_log_entries": "You do not have permission to delete activity log entries.",
            "not_authorised_to_update_provider_details": "You are not authorised to update provider details.",
            "not_authorised_to_update_other_providers": "You are not authorised to update other providers.",
            "not_authorised_to_create_providers": "You are not authorised to create providers.",
            "not_authorised_to_delete_providers": "You are not authorised to delete providers.",
            "not_authorised_to_access_smsp": "You are not authorised to access SMSP.",
            "not_authorised_to_check_duplicate_staff": "You are not authorised to check for duplicate staff members.",
            "not_authorised_grant_access_external_staff": "You are not authorised to grant access to external staff.",
            "not_authorised_to_submit_response_for_thread": "You are not authorised to submit responses to this {request}.",
            "not_authorised_to_view_this_form_subimission": "You are not authorised to view this form.",
            "not_authorised_to_view_this_thread": "You are not authorised to view this thread.",
            "not_authorised_to_assign_threads": "You are not authorised to assign threads.",
            "not_authorised_set_wait_state_on_threads": "You are not authorised to set wait state on threads.",
            "not_authorised_set_follow_up_for_threads": "You are not authorised to set a follow up for threads.",
            "not_authorised_to_prioritise_threads": "You are not authorised to prioritise threads.",
            "not_authorised_to_prioritise_threads_from_other_providers": "You are not authorised to prioritise threads from other providers.",
            "not_authorised_close_threads_you_do_not_own": "You are not authorised to close threads that you do not own.",
            "not_authorised_to_access_this_thread": "You are not authorised to access this thread.",
            "not_authorised_to_reopen_threads_you_do_not_own": "You are not authorised to re-open threads that you do not own.",
            "not_authorised_to_create_threads_on_behalf_of_this_user": "You are not authorised to create threads on behalf of this user.",
            "not_authorised_to_create_threads_on_behalf_of_other_users": "You are not authorised to create threads on behalf of other users.",
            "not_authorised_to_delete_threads": "You are not authorised to delete threads.",
            "not_authorised_to_list_users": "You are not authorised to list users.",
            "not_authorised_to_view_users_from_other_providers": "You are not authorised to view users from other providers.",
            "permission_denied_update_other_user_accounts": "You do not have permission to update other user accounts.",
            "permission_denied_update_non_patient_user_accounts": "You do not have permission to update non-{client} user accounts.",
            "permission_denied_modify_user_roles": "You do not have permission to modify user roles.",
            "permission_denied_create_non_patient_user_accounts": "You do not have permission to create non-{client} user accounts.",
            "permission_denied_add_users_with_roles": "You do not have permission to add users with roles.",
            "permission_denied_add_superusers": "You do not have permission to add superusers.",
            "patients_cannot_be_added_with_roles": "{Clients} cannot be added with roles.",
            "permission_denied_delete_this_user_account": "You do not have permission to delete this user account.",
            "permission_denied_delete_multi_provider_accounts_yet": "You do not have permission to delete multi-provider accounts (yet).",
            "permission_denied_send_emails_to_user_accounts": "You do not have permission to send emails to user accounts.",
            "permission_denied_create_demo_questions": "You do not have permission to create demo questions.",
            "permission_denied_create_demo_questions_for_staff_in_other_providers": "You do not have permission to create demo questions for staff in other providers.",
            "not_authorised_to_list_duplicate_users": "You are not authorised to list duplicate users.",
            "non_staff_user_attempting_access_usergroup_index": "Non staff user attempting to access UserGroup index",
            "permission_denied_view_user_groups": "You do not have permission to view user groups.",
            "permission_denied_edit_user_groups": "You do not have permission to edit user groups.",
            "not_allowed_add_non_staff_users_to_groups": "You are not allowed to add non-staff users to groups.",
            "permission_denied_create_user_groups": "You do not have permission to create user groups.",
            "not_authorised_to_send_video_control_requests_to_this_thread": "You are not authorised to send video control requests to this thread.",
            "permission_denied_delete_appointment": "You do not have permission to delete this appointment.",
            "permission_denied_edit_network_settings": "You do not have permission to edit network settings.",
            "not_authorised_to_set_ownership": "You are not authorised to set the ownership of {requests}",
            "only_owner_can_transfer_ownership": "Only the owner can transfer ownership of a {request}",
            "token_not_found": "New account token not found",
            "not_authorised_to_view_reports": "You are not authorised to view reports."
        },
        "qa": {
            "new": "Is this about a:",
            "sc_new": "New/Existing/Other",
            "about": "Your request in a few words. There is space for more next.",
            "sc_about": "About",
            "about_medication_subject": "The subject line for your query. There is space for more next.",
            "sc_about_medication_subject": "About",
            "how_long": "How long have you had this problem?",
            "sc_how_long": "How long?",
            "symptoms": "Please describe your symptoms and any idea of the cause.\\n What are your concerns today?\\n How would you like us to help?",
            "sc_symptoms": "Symptoms/Cause/Concerns/Expectations",
            "contact_by": "How would you prefer us to resolve your request?",
            "sc_contact_by": "Prefer contact by",
            "call_time": "When would you like us to call?",
            "sc_call_time": "Preferred call time",
            "availability": "Please say when you are free. We will try to fit in.",
            "sc_availability": "Availability",
            "changes": "Please describe any recent changes.\\n What are your concerns today?\\n How would you like us to help?",
            "sc_changes": "Changes/Concerns/Expectations",
            "clinician": "We can't promise, but will do our best if you have a preferred clinician",
            "sc_clinician": "Chosen clinician",
            "appointment_time": "If the doctor decides you need a face to face, do you have a preferred time, normally today?",
            "sc_appointment_time": "Preferred appointment time",
            "like_help_from": "Who would you like help from?",
            "sc_like_help_from": "Would like help from",
            "resolve_by": "How was this request resolved?",
            "sc_resolve_by": "How resolved",
            "if_notes_resolve_by": "If notes were available, I would resolve by:",
            "explain_question": "Please explain your question",
            "sc_explain_question": "Question",
            "explain_medication_query": "Further details of your medication query",
            "sc_explain_medication_query": "Query",
            "completed_by_other": "Was this request completed on behalf of another clinician?",
            "sc_completed_by_other": "Completed by other clinician",
            "completed_behalf_of": "Clinician that the request was completed on behalf of",
            "sc_completed_behalf_of": "Completed on behalf of",
            "option_new_medical_problem": "New medical problem",
            "option_val_new_medical_problem": "New medical problem",
            "option_existing_problem": "Existing problem",
            "option_val_existing_problem": "Existing problem",
            "option_any_other_question": "Any other question",
            "option_val_any_other_question": "Other question",
            "option_medication_query": "Medication query",
            "option_val_medication_query": "Medication query",
            "option_email_message": "Email message",
            "option_val_email_message": "Email message",
            "option_telephone": "Telephone",
            "option_val_telephone": "Telephone",
            "option_called_patient": "Called {client}",
            "option_val_called_patient": "Called {client}",
            "option_telephone_appt_booked": "Telephone appt booked",
            "option_val_telephone_appt_booked": "Telephone appt booked",
            "option_face_to_face_appointment": "Face to face appointment",
            "option_val_face_to_face_appointment": "Face to face appointment",
            "option_asap": "As soon as possible",
            "option_val_asap": "ASAP",
            "option_explain_availability": "I need to explain my availability",
            "option_val_explain_availability": "Explain",
            "option_anyone": "Anyone",
            "option_val_anyone": "Anyone",
            "option_someone_by_name": "Someone by name",
            "option_val_someone_by_name": "Someone by name",
            "option_female_clinician": "Female clinician",
            "option_val_female_clinician": "Female clinician",
            "option_male_clinician": "Male clinician",
            "option_val_male_clinician": "Male clinician",
            "option_message": "Message",
            "option_val_message": "Message",
            "option_face_to_face": "Face to face",
            "option_val_face_to_face": "Face to face",
            "option_abandoned": "Abandoned",
            "option_val_abandoned": "Abandoned",
            "option_admin": "Admin",
            "option_val_admin": "Admin",
            "option_other_clinician": "Other clinician",
            "option_val_other_clinician": "Other clinician",
            "option_anytime_not_urgent": "Any time, not urgent",
            "option_val_anytime_not_urgent": "Any time, not urgent",
            "option_video": "Video",
            "option_val_video": "Video",
            "option_visit": "Visit",
            "option_val_visit": "Visit",
            "option_yes": "Yes",
            "option_val_yes": "Yes",
            "option_no": "No",
            "option_val_no": "No",
            "option_view_online_resources": "View online resources",
            "option_val__view_online_resources": "Launched search",
            "option_continue_to_askmyGP": "Continue to askmyGP",
            "option_val_continue_to_askmyGP": "Continued to askmyGP"
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "validation": {
            "date_after_formatted": "The {attribute} must be after {date}",
            "phone": "The {attribute} field contains an invalid number.",
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, and dashes.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "password": {
                "letters": "The {attribute} field must contain at least one letter.",
                "mixed": "The {attribute} field must contain at least one uppercase and one lowercase letter.",
                "numbers": "The {attribute} field must contain at least one number.",
                "symbols": "The {attribute} field must contain at least one symbol.",
                "uncompromised": "The given {attribute} has appeared in a data leak. Please choose a different {attribute}."
            },
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "custom": {
                "tags_tag_use.required": "Please select at least one use for the tag",
                "forenames.required": "Please enter the forename(s)",
                "surname.required": "Please enter the surname",
                "dob": {
                    "required": "Please enter the date of birth",
                    "after": "Please enter a date of birth after {date}",
                    "date": "Please enter a valid date of birth",
                    "before": "Please enter a valid date of birth",
                    "in": "Date of birth entered does not match the records held by the practice"
                },
                "gender.required": "Please select the gender",
                "provider.site_id.required": "Please select the preferred site",
                "capacity.*.capacity.*": "The capacity must be a whole number, zero or greater",
                "verification_status_id.required": "Please select an ID status",
                "provider.id.required": "Please select a provider",
                "provider.user_role_id.required": "Please select a user role",
                "demand.*.demand.*": "The demand must be a whole number, zero or greater",
                "email.required": "Please enter your email address",
                "phone_number.required": "Please enter your telephone number",
                "postcode.required": "Please enter your postcode",
                "postcode.regex": "Please enter a valid postcode",
                "terms.required": "Please accept the end-user licence agreement",
                "locale.required": "Please select a language",
                "user_relationship_type_id.required": "Please select the type of relationship",
                "site_id.required": "Please select your preferred site",
                "dob.regex": "Please enter date of birth in DD/MM/YYYY format",
                "message.required": "Please type something in the message box",
                "attached_images.*.clamav": "A virus was detected in your file upload. You may want to run an anti virus program on your computer to check for viruses. The upload has been rejected.",
                "attached_images.*": "Your attached image does not seem to be a valid image file (jpg, jpeg and png supported only)",
                "attached_images.*.*.clamav": "A virus was detected in your file upload. You may want to run an anti virus program on your computer to check for viruses. The upload has been rejected.",
                "attached_images.*.*": "Your attached image does not seem to be a valid image file (jpg, jpeg and png supported only)",
                "attached_documents.*.mimetypes": "Your attached document does not seem to be a valid document file (pdf, doc, docx, odt, xls, xlsx, ods supported only)",
                "attached_documents.*.clamav": "A virus was detected in your file upload. You may want to run an anti virus program on your computer to check for viruses. The upload has been rejected.",
                "attached_documents.*.*.mimetypes": "Your attached document does not seem to be a valid document file (pdf, doc, docx, odt, xls, xlsx, ods supported only)",
                "attached_documents.*.*.clamav": "A virus was detected in your file upload. You may want to run an anti virus program on your computer to check for viruses. The upload has been rejected."
            }
        },
        "errors": {
            "too_many_page_requests": "The server is reporting that you are making too many data/page requests. Please wait, and try again later.",
            "data_sending_too_large_rejected": "The server has reported that the data you are sending is too large, and has been rejected. Try using a smaller attachment.",
            "item_requested_not_found_maybe_deleted_by_another": "The item you are requesting has not been found. This could be because it has been deleted by another user.",
            "data_endpoint_not_found": "The data endpoint that you are trying to access has not been found.",
            "an_error_occured_try_again": "An error occurred. Please try again.",
            "security_risk": "The server has detected content that is considered a security risk. If you think this is an error, please report it: <ul><li><a href='mailto:askmyGP@evergreen-life.co.uk?Subject=askmyGP%20user%20report'>askmyGP@evergreen-life.co.uk</a></li></ul>Our security team have been notified of this incident, and your user details, and IP address have been recorded to help us take appropriate action.",
            "unexpected_response_from_server": "An unexpected response was received from the server. If this continues to occur, please notify an administrator.",
            "application_version_too_old": "The version of the application that you are running is out of date. Click the button below to force the application to refresh. If you continue to see this message after a refresh, you may need to try again later.\n        <br /><div style=\"text-align: center\"><button onclick=\"window.location.reload(true)\" class=\"btn btn-primary\">Refresh to use the latest version of the application</button></div>",
            "admin_restricted_patient_not_found": "No {client} found with that ID or email address.",
            "max_websocket_reconnects": "The application is having trouble connecting to the server. Click the button below to force the application to refresh. If you continue to see this message after a refresh, you may need to try again later.\n        <br /><div style=\"text-align: center\"><button onclick=\"window.location.reload(true)\" class=\"btn btn-primary\">Refresh application</button></div>",
            "writeback_max_pending_age_warning": "There are pending filings in your writeback queue that are older than {hours} hours. Please ensure that your filing system is functioning correctly as {requests} will not file into your clinical system until this is addressed. For Systmone practices, check to ensure your poller is running and that Systmone is logged in alongside it. <a target=\"helpdesk\" href=\"https://evergreenlife.freshdesk.com/support/solutions/articles/14000145209-systmone-poller-troubleshooting\">Further guidance can be found here</a>.",
            "writeback_admin_block": "There are pending filings in your writeback queue which are older than {hours} hours. Please ensure that your filing system is functioning correctly, as you will be unable to use the automated writeback feature until this is addressed. You can resolve any issues and then come back and try again. Otherwise, the \"Copy to clipboard\" button below will copy to your clipboard for manual copying in to your records system. Please contact the {app_name} support team via the ‘Help’ button if you require further assistance.",
            "writeback_admin_block_originator": "There are pending filings in the writeback queue for {provider_name} which are older than {hours} hours. This could result in a delay in this {request} filing into their clinical record system. If the {request} is urgent, please contact {provider_name} directly so that they can resolve the issue. Otherwise, this {request} will file to the {client} record once the writeback queue has been cleared by the practice. Please contact the {app_name} support team via the ‘Help’ button if you require further assistance."
        }
    },
    "fr": {
        "translations": {
            "English": "English",
            "Cymraeg": "Cymraeg",
            "is_loading": "est en cours de chargement.",
            "please_be_patient": "Veuillez ne pas rafraîchir votre navigateur.",
            "loading_browser_support_message": "Si l'application ne se charge pas, veuillez vous assurer d'utiliser un navigateur pris en charge - Chrome, MS Edge, Safari (10+) et Firefox.",
            "ie11_heading": "Navigateur non pris en charge.",
            "ie11_message": "Vous essayez d'utiliser askmyGP sur un navigateur non pris en charge. L'application askmyGP prend en charge Chrome, MS Edge, Safari (10+) et Firefox.",
            "ie11_help_link": "Cliquez ici pour obtenir des instructions sur la façon de définir IE11 comme votre navigateur par défaut pour askmyGP.",
            "ie11_password_reset": "Pour réinitialiser votre mot de passe, copiez le lien ci-dessous dans un navigateur pris en charge.",
            "application_failed_to_load": "Désolé, nous avons un problème technique. Veuillez réessayer ultérieurement.",
            "edit_demand_capacity": "Modifier la demande et la capacité du groupe",
            "save": "Enregistrer",
            "cancel": "Annuler",
            "show": "Afficher",
            "hide": "Masquer",
            "login": "Connexion",
            "log_in": "Se connecter",
            "logout": "Se déconnecter",
            "edit": "Modifier",
            "delete": "Supprimer",
            "help": "Aide",
            "edit_patient": "Modifier le patient",
            "send_assign": "Envoyer / Attribuer",
            "sar": "Télécharger l'historique",
            "update": "Mettre à jour",
            "create": "Créer",
            "create_staff": "Créer un membre du personnel",
            "spine_lookup": "Recherche NHS Spine",
            "close": "Fermer",
            "clear": "Effacer",
            "apply": "Appliquer",
            "search": "Rechercher",
            "copy_to_patient_record": "Copier dans le dossier patient",
            "remove_site": "Supprimer le site",
            "add_site": "Ajouter un autre site",
            "add_linked_provider": "Ajouter un fournisseur lié",
            "update_settings": "Mettre à jour les paramètres",
            "view_appointments_calendar": "Afficher le calendrier des rendez-vous",
            "view": "Afficher",
            "add": "Ajouter",
            "remove": "Supprimer",
            "start_video_call": "Démarrer un appel vidéo",
            "advanced_search": "Recherche avancée",
            "create_new_request": "Créer une nouvelle demande",
            "create_new_request_provider": "Nouvelle demande",
            "view_activity": "Voir l'activité",
            "reset_demo_questions": "Réinitialiser les questions de démo",
            "send_welcome_email_password": "Envoyer un e-mail de bienvenue / réinitialisation du mot de passe",
            "reset_password": "Réinitialiser le mot de passe",
            "create_password": "Créer un mot de passe",
            "set_password": "Définir un mot de passe",
            "change_password": "Changer le mot de passe",
            "send_password_reset_link": "Envoyer le lien de réinitialisation du mot de passe",
            "confirm_password": "Confirmer le mot de passe",
            "confirm": "Confirmer",
            "register": "S'inscrire",
            "register_patient": "Enregistrer un patient",
            "add_another_patient": "Ajouter un autre patient",
            "add_another_person": "Ajouter une autre person",
            "next": "Suivant",
            "back": "Retour",
            "prev": "Précédent",
            "previous": "Précédent",
            "email_address": "Adresse e-mail",
            "email": "E-mail",
            "email_or_user_id": "Adresse e-mail ou ID utilisateur",
            "password": "Mot de passe",
            "current_password": "Mot de passe actuel",
            "new_password": "Nouveau mot de passe",
            "forename": "Prénom",
            "first_names": "Prénom(s)",
            "gender": "Sexe",
            "DOB": "Date de naissance",
            "date_of_birth": "Date de naissance",
            "postcode": "Code postal",
            "on": "Activé",
            "off": "Désactivé",
            "yes": "Oui",
            "no": "Non",
            "set_service_availability": "Définir la disponibilité du service",
            "time_requests_return_waiting": "Heure de retour des demandes en attente",
            "set_waiting_days": "Définir la valeur par défaut des jours d'attente",
            "relationship_type": "Type de relation",
            "relationship": "Relation",
            "select_site": "Sélectionner un site",
            "site": "Site",
            "scope_of_message": "Portée du message *",
            "all_sites": "Tous les sites",
            "combined_sites": "Sites combinés",
            "please_select": "Veuillez sélectionner",
            "out_of_hours_requests": "Demandes hors heures d'ouverture",
            "closed_to_new_requests": "Fermé aux nouvelles demandes",
            "availability_until_previous": "Le statut sera pris à partir du jour précédent.",
            "availability_until_previous_help1": "Ce paramètre indique au système comment traiter les demandes soumises entre l'heure de fermeture du jour en cours et l'heure d'ouverture du jour suivant pour lequel une disponibilité est définie.",
            "availability_until_previous_help2": "Lorsqu'aucune heure d'ouverture n'est définie pour un jour, le paramètre sera pris à partir du premier jour précédent où une disponibilité a été définie.",
            "availability_until_previous_help3": "Par exemple, si ni le samedi ni le dimanche n'ont d'horaires de disponibilité définis, la disponibilité du service sera prise à partir du vendredi et appliquée aux deux jours jusqu'à la période précédant l'ouverture du lundi suivant.",
            "availability_until_previous_help4": "Si vous souhaitez simplement mettre le système hors ligne temporairement, utilisez le paramètre de disponibilité global ci-dessus.",
            "global": "Global",
            "is": "est",
            "is_not": "n'est pas",
            "contains": "contient",
            "does_not_contain": "ne contient pas",
            "field": "Champ",
            "NHS_spine": "NHS Spine",
            "current": "Actuel",
            "NHS_number": "Numéro NHS/CHI",
            "provider_code": "Code du fournisseur",
            "title": "Titre",
            "surname": "Nom de famille",
            "forenames": "Prénom(s)",
            "phone": "Téléphone",
            "address_line_1": "Adresse ligne 1",
            "address_line_2": "Adresse ligne 2",
            "address_line_3": "Adresse ligne 3",
            "address_line_4": "Adresse ligne 4",
            "address_line_5": "Adresse ligne 5",
            "day": "Jour",
            "predicted_demand": "Demande prévue",
            "in_hours_service_times": "Heures de service",
            "service_until_next_opening": "Service jusqu'à la prochaine ouverture",
            "day_of_week": "Jour de la semaine",
            "availability": "Disponibilité",
            "unavailable": "Indisponible",
            "capacity_requests": "Capacité (demandes)",
            "date": "Date",
            "session": "Session",
            "max_book_ahead_time": "Délai de réservation maximal",
            "min_book_ahead_time": "Délai de réservation minimal",
            "appointments_interval": "Intervalle entre les rendez-vous",
            "session_name": "Nom de la session",
            "start_date": "Date de début",
            "end_date": "Date de fin",
            "actions": "Actions",
            "digital_triage": "Triage numérique",
            "request_solved_by_mode": "Demande de médecin généraliste résolue par mode",
            "other_clinician": "Autre clinicien",
            "admin": "Administrateur",
            "no_availability": "Pas de disponibilité",
            "message": "message",
            "telephone": "Téléphone",
            "face_to_face": "En personne",
            "GP": "Médecin (GP)",
            "total_requests": "Demandes totales",
            "min_request": "Minutes/demande",
            "total_minutes": "Minutes totales",
            "is_proxy_for": "Est un mandataire pour",
            "in_care_of": "Sous la responsabilité de",
            "average_consult_time_min": "Temps moyen de consultation (en minutes)",
            "name_of_session": "Nom de la session",
            "7_days": "7 jours",
            "15_mins": "15 minutes",
            "no_standard_availability": "Aucune disponibilité standard trouvée",
            "none_listed": "Aucun répertorié",
            "enter_only_one": "Entrez une seule valeur",
            "see_settings_groups": "Voir aussi Paramètres > Groupes pour vous assurer une appartenance correcte",
            "tooltip_one_field_is_enough": "La date de naissance fonctionne mieux seule",
            "news_and_updates": "Actualités et mises à jour",
            "create_new": "Créer un nouveau",
            "settings": "Paramètres",
            "reports": "Rapports",
            "diagnostics": "Diagnostics",
            "digital_triage_results": "Résultats du triage numérique",
            "update_your_details": "Mettez à jour vos coordonnées",
            "register_for_account": "Inscrivez-vous pour un compte",
            "self_help": "Auto-assistance",
            "service_times": "Horaires du service",
            "service_status": "Statut du service",
            "messages": "Messages",
            "sites": "Sites",
            "availability_exceptions": "Exceptions de disponibilité",
            "appointment_settings": "Paramètres de rendez-vous",
            "appointment_session_types": "Types de session de rendez-vous",
            "appointment_sessions": "Sessions de rendez-vous",
            "booking_availability": "Disponibilité de réservation",
            "select_relationship": "Sélectionner une relation",
            "staff_login_to": "Connexion du personnel à",
            "link_forgotten_password": "Mot de passe oublié ?",
            "forgotten_password": "Mot de passe oublié",
            "password_reset_sucess_message": "Votre mot de passe a été réinitialisé avec succès. Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",
            "password_reset_email_sent_message": "Un e-mail de réinitialisation du mot de passe a été envoyé à votre adresse e-mail, si elle est enregistrée. Veuillez suivre les instructions de l'e-mail pour réinitialiser votre mot de passe.",
            "home": "Accueil",
            "dashboard": "Tableau de bord",
            "request": "Demande",
            "requests": "Demandes",
            "patients": "Patients",
            "accounts": "Nghyfrif",
            "staff": "Personnel",
            "appointments": "Rendez-vous",
            "my_profile": "Mon profil",
            "profile": "Profil",
            "preset_messages": "Messages prédéfinis",
            "preset_message_search": "Recherche de messages prédéfinis",
            "patient_search": "Recherche de patients",
            "news_items": "Actualités",
            "log_entries": "Entrées de journal",
            "feedback_entries": "Commentaires",
            "staff_members": "Membres du personnel",
            "user_groups": "Groupes d'utilisateurs",
            "duplicate_patients": "Patients en double",
            "manage_duplicates": "Gérer les doublons",
            "groups": "Groupes",
            "system": "Système",
            "system_logs": "Journaux",
            "guide": "Guide",
            "feedback": "Commentaires",
            "send_feedback": "Envoyer des commentaires",
            "patient_feedback": "Commentaires des patients",
            "news": "Actualités",
            "version": "Version",
            "demand_and_capacity": "Demande et capacité",
            "filtered": "filtré",
            "filter": "filtrer",
            "show_all_clinicians": "afficher tous les cliniciens",
            "new": "Nouveau",
            "assigned": "Attribué",
            "assigned_now": "Attribué (maintenant)",
            "assigned_today": "Attribué jusqu'à présent aujourd'hui",
            "share": "Partager",
            "shared": "partagé",
            "stop_share": "Annuler le partage",
            "assigned_to": "Attribué à",
            "assigned_to_me_or_my_groups": "Attribué à moi ou à mes groupes",
            "waiting_for_patient_assigned_to_me_or_my_groups": "En attente du patient, attribué à moi ou à mes groupes",
            "include": "Inclure",
            "waiting_for_patient": "En attente du patient",
            "new_today": "Nouveau aujourd'hui",
            "completed_today": "Complétés aujourd'hui",
            "today": "Aujourd'hui",
            "copy": "Copier",
            "copy_to_clipboard": "Copier dans le presse-papiers",
            "copy_rs": "Copier dans le système de dossier",
            "copy_rso": "Copier dans le système de dossier du fournisseur d'origine",
            "copy_and_transfer": "Copier et transférer",
            "copy_and_transfer_rs": "Copier dans le système de dossier et transférer",
            "skip_and_transfer": "Ignorer et transférer",
            "copy_and_transfer_message": "Si nécessaire, copiez dans votre dossier avant le transfert",
            "wait_and_transfer_message": "Si nécessaire, vous pouvez définir le message en attente de réponse avant le transfert",
            "copy_and_share": "Copier et partager",
            "copy_and_share_rs": "Copier dans le système de dossier et partager",
            "skip_and_share": "Ignorer et partager",
            "copy_and_share_message": "Si nécessaire, copiez dans votre dossier avant le partage",
            "wait_and_share_message": "Si nécessaire, vous pouvez définir le message en attente de réponse avant le partage",
            "thread_originated_at": "Originaire de",
            "shared_with": "Partagé avec",
            "set_follow_up": "Définir un suivi",
            "cancel_follow_up": "Annuler le suivi",
            "re-open": "Réouvrir",
            "send": "Envoyer",
            "now": "Maintenant",
            "waiting": "En attente",
            "clinician": "Clinicien",
            "clinician_group": "Personne/Groupe",
            "team": "Équipe",
            "network": "Réseau",
            "completed": "Complété(s)",
            "mine": "Le(s) mien",
            "closed": "Fermé(s)",
            "archived": "Archivé(s)",
            "capacity": "Capacité",
            "complete": "Terminé(s)",
            "born": "Né",
            "address": "Adresse",
            "emergency": "Urgence",
            "urgent": "Urgent",
            "routine": "Routine",
            "visit_request": "Demande de visite",
            "elevated": "Élevé",
            "lower": "Inférieur",
            "download": "Télécharger",
            "wrote": "a écrit",
            "create_follow_up": "Créer un suivi",
            "requestID": "ID de demande",
            "name": "Nom",
            "month": "Mois",
            "year": "Année",
            "group": "Groupe",
            "user_not_assigned_to_any_groups": "Cet utilisateur n'est assigné à aucun groupe.",
            "all": "Tous",
            "provider": "Fournisseur",
            "providers": "Fournisseurs",
            "forename(s)": "Prénom(s)",
            "alias": "Alias, affiché aux patients",
            "IDStatus": "Statut de l'ID",
            "patientID": "ID du patient",
            "age": "Âge",
            "comment": "Commentaire",
            "profession": "Profession",
            "gpad_profession": "Groupe professionnel",
            "scope": "Portée",
            "content": "Contenu",
            "updated": "mis à jour",
            "estimated_capacity": "capacité estimée",
            "so_far_today": "Jusqu'à présent aujourd'hui",
            "filter_no_users_found": "Aucun utilisateur trouvé pour le filtre sélectionné actuellement.",
            "patient_read_all": "Le patient a lu tous les messages",
            "new_message_patient_read_all": "Nouveau message et le patient a lu tous les messages",
            "patient_unread": "Le patient a une réponse non lue",
            "new_message_patient_unread": "Nouveau message et le patient a une réponse non lue",
            "unread_message": "message non lu",
            "unread_messages": "Messages non lus",
            "phone_and_email": "Téléphone et e-mail",
            "requested_GP": "Médecin (GP) demandé",
            "demo_mode": "Mode démo",
            "demo_create_50_reqests_message": "Si le mode démo est activé, le superutilisateur aura 50 demandes de démo créées pour lui, veuillez donc patienter lorsque vous cliquez sur \"créer\".",
            "service_availability": "Disponibilité du service",
            "video_available": "Vidéo disponible",
            "video_enabled": "Vidéo activée",
            "appointment_booking_enabled": "Rendez-vous activés",
            "clinician_gender_selection_enabled": "Sélection du sexe du clinicien activée",
            "campaigns_enabled": "Campagnes activées",
            "list_size": "taille de la liste",
            "practice_type": "Type de cabinet",
            "practice_status": "Statut du cabinet",
            "provider_type": "Type de fournisseur",
            "patient_link": "Lien du patient",
            "no_items_found": "Aucun élément trouvé",
            "qa_in_progress": "QA EN COURS :",
            "no_subject": "pas de sujet",
            "subject_id": "ID du sujet",
            "causer_id": "ID du déclencheur",
            "item_id": "ID de l'élément",
            "user_id": "ID de l'utilisateur",
            "set_default_language": "Définir la langue par défaut",
            "language": "Langue",
            "update_filter_options": "Mettre à jour les options de filtre",
            "read": "Lu",
            "how_was_this_request_resolved?": "Comment cette demande a-t-elle été résolue ?",
            "session_times": "Horaires des sessions",
            "no_sessions_available": "Aucune session disponible",
            "no_appointments_available": "Il n'y a actuellement aucun rendez-vous disponible. Cliquez sur \"retour\" et sélectionnez un autre jour.",
            "choose_appointment_day": "Veuillez choisir le jour le plus proche qui vous convient",
            "choose_appointment_time": "Choisissez un horaire pour votre rendez-vous",
            "change_booking": "Modifier la réservation",
            "availability_of_the_service": "Disponibilité du service",
            "default_language": "Langue par défaut",
            "history_from_patient": "Historique du patient",
            "date_of_birth_copied_to_clipboard": "Date de naissance copiée dans le presse-papiers",
            "no_site_specified": "Aucun site spécifié",
            "unsaved_changes_title": "Modifications non enregistrées",
            "unsaved_changes_text": "Vous avez des données non enregistrées qui seront perdues si vous quittez cette page. Êtes-vous sûr de vouloir continuer ?",
            "incomplete_qa_text": "Vous avez une vérification QA en cours incomplète qui sera perdue si vous quittez cette page. Êtes-vous sûr de vouloir continuer ?",
            "incomplete_qa_text_saved": "Vous avez une vérification QA en cours incomplète. Nous essaierons de sauvegarder votre progression de manière sécurisée dans ce navigateur afin que vous puissiez poursuivre la vérification plus tard. Êtes-vous sûr de vouloir continuer ?",
            "thread_created_by_staff": "Cette demande a été créée par un membre du personnel.",
            "thread_created_by_proxy": "Cette demande a été créée par un mandataire.",
            "assigned_thread_to": "demande attribuée à",
            "user_set_priority_to": "{user} a défini la priorité sur {priority}",
            "form_set_priority_to": "Forme '{form}' définie avec la priorité {priority}",
            "blood_pressure_range_set_priority_to": "Plage de tension artérielle définie avec la priorité {priority}",
            "user_assigned_thread_to": "{user} a attribué la demande à {to}",
            "shared_thread_with": "demande partagée avec",
            "user_shared_thread_with": "{user} a partagé la demande avec {provider}",
            "unshared_thread_with": "arrêt de partage avec",
            "user_unshared_thread_with": "{user} a arrêté de partager avec {provider}",
            "transferred_ownership_of_thread_to": "transfert de propriété du fil à",
            "user_transferred_ownership_of_thread_to": "{user} a transféré la propriété du fil à {provider}",
            "set_thread_as_unassigned": "définir la demande comme non assignée",
            "user_set_thread_as_unassigned": "{user} a défini la demande comme non assignée",
            "completed_this_request": "{user} a terminé cette demande",
            "autocomplete_request_timeout": "Cette demande a été automatiquement clôturée après une attente.",
            "autocomplete_request_custom_action": "Cette demande a été automatiquement clôturée car elle a été créée à partir d'une action personnalisée avec autocomplétion activée.",
            "re-opened_this_request": "{user} a réouvert cette demande",
            "closed_response_to_patient": "Merci, le service est actuellement fermé pour les demandes askmyGP. Nous avons bien reçu la vôtre et nous vous répondrons lorsque le service rouvrira. Assurez-vous de lire les e-mails provenant de no-reply@askmygp.uk. Veuillez avoir votre téléphone à portée de main car nous pourrions avoir besoin de vous appeler. Les appels peuvent être enregistrés à des fins de formation, de surveillance et d'audit.",
            "open_service_response_to_patient": "Merci, le service est ouvert et nous vous répondrons dès que possible. Assurez-vous de lire les e-mails provenant de no-reply@askmygp.uk. Veuillez avoir votre téléphone à portée de main car nous pourrions avoir besoin de vous appeler. Les appels peuvent être enregistrés à des fins de formation, de surveillance et d'audit.",
            "duplicate_patient_details": "Détails du patient en double",
            "considerations": "Considérations",
            "consider_the_following_before_merging": "Vous devez prendre en compte les points suivants concernant les deux dossiers de patients avant de les fusionner",
            "both_patient_accounts_active_and_logged_in": "Les deux comptes de patients sont actifs et ont été utilisés par le patient pour se connecter. Vous pouvez consulter le patient pour savoir quel compte il/elle souhaite conserver.",
            "patient_A_active_used_by_patient_to_login": "Le patient A est actif et a été utilisé par le patient pour se connecter.",
            "patient_B_active_used_by_patient_to_login": "Le patient B est actif et a été utilisé par le patient pour se connecter.",
            "both_patient_accounts_email_set_neither_logged_in": "Les deux comptes du patient ont une adresse e-mail définie, bien que aucun des comptes n'ait été utilisé pour se connecter activement.",
            "patient_A_email_set_not_logged_in": "Le patient A a une adresse e-mail définie, il est donc possible pour le patient de se connecter à ce compte, bien qu'il/elle ne l'ait pas encore fait.",
            "patient_B_email_set_not_logged_in": "Le patient B a une adresse e-mail définie, il est donc possible pour le patient de se connecter à ce compte, bien qu'il/elle ne l'ait pas encore fait.",
            "neither_account_has_email": "Aucun des comptes n'a d'adresse e-mail et n'a donc pas été utilisé par le patient pour se connecter.",
            "patient_A_has_NHS_CHI_number": "Le patient A a un numéro NHS/CHI présent.",
            "patient_B_has_NHS_CHI_number": "Le patient B a un numéro NHS/CHI présent.",
            "verification_statuses_of_patients_different": "Les statuts de vérification des patients A et B sont différents.",
            "both_patients_have_requests_all_will_assign_to_chosen_patient": "Les deux patients ont des demandes antérieures. Toutes les demandes seront attribuées au patient choisi si vous choisissez de fusionner.",
            "patient_A_has_requests": "Le patient A a des demandes antérieures.",
            "patient_B_has_requests": "Le patient B a des demandes antérieures.",
            "both_patients_have_carers_all_will_be_assigned_to_chosen_patient": "Les deux patients ont des personnes qui s'occupent d'eux. Toutes les personnes qui s'occupent seront attribuées au patient choisi.",
            "patient_A_has_carers_those_will_be_copied_to_chosen_patient": "Le patient A a des personnes qui s'occupent de lui. Ces personnes seront copiées vers le patient choisi si vous choisissez de fusionner.",
            "patient_B_has_carers_those_will_be_copied_to_chosen_patient": "Le patient B a des personnes qui s'occupent de lui. Ces personnes seront copiées vers le patient choisi si vous choisissez de fusionner.",
            "differences_in_the_details_for_the_patient_records_are": "Les différences dans les détails des dossiers des patients sont",
            "highlighted": "soulignées",
            "in_the_above_table": "dans le tableau ci-dessus.",
            "keeping_patient_A": "Conserver le patient A",
            "if_details_for_patient_A_correct_you_should_keep_Patient_A_merge_all_from_B_to_A_delete_B": "Si les coordonnées utilisateur du patient A sont correctes, vous devriez conserver le patient A. Cela fusionnera toutes les demandes, procurations et personnes qui s'occupent existantes du patient B dans le patient A. Cela supprimera également le patient B.",
            "keep_patient_A": "Conserver le patient A",
            "keeping_patient_B": "Conserver le patient B",
            "if_details_for_patient_B_correct_you_should_keep_Patient_A_merge_all_from_A_to_B_delete_A": "Si les coordonnées utilisateur du patient B sont correctes, vous devriez conserver le patient B. Cela fusionnera toutes les demandes, procurations et personnes qui s'occupent existantes du patient A dans le patient B. Cela supprimera également le patient A.",
            "keep_patient_B": "Conserver le patient B",
            "merge_patients": "Fusionner les patients",
            "merge_patients_confirmation_text": "Vous êtes sur le point de fusionner ces deux dossiers de patients. Êtes-vous sûr de vouloir continuer ?",
            "patient_records_have_been_merged": "Les dossiers des patients ont été fusionnés.",
            "edit_merged_patient_record": "Modifier le dossier de patient fusionné",
            "provider_assignment_status": "Statut",
            "message_to_patient": "Message au patient",
            "invite_title": "titre de l'invitation",
            "invite_message": "message d'invitation",
            "invite_call_to_action": "appel à l'action de l'invitation",
            "reminder_title": "titre du rappel",
            "reminder_message": "message de rappel",
            "reminder_call_to_action": "appel à l'action du rappel",
            "internal_note": "Note Interne",
            "attach_document": "Joindre un document",
            "video_call": "Appel Vidéo",
            "edit_codes": "Modifier les codes",
            "forms": "Formulaires",
            "form": "Formulaire",
            "url": "Lien (URL)",
            "form_search": "Recherche de Formulaire",
            "properties": "Propriétés",
            "form_submitted_successfully": "Formulaire soumis avec succès",
            "form_progress_saved": "Progression du formulaire enregistrée",
            "couldnt_load_form": "Impossible de charger le formulaire",
            "fill_in_form": "Remplir le formulaire",
            "view_form": "Voir le formulaire",
            "fill_form_blurb": "Pour nous aider à répondre à votre demande, pourriez-vous s'il vous plaît remplir le formulaire joint ?",
            "await_reply": "En attente de réponse",
            "end_wait": "Fin de l'attente",
            "start_QA": "Démarrer la validation QA",
            "skip_QA": "Passer la validation QA",
            "assign_to": "Attribuer à",
            "unassigned": "Non assigné",
            "unassign": "désassigner",
            "loading_image": "Chargement de l'image en cours ...",
            "downloaded": "Téléchargé",
            "remove_image": "Supprimer l'image",
            "remove_image_confirmation": "Êtes-vous sûr de vouloir supprimer cette image ?",
            "remove_document": "Supprimer le document",
            "remove_document_confirmation": "Êtes-vous sûr de vouloir supprimer ce document ?",
            "preparing_download": "Préparation du téléchargement ...",
            "await_reply_from_patient": "En attente de réponse du patient",
            "set_waiting": "En attente",
            "inform_patient_that_request_is_waiting": "Informer le patient que la demande est en attente",
            "if_no_reply_return_to": "En l'absence de réponse, retourner à",
            "current_assignee": "Attributaire actuel",
            "send_on_date": "Envoyer à la date",
            "await_reply_for": "En attente de réponse pendant",
            "if_no_reply_move_to": "En l'absence de réponse, déplacer vers",
            "send_video_request_to": "Vous êtes sur le point d'envoyer une demande vidéo à",
            "send_video_request": "Envoyer une demande vidéo",
            "video_not_enabled": "La vidéo n'est pas disponible actuellement, peut-être parce que le navigateur est IE11 ou antérieur.",
            "waiting_for_video_to_initialise": "En attente de l'initialisation de la vidéo",
            "waiting_for_patient_to_init_video": "Le patient n'a pas encore rejoint l'appel. Vous pouvez travailler sur d'autres cas et nous vous avertirons lorsque le patient sera arrivé.",
            "request_details": "Détails de la demande",
            "patient_details": "Détails du patient",
            "button_override_lock": "Remplacer le verrouillage",
            "staff_name": "Nom du personnel",
            "patient_name": "Nom du patient",
            "patient_phone": "Téléphone du patient",
            "alternative_phone": "Téléphone alternatif",
            "previous_requests": "Demandes précédentes",
            "load_previous_requests": "Charger les demandes précédentes",
            "request_locked_by": "La demande est verrouillée par",
            "characters_remaining": "caractères restants",
            "no_preset_messages_available": "Aucun message prédéfini disponible",
            "no_forms_available": "Aucun formulaire disponible",
            "user_role": "Rôle de l'utilisateur",
            "usual_GP": "Médecin généraliste habituel",
            "away": "absent",
            "preferred_site": "Site préféré",
            "preferred_site*": "Site préféré *",
            "telephone_number": "Numéro de téléphone",
            "phone_number": "Numéro de téléphone",
            "alternative_telephone": "Téléphone alternatif",
            "alternative_phone_number": "Numéro de téléphone alternatif",
            "invalid_nhs_number": "Numéro NHS/CHI invalide",
            "mrs_no_nhs_number": "Le patient n'a pas de numéro NHS/CHI défini, il n'est donc pas possible de le copier directement dans votre système dossiers médicaux. Vous pouvez modifier les détails du patient en utilisant la recherche Spine, puis revenir et réessayer. Sinon, le bouton \"Copier\" ci-dessous copiera dans votre presse-papiers pour une copie manuelle dans votre système de dossiers.",
            "mrs_no_nhs_number_originator": "Le patient n'a pas de numéro NHS/CHI défini, il n'est donc pas possible de le copier directement dans aucun système de dossiers médicaux. Seul le fournisseur d'origine peut corriger les détails du patient.",
            "mrs_copied_successfully_id": "Demande copiée dans le système de dossiers avec l'identifiant {id}",
            "mrs_already_copied_successfully_id": "La demande a déjà été copiée dans le système de dossiers avec l'identifiant {id}",
            "mrs_copy_initiated": "Copie vers le système de dossiers en cours",
            "mrs_copy_pending": "Copie vers le système de dossiers en cours. En attente...",
            "mrs_copy_pending_id": "Copie vers le système de dossiers en cours avec l'identifiant {id}. En attente...",
            "mrs_copy_pending_already": "Il y a déjà une copie en attente vers votre système de dossiers. Vous devez laisser cette copie se terminer avant d'en tenter une autre.",
            "mrs_copy_pending_already_id": "Il y a déjà une copie en attente vers votre système de dossiers avec l'identifiant {id}. Vous devez laisser cette copie se terminer avant d'en tenter une autre.",
            "mrs_failed": "Échec de la copie vers le système de dossiers médicaux. Vous pouvez toujours copier la demande via votre presse-papiers.",
            "mrs_failed_id": "Échec de la copie vers le système de dossiers médicaux avec l'identifiant {id}. Vous pouvez toujours copier la demande via votre presse-papiers.",
            "mrs_failed_previous": "La copie précédente vers votre système de dossiers médicaux a échoué. Si le problème a été résolu, vous pouvez lancer une nouvelle copie vers votre système de dossiers médicaux, ou vous pouvez copier la demande via votre presse-papiers.",
            "mrs_failed_previous_id": "La copie précédente vers votre système de dossiers médicaux a échoué avec l'identifiant {id}. Si le problème a été résolu, vous pouvez lancer une nouvelle copie vers votre système de dossiers médicaux, ou vous pouvez copier la demande via votre presse-papiers.",
            "mrs_failed_reason": "Le motif signalé est :",
            "mrs_timed_out": "Temps imparti dépassé pour la copie vers le système de dossiers.",
            "mrs_existing_pending": "Une copie vers le système de dossiers est déjà en attente.",
            "mrs_clear_status": "Effacer l'état de classement",
            "failed_filings": "Problèmes de classement",
            "request_copied_to_clipboard": "Demande copiée dans le presse-papiers",
            "record_system_integration_type": "Type d'intégration du système de dossiers médicaux",
            "weekly_rota": "Rota hebdomadaire",
            "potential_duplicate_records": "Doublons potentiels dans les dossiers",
            "created_by": "Créé par",
            "service_message": "Message de service",
            "service_message_start_at": "Heure de début du message de service",
            "service_message_end_at": "Heure de fin du message de service",
            "overall_rating": "Note globale",
            "created_at": "Créé le",
            "view_request": "Voir la demande",
            "title_password_guidance": "Directives relatives à un mot de passe fort",
            "password_guidance1": "Les mots de passe doivent comporter au moins 8 caractères et ne peuvent pas être des mots tels que ‚Äúpassword‚Äù, ‚Äú12345678‚Äù or ‚Äúabcdefgh‚Äù.",
            "password_guidance2": "La chose la plus importante est de ne pas utiliser de mots de passe courts (nous vous suggérons plus de 8 caractères). Les espaces sont autorisés, vous pouvez donc utiliser une longue phrase de trois ou quatre mots aléatoires. Un mot de passe plus court avec un mélange de types de caractères fonctionnera également, sauf s'il s'agit d'un modèle très courant.",
            "subtitle_user_details": "Détails de l'utilisateur",
            "shown_to_patients": "affiché aux patients",
            "note_multi_provider_not_yet_editable": "Il s'agit d'un compte du personnel multi-fournisseur. La modification des rôles du personnel ou la suppression du compte n'est pas (encore) disponible pour les administrateurs du réseau.",
            "availability_help_text": "Pour qu'un membre du personnel soit disponible pour sélection dans l'interface du patient, il doit être disponible dans les 14 prochaines heures et avoir <strong>n'importe quelle</strong> disponibilité sur le site choisi par le patient. La raison en est que le membre du personnel peut discuter d'un problème avec le patient en ligne aujourd'hui, car il est disponible (quelque part), et s'il devient nécessaire de voir le patient en personne, il peut prendre rendez-vous pour la prochaine visite sur le site choisi par le patient.",
            "alert_info_weekly_rota_part1": "Toute heure saisie ici remplacera celle saisie dans le calendrier hebdomadaire ci-dessus. Par exemple, si vous souhaitez définir une personne comme étant disponible uniquement le matin, vous pouvez ajouter ce jour spécifique ci-dessous et saisir la disponibilité comme suit :",
            "alert_info_weekly_rota_part2": "Les exceptions remplacent toute la journée, mais sont cumulatives, donc si un membre du personnel ne pouvait pas être disponible entre 11h00 et 14h00, vous entreriez deux exceptions de disponibilité ci-dessous, une pour",
            "alert_info_weekly_rota_part3": "et une autre pour",
            "alert_info_weekly_rota_part4": "Si vous souhaitez indiquer qu'une personne est absente toute la journée, ajoutez simplement la date (ou la plage de dates) et laissez les horaires de disponibilité vides.",
            "link_more_information": "Plus d'informations",
            "add_to_home_screen": "Ajouter à l'écran d'accueil",
            "group_can_have_requests_assigned": "Le groupe peut se voir attribuer des demandes",
            "members_can_have_requests_assigned": "Les membres individuellement peuvent avoir des demandes et s'afficher dans le tableau de bord",
            "patients_can_choose_group_members": "Les patients peuvent choisir les membres du groupe",
            "can_complete_on_behalf_of_another": "Peut effectuer au nom d'un autre",
            "members": "Membres",
            "description": "Description",
            "event_triggered_by": "Événement déclenché par",
            "PATIENT": "PATIENT",
            "STAFF": "PERSONNEL",
            "no_properties_specified": "Aucune propriété spécifiée",
            "patient": "Patient",
            "account_status": "Statut du compte",
            "patient_never_logged_in": "Le patient ne s'est jamais connecté",
            "alert_scope_global": "Cette portée du message est globale. Il ne peut être modifié que par un administrateur du réseau askmyGP.",
            "alert_scope_organisational": "Cette portée du message est organisationnelle. Elle ne peut être modifiée que par un administrateur.",
            "owner": "propriétaire",
            "ownership": "propriété",
            "set_owner": "définir le propriétaire",
            "transfer": "transfert",
            "organisational": "Organisationnel",
            "personal": "Personnel",
            "welcome_to": "Bienvenue sur",
            "welcome_to_askmyGP": "Bienvenue sur askmyGP",
            "patient_intro": "Obtenez de l'aide de votre cabinet. Demandez à tout moment, nous répondons pendant les heures de travail.",
            "you_may_add_more_detail_later": "Vous pouvez ajouter plus de détails plus tard",
            "is_currently_unavailable_for_online_requests": "est actuellement indisponible pour les demandes en ligne",
            "is_currently_available_for_some_requests": "est actuellement hors ligne. Vous pouvez toujours accéder à certains services. Les demandes seront examinées lorsque nous serons de nouveau en ligne.",
            "network_is_currently_unavailable_for_online_requests": "Désolé, en raison d'un problème technique avec askmyGP, nous ne pouvons pas accepter de nouvelles demandes en ligne pour le moment. Nous espérons que le système fonctionnera à nouveau bientôt. Cependant, pour éviter tout retard, veuillez appeler le cabinet et parler à l'accueil afin que nous puissions répondre à vos besoins.",
            "get_self_help": "Obtenir de l'aide auto-assistance",
            "quick_self_help": "Auto-assistance NHS",
            "consult_your_GP": "Consulter un clinicien",
            "login_to_consult_your_GP": "Inscrivez-vous ou connectez-vous pour consulter un clinicien",
            "do_not_use_in_emergencies": "Ne pas utiliser en cas d'urgence - Conseils du NHS ici",
            "the_end_user_licence_agreement": "L'accord de licence de l'utilisateur final (\"End user licence agreement\")",
            "end_user_licence_agreement": "Accord de licence de l'utilisateur final (\"End user licence agreement\")",
            "privacy_policy": "Politique de confidentialité (\"Privacy Policy\")",
            "characters_left": "caractères restants",
            "terms_of_use": "Conditions d'utilisation (\"Terms of Use\")",
            "hello": "Bonjour",
            "you_have_new_messages_in": "Vous avez de nouveaux messages dans",
            "thread": "fil",
            "are_these_details_correct_if_not_contact_your_practice": "Ces détails sont-ils corrects ? Sinon, contactez votre cabinet de médecin généraliste",
            "remember_to_click_save_below": "N'oubliez pas de cliquer sur Confirmer ci-dessous",
            "your_user_details_were_updated_successfully": "Vos coordonnées ont été mises à jour avec succès.",
            "new_request": "Nouvelle demande",
            "view_past_requests": "Voir les demandes précédentes",
            "edit_my_details": "Modifier mes coordonnées",
            "people_i_care_for": "{people} dont je m'occupe",
            "people": "Personnes",
            "our_service_times": "Nos heures de service",
            "when_is_your_GP_working": "Quand votre clinicien est-il disponible ?",
            "offline": "Hors ligne",
            "i_am_asking_as_a": "Je demande en tant que",
            "parent_or_carer": "Parent ou tuteur",
            "do_you_have_an_askmyGP_login": "Avez-vous un compte {article_app_name} ?",
            "sign_up_as_a_new_user": "Inscrivez-vous en tant que nouvel utilisateur",
            "login_existing_user": "Connectez-vous en tant qu'utilisateur existant",
            "logged_out_successfully": "Déconnexion réussie",
            "logged_out_automatically_message": "Vous avez été déconnecté automatiquement du système askmyGP en raison d'une inactivité",
            "logged_out_manually_message": "Vous avez été déconnecté avec succès du système askmyGP",
            "logged_out_not_logged_in": "Pour utiliser le système askmyGP, vous devrez vous connecter à votre compte",
            "log_back_in": "Se reconnecter",
            "404_not_found": "404 Non trouvé",
            "page_not_found": "Page non trouvée",
            "not_found": "Introuvable",
            "sorry_item_requested_not_found_in_system": "Désolé, l'élément que vous avez demandé n'a pas été trouvé dans le système.",
            "return_to_site_index": "Retour à l'index du site",
            "im_sorry_we_cant_find_the_page_you_are_looking_for": "Je suis désolé, nous ne parvenons pas à trouver la page que vous recherchez",
            "create_your_password": "Créez votre mot de passe",
            "secure_your_account": "Sécurisez votre compte en créant un mot de passe",
            "reset_your_password": "Réinitialisez votre mot de passe",
            "strong_password_guidance": "Directives pour un mot de passe fort",
            "password_reset_email_sent": "Email de réinitialisation du mot de passe envoyé",
            "password_reset_successfully": "Réinitialisation du mot de passe réussie",
            "attach_photo_or_document": "Joindre une photo ou un document ?",
            "attach_another_photo_or_document": "Joindre une autre photo ou un autre document ?",
            "message_updated": "Message mis à jour",
            "new_message": "Nouveau message",
            "message_deleted": "Message supprimé",
            "sign_up_to": "Inscrivez-vous pour",
            "you_can_do_it_here_and_now_your_email_address_may_be_used_only_once": "Vous pouvez le faire ici et maintenant. Votre adresse e-mail ne sera utilisée qu'une seule fois.",
            "unable_to_register_message": "Malheureusement, vous ne pouvez pas vous inscrire à askmyGP car nous ne savons pas avec quel GP vous souhaitez vous inscrire. Veuillez suivre le lien fourni sur le site web de votre GP.",
            "please_accept": "Veuillez accepter",
            "my_details": "Mes coordonnées",
            "privacy_message_overview": "askmyGP traite vos données personnelles et de soins de santé au nom de votre GP, qui est le responsable du traitement des données. Les données anonymisées sont utilisées à des fins de recherche et de développement. Nous n'utilisons pas d'informations personnelles à des fins de marketing.",
            "isabel_checks_symptoms_for_possible_conditions": "Isabel vérifie les symptômes pour des conditions possibles",
            "powered_by_isabel_healthcare": "Grâce à Isabel Healthcare",
            "input_placeholder_self_help": "Saisissez le titre de votre problème (50 caractères maximum)",
            "placeholder_enter_problem_self_help": "Saisissez un problème pour l'auto-assistance",
            "no_search_results_found": "Aucun résultat de recherche trouvé",
            "we_try_to_respond_soon_during_these_hours": "Nous essayons de répondre rapidement pendant ces heures",
            "it_helps_us_if_you_send_your_request_on_the_same_day": "Cela nous aide si vous envoyez votre demande le même jour",
            "provider_details": "Détails du fournisseur",
            "provider_name": "Nom du fournisseur",
            "practice_code": "Code du GP",
            "site_name": "Nom du site",
            "superuser_gender": "Genre de l'administrateur principal",
            "superuser_forenames": "Prénoms de l'administrateur principal",
            "superuser_surname": "Nom de famille de l'administrateur principal",
            "superuser_email": "Adresse e-mail de l'administrateur principal",
            "tooltipRobotName": "Le nom du robot doit être construit de manière à ressembler au nom du fournisseur. Par exemple : Le fournisseur \"Bramley Surgery\" a pour prénoms de robot \"Bramley\" et pour nom de famille \"Surgery\".",
            "robot_name": "Nom du robot",
            "robot_forenames": "Prénoms du robot",
            "robot_surname": "Nom de famille du robot",
            "robot_email": "Adresse e-mail du robot",
            "leave_blank_to_auto_populate_with": "Laisser vide pour remplir automatiquement avec",
            "click_to_view": "Cliquez pour afficher",
            "copied_to_clipboard": "copié dans le presse-papiers",
            "disable_notifications": "Désactiver les notifications",
            "enable_notifications": "Activer les notifications",
            "DD/MM/YYYY": "JJ/MM/AAAA",
            "DD/MM/YYYY-HH-MM": "JJ/MM/AAAA HH:MM",
            "video_request_from": "Demande vidéo de",
            "video_request": "Demande vidéo",
            "delete_message": "Supprimer le message",
            "message_will_be_deleted_continue": "Le contenu de ce message sera supprimé. Êtes-vous sûr de vouloir continuer ?",
            "message_content_deleted": "Contenu du message supprimé",
            "thread_reopened": "Fil rouvert",
            "delete_request": "Supprimer la demande",
            "you_are_about_to_delete_request": "Vous êtes sur le point de supprimer la demande",
            "for": "pour",
            "are_you_sure_you_want_to_continue": "Êtes-vous sûr de vouloir continuer ?",
            "finish": "Terminer",
            "awaiting_reply_then_closed_until": "Le cabinet attend votre réponse. Si vous souhaitez répondre, veuillez le faire avant {waiting_until}, date à laquelle le cas sera clos.",
            "awaiting_reply_then_reassigned_until": "Le cabinet attend votre réponse. Si vous souhaitez répondre, veuillez le faire avant {waiting_until}, date à laquelle le cas sera renvoyé à {clinicien}.",
            "awaiting_reply_then_unassigned_until": "Le cabinet attend votre réponse. Si vous souhaitez répondre, veuillez le faire avant {waiting_until}, date à laquelle le cas sera réexaminé par un membre de notre équipe.",
            "completed_message_intro": "Merci d'avoir utilisé le service askmyGP.",
            "completed_message_manual": "Nous avons maintenant traité votre demande.",
            "completed_message_auto": "Étant donné que nous n'avons pas reçu de réponse de votre part, nous avons maintenant clos votre demande.",
            "completed_message_auto_custom_action": "Votre demande a été traitée automatiquement et aucune autre action n'est nécessaire.",
            "completed_message_feedback": "Vous pouvez laisser un commentaire sur notre <strong><a href=\"{feedback_link}\">formulaire de feedback</a></strong>.",
            "ended_the_wait_state_for_this_request": "{user} a mis fin à l'état d'attente de cette demande",
            "set_thread_waiting": "Définir l'attente du fil",
            "wait_ended": "Attente terminée",
            "send_message": "Envoyer le message",
            "request_will_go_to_patient_confirmation": "Ce message sera envoyé au patient. Veuillez confirmer que vous souhaitez l'envoyer ?",
            "okay": "D'accord",
            "request_updated": "Demande mise à jour",
            "basic_search": "Recherche de base",
            "oldest_on_top": "Le plus ancien en premier",
            "newest_on_top": "Le plus récent en premier",
            "Male": "Homme",
            "Female": "Femme",
            "Unspecified": "Non spécifié",
            "monday": "lundi",
            "tuesday": "mardi",
            "wednesday": "mercredi",
            "thursday": "jeudi",
            "friday": "vendredi",
            "saturday": "samedi",
            "sunday": "dimanche",
            "Claimed": "Réclamé",
            "Identified": "Identifié",
            "Verified": "Vérifié",
            "Mr": "M.",
            "Ms": "Mme",
            "Mrs": "Mme",
            "Miss": "Mlle",
            "Dr": "Dr",
            "Mx": "Mx",
            "skip": "Passer",
            "check": "Vérifier",
            "deleted": "supprimé",
            "undefined": "indéfini",
            "Parent/Guardian": "Parent/Tuteur",
            "Carer": "Aidant/Ami/Parent",
            "select": "sélectionner",
            "select_clinician": "Sélectionner un clinicien",
            "edit_session_data": "Modifier les données de session",
            "edit_availability": "Modifier la disponibilité",
            "select_clinician_view_calendar": "Veuillez sélectionner un clinicien pour voir son calendrier",
            "selected_clinician_has_no_sessions": "Le clinicien sélectionné n'a aucune séance de rendez-vous",
            "cancel_appointment": "Annuler la réservation",
            "appointment_booking": "Prise de rendez-vous",
            "enable_appointment_bookings": "Activer les prises de rendez-vous",
            "book_appointment": "Prendre rendez-vous",
            "restricted_patient_search": "Patients",
            "network_availabile_for_new_requests": "Le système est disponible pour de nouvelles demandes",
            "network_up": "Le système est disponible pour les fournisseurs et les patients",
            "network_softdown_message": "Désolé, askmyGP est actuellement hors ligne. Veuillez réessayer plus tard.",
            "network_unavailable_for_new_requests_message": "Désolé, askmyGP est actuellement hors ligne pour toutes nouvelles demandes. Veuillez réessayer plus tard.",
            "network_settings": "Paramètres réseau",
            "capacity_planning": "planification de la capacité",
            "demand_per_week": "demande par semaine",
            "typical": "typique",
            "actual": "réel",
            "clinical": "clinique",
            "other": "autre",
            "total": "total",
            "capacity_per_session": "capacité par session",
            "sessions": "sessions",
            "save_to_dashboard": "enregistrer dans le tableau de bord",
            "demand_per_day_as_percent_of_week": "Demande par jour en % de la semaine",
            "search_cant_select": "Vous ne pouvez pas sélectionner cet élément",
            "search_item_already_exists": "L'élément existe déjà",
            "search_cant_select_provider_xref": "Vous ne pouvez pas sélectionner le même fournisseur que celui pour lequel vous ajoutez le lien.",
            "search_item_already_exists_provider_xref": "Un lien pour ce fournisseur existe déjà.",
            "cant_share_non_verified_user_request": "Vous ne pouvez partager/transférer des demandes que pour les patients dont le statut ID est \"Vérifié\" et qui ont un numéro NHS/CHI défini.",
            "continue_search_in_archive": "Afficher les demandes précédentes",
            "closed_at_range": "Complété entre les dates",
            "show_available_all_option": "Afficher disponible / tout",
            "show_all_waiting": "Afficher tout",
            "show_all": "Afficher tout",
            "show_pending": "Afficher en attente",
            "sms_sent": "Un message SMS a été envoyé à l'utilisateur sur {phone}",
            "sms_smtp_gateway_domain": "Domaine de passerelle SMTP SMS",
            "id": "ID",
            "email_verification_text": "Un code à quatre chiffres a été envoyé à l'adresse e-mail que vous avez fournie",
            "password_verification_text": "Pour autoriser cette modification, vous devez vérifier votre mot de passe",
            "password_verification_for_email": "Lorsque vous modifiez votre adresse e-mail, vous devez également vérifier votre mot de passe actuel",
            "verify": "Vérifier",
            "tags": "tags",
            "tag": "tag",
            "tag_entries": "Entrées de tags",
            "tag_uses": "Utilisations de tags",
            "icon": "Icône",
            "position": "Position",
            "custom_actions": "actions personnalisées",
            "custom_action": "action personnalisée",
            "cohorts": "cohortes",
            "cohort": "cohortes",
            "campaigns": "campagnes",
            "campaign": "campagne",
            "campaign_not_found": "Désolé, la campagne que vous avez sélectionnée n'existe plus.",
            "start_campaign": "commencer la campagne",
            "reset_campaign": "réinitialiser la campagne",
            "stop_campaign": "arrêter la campagne",
            "campaign_started": "{name} a été démarré et commencera le traitement lors de la prochaine exécution de traitement (généralement dans une minute)",
            "campaign_stopped": "{name} est terminé",
            "campaign_reset": "Les données de {name} ont été réinitialisées",
            "campaign_reminder_at": "Un rappel pour {name} a été lancé",
            "start_at": "début à",
            "end_at": "fin à",
            "total_users": "utilisateurs totaux",
            "invite_sent": "invitation envoyée",
            "reminder_sent": "rappel envoyé",
            "send_reminder": "envoyer un rappel",
            "automatically_assign": "automatiquement attribué à",
            "AUTOMATED_FORM_SUBMISSION": "Le formulaire {form_title} a été soumis avec succès par {name}",
            "AUTOMATED_FORM_SAVE": "Le formulaire {form_title} a été enregistré (en cours) par {name}",
            "record_system_test_user_id": "ID utilisateur de test du système de dossiers médicaux",
            "mrs_user_id": "ID utilisateur du système de dossiers médicaux",
            "oauth_authorisation": "Autoriser l'accès au compte",
            "authorise": "autoriser",
            "oauth_requesting_permission": "<strong>{client_name}</strong> demande l'autorisation d'accéder à votre compte.",
            "oauth_application_abilities": "Cette application pourra",
            "oauth_token_can_profile": "Afficher des informations sur votre profil",
            "terms_conditions": "Termes et conditions (\"Terms & Conditions\")",
            "terms_message": "Pour continuer à utiliser le service askmyGP, vous devez accepter les accords de licence suivants.",
            "codes": "Codes",
            "consultation": "Consultation",
            "add_code": "Ajouter un code",
            "no_codes": "Aucun code spécifié",
            "code_header": "En-tête",
            "code_scheme": "Schéma",
            "code_code": "Code",
            "code_description_id": "ID de description",
            "description_id": "ID de description",
            "code_term": "Terme",
            "code_units": "Unités",
            "code_value": "Valeur",
            "code": "Code",
            "blood_pressure": "Pression artérielle",
            "blood_pressure_ranges": "Plages de pression artérielle",
            "blood_pressure_ranges_help": "Lorsqu'une pression artérielle est saisie dans l'interface de codage, ou via un champ de formulaire, les valeurs seront comparées à ces plages et automatiquement priorisées comme spécifié.",
            "blood_pressure_ranges_and_or": "Pour entrer une plage qui correspond à la pression diastolique ou systolique, définissez la relation sur <em>OU</em>. Pour entrer une plage qui correspond à la pression diastolique et systolique ensemble, définissez la relation sur <em>ET</em>.",
            "add_blood_pressure": "Ajouter une pression artérielle",
            "add_blood_pressure_range": "Ajouter une plage de pression artérielle",
            "no_blood_pressures": "Aucune pression artérielle spécifiée",
            "no_blood_pressure_ranges": "Aucune plage de pression artérielle spécifiée",
            "systolic": "Systolique",
            "diastolic": "Diastolique",
            "min": "min",
            "max": "max",
            "term": "Terme",
            "unit": "Unité",
            "value": "Valeur",
            "code_descriptive_text": "Texte descriptif",
            "attachments": "Pièces jointes",
            "session_saved_for_later": "Votre progression de soumission en cours a été enregistrée en toute sécurité dans votre navigateur. Ainsi, si vous utilisez le même navigateur lorsque votre GP rouvrira pour les soumissions de demandes, vous serez invité à récupérer votre demande enregistrée et à continuer votre soumission.",
            "recover_in_progress_qa_title": "Continuer la demande en cours",
            "recover_in_progress_qa_text": "Vous avez une soumission de demande en cours enregistrée. Souhaitez-vous continuer avec le brouillon ?",
            "save_qa": "Enregistrer la progression",
            "dont_save_qa": "Ne pas enregistrer la progression",
            "continue_qa": "Continuer l'édition",
            "not_authorised_to_search_snomed": "Vous n'êtes pas autorisé à rechercher des codes SNOMED",
            "who_is_this_service_for": "Pour qui est ce service ?",
            "custom_action_not_found": "Action personnalisée introuvable.",
            "allow_when_closed": "Autoriser quand c'est fermé",
            "content_requests_submit_someone_else_visible": "Le contenu des demandes que vous soumettez pour quelqu'un d'autre est visible par cette personne.",
            "number_open_requests_for_patient": "Nombre de demandes en cours pour ce patient",
            "no_session_types_found": "Aucun type de session trouvé",
            "no_sessions_found": "Aucune session trouvée",
            "no_availibility_exceptions_found": "Aucune exception de disponibilité trouvée",
            "preview": "Aperçu",
            "colour": "Couleur",
            "use": "Utilisation",
            "search_min_3_characters": "Recherche (au minimum 3 caractères)",
            "problem": "Problème",
            "history": "Antécédents",
            "examination": "Examen",
            "family_history": "Antécédents familiaux",
            "social": "Social",
            "procedure": "Procédure",
            "attachments_auto_copy_to_record_system": "Ces pièces jointes seront également automatiquement copiées dans votre système d'enregistrement :",
            "notification_updated_successfully": "mis à jour avec succès",
            "notification_created_successfully": "créé avec succès",
            "notification_deleted_successfully": "supprimé avec succès",
            "you_are_about_to_remove_access_to_provider_account_for": "Vous êtes sur le point de supprimer l'accès à votre compte de fournisseur askmyGP pour",
            "shared_transferred": "Partagé/Transféré",
            "demand_capacity_updated_success": "Demande et capacité mises à jour avec succès",
            "set_followup_for_request_at": "{user} a défini un suivi pour cette demande jusqu'à {waiting_until}",
            "assigned_request_to": "demande attribuée à",
            "removed_follow_up_for_request": "{user} a supprimé le suivi pour cette demande.",
            "set_request_to_wait_until": "{user} a défini cette demande en attente jusqu'à {waiting_until}",
            "custom_action_type": "Type d'action personnalisée",
            "submission_message": "Message de soumission (envoyé à l'utilisateur lorsque le formulaire est soumis et que la nouvelle demande est créée)",
            "automatically_share_requests_with": "Transférer automatiquement la nouvelle demande à",
            "when_shared_completes_automatically_or_autocompletes_writeback_with_user": "Lorsque les demandes transférées sont terminées, ou que les demandes sont automatiquement terminées, effectuez automatiquement un retour d'écriture en utilisant",
            "when_transferred_request_completes_automatically_writeback": "Lorsque la demande transférée est terminée, effectuez automatiquement un retour d'écriture",
            "do_not_automatically_writeback": "Ne pas effectuer de retour d'écriture automatique",
            "user_selectable": "L'action est sélectionnable par l'utilisateur (apparaît comme un bouton personnalisé dans l'application patient)",
            "autocomplete_custom_action": "Terminer automatiquement l'action lorsque le formulaire est soumis",
            "autocomplete_custom_action_info": "L'achèvement automatique est toujours annulé lorsque la demande est priorisée au-dessus de \"Routine\". Les demandes peuvent être priorisées via des formulaires soit explicitement (AMGFLAG) soit implicitement via des mesures de pression artérielle (AMGBP)",
            "none": "Aucun",
            "automatically_assign_requests_to": "Attribuer automatiquement les demandes à",
            "do_not_automatically_assign": "Ne pas attribuer automatiquement",
            "do_not_automatically_transfer": "Ne pas transférer automatiquement",
            "automatically_tag_requests_as": "Tag automatiquement les demandes en tant que",
            "search_for_a_tag": "Rechercher un tag",
            "no_results": "Aucun résultat",
            "you_have": "Vous avez",
            "view_messages": "Voir les messages",
            "view_all_prev_requests": "Voir toutes les demandes précédentes",
            "nhs_covid": "Conseils NHS sur le coronavirus (COVID-19)",
            "at": "à",
            "third_party_apps_account_access": "Applications tierces avec accès au compte",
            "oauth_revoke_access": "Révoquer l'accès au compte",
            "remove_access": "Supprimer l'accès ?",
            "remove_access_confirmation": "{client} n'aura plus accès à votre compte askmyGP. Vous devrez accorder l'accès si vous souhaitez utiliser à nouveau cette application ou ce service.",
            "include_internal_messages": "Inclure les messages internes",
            "include_internal_messages_when_copying": "Inclure par défaut les messages internes dans la copie/retour d'écriture ?",
            "include_datetime_when_copying": "Inclure la date/heure des messages dans la copie/retour d'écriture ?",
            "messages_thread": "Fil de messages",
            "introduction": "Introduction",
            "select_service": "Sélectionner le service",
            "profile_details": "Détails du profil",
            "register_proxy": "Enregistrer le mandataire",
            "select_caree": "Sélectionner le patient pris en charge",
            "staff_availability": "Disponibilité du personnel",
            "oauth": "oauth",
            "terms": "terms",
            "profile_edit": "Modifier le profil",
            "user_import": "importer des utilisateurs",
            "user_imports": "importation des utilisateurs",
            "new_users": "nouveaux utilisateurs",
            "existing_users": "utilisateurs existants",
            "bad_data_users": "utilisateurs avec des données erronées",
            "in_other_provider_users": "utilisateurs existants dans d'autres fournisseurs",
            "test_email_sent_to": "Email de test envoyé à {email}",
            "egl_app_paired": "L'application patient EGL a été associée",
            "user_csv_file": "Fichier CSV utilisateur",
            "uploaded_file": "Fichier téléchargé",
            "download_csv": "Télécharger le CSV",
            "open_menu": "Ouvrir le menu",
            "close_menu": "Fermer le menu",
            "priority": "Priorité",
            "priority_20": "Urgence",
            "priority_10": "Urgent",
            "priority_5": "Demande de visite",
            "priority_0": "Routine",
            "priority_-10": "Inférieur",
            "creating_new_message_title": "Création d'un nouveau fil de message",
            "add_attachment_to_message": "Ajouter une pièce jointe au message",
            "relation_and": "ET",
            "relation_or": "OU",
            "recover_in_progress_form_title": "Continuer le formulaire brouillon",
            "recover_in_progress_form_text": "Vous avez une version brouillon de ce formulaire enregistrée. Souhaitez-vous continuer avec le brouillon ?",
            "email_verification_code": "Code invalide saisi. Veuillez taper le code tel qu'il apparaît dans l'email. Si vous n'avez pas reçu l'email, veuillez vérifier votre dossier de courrier indésirable/spam.",
            "change_email_address": "Changer l'adresse e-mail.",
            "verify_email_address": "Vérifier l'adresse e-mail.",
            "up_to_date": "Vous êtes tous à jour.",
            "someone_else": "Quelqu'un d'autre"
        },
        "passwords": {
            "password": "Les mots de passe doivent comporter au moins huit caractères.",
            "reset": "Votre mot de passe a été réinitialisé !",
            "sent": "Nous avons envoyé par e-mail votre lien de réinitialisation de mot de passe !",
            "token": "Ce jeton de réinitialisation de mot de passe a expiré. <a href=\"RESET_LINK\">Demander un nouveau jeton</a>",
            "user": "Nous ne trouvons aucun utilisateur avec cette adresse e-mail."
        },
        "auth": {
            "failed": "L'e-mail ou le mot de passe ne correspondent pas à nos enregistrements. Essayez le lien \"Mot de passe oublié\" ci-dessous.",
            "throttle": "Trop de tentatives de connexion. Veuillez réessayer dans {seconds} secondes."
        },
        "emails": {
            "welcome_to_app_from": "Bienvenue sur askmyGP de la part de",
            "please_login_now": "Veuillez vous connecter maintenant.",
            "account_created_choose_password_and_login": "Assurez-vous d'être connecté à un réseau NHS sécurisé pour vous connecter et créer votre mot de passe.",
            "set_your_login": "Définissez votre identifiant de connexion askmyGP",
            "if_login_expired": "Si le lien ci-dessus a expiré, cliquez ici pour vous connecter à",
            "if_login_created_may_request_new_link": "Si votre identifiant de connexion a été créé, vous pouvez demander un nouveau lien en utilisant \"Mot de passe oublié\"",
            "kind_regards": "Cordialement",
            "app_on_behalf_of": "askmyGP au nom de",
            "do_not_reply_responses_not_monitored": "Ne répondez pas à cet e-mail, car les réponses ne sont pas surveillées.",
            "always_use_secure_service_to_message": "Utilisez toujours le service askmyGP sécurisé pour envoyer des messages.",
            "create_your_new_app_password": "Créez votre nouveau mot de passe askmyGP",
            "patient_welcome_message": "Bienvenue sur askmyGP. Vous êtes maintenant approuvé pour un accès plus rapide et plus facile à votre propre médecin (\"GP\").",
            "create_new_password": "Créer un nouveau mot de passe",
            "with_login_you_can_request_help_welcome_message": "Avec votre identifiant de connexion sécurisé, vous pouvez demander de l'aide pour tout problème médical. Vous pouvez demander de l'aide pour vous-même ou de la part de quelqu'un dont vous vous occupez, à condition que le patient soit inscrit auprès de notre centre médical (\"GP practice\"). Pendant les heures de travail, nous répondons rapidement. En dehors des heures de travail, nous répondons le jour ouvrable suivant.",
            "please_use_app_for_all_enquiries": "Veuillez utiliser askmyGP pour toutes vos demandes futures et aidez-nous à vous aider.",
            "sent_you_a_message": "vous a envoyé un message askmyGP",
            "click_to_login_do_not_reply": "Cliquez ci-dessous pour vous connecter et voir votre message. Ne répondez pas à cet e-mail, car les réponses ne sont pas surveillées. Utilisez toujours le service askmyGP sécurisé pour envoyer des messages.",
            "do_not_reply_always_use_secure_askmygp_to_message": "Ne répondez pas à cet e-mail, car les réponses ne sont pas surveillées. Utilisez toujours le service askmyGP sécurisé pour envoyer des messages.",
            "see_my_message": "Voir le message",
            "open_message_with_egl_app": "Ouvrir le message dans l'application Evergreen Life",
            "open_message_with_web_app": "Ouvrir le message dans le navigateur",
            "you_have_a_message": "Vous avez un message sur askmyGP",
            "regards": "Cordialement",
            "security_notice": "Avis de sécurité",
            "security_notice_from": "Ceci est un avis de sécurité de la part de",
            "message": "Message",
            "app_password_reset": "Réinitialisation du mot de passe askmyGP",
            "set_password": "Définir le mot de passe",
            "link_will_expire": "Ce lien peut être utilisé une seule fois et expirera après 24 heures.",
            "password_reset_request": "Quelqu'un a demandé la réinitialisation du mot de passe pour le compte askmyGP enregistré à",
            "no_changes_yet_click_reset_pass": "Aucun changement n'a encore été effectué. Cliquez sur le bouton ci-dessous pour réinitialiser votre mot de passe.",
            "did_not_request_no_action_required": "Si vous n'avez pas demandé de réinitialisation du mot de passe, vous pouvez ignorer cet e-mail : aucune action supplémentaire n'est requise. Veuillez ne pas répondre à cet e-mail, car les réponses ne sont pas surveillées.",
            "find_out_more": "En savoir plus",
            "you_can_download_our_app": "Vous pouvez maintenant télécharger notre application"
        },
        "security": {
            "not_authorised_to_list_feedback": "Vous n'êtes pas autorisé(e) à répertorier les commentaires.",
            "not_authorised_to_view_feedback_items": "Vous n'êtes pas autorisé(e) à consulter les éléments de rétroaction.",
            "not_authorised_to_view_this_feedback": "Vous n'êtes pas autorisé(e) à consulter cet élément de rétroaction.",
            "not_authorised_to_delete_feedback": "Vous n'êtes pas autorisé(e) à supprimer les éléments de rétroaction.",
            "not_allowed_view_messages": "Vous n'êtes pas autorisé(e) à consulter les messages.",
            "not_allowed_view_messages_from_another_provider": "Vous n'êtes pas autorisé(e) à consulter les messages d'un autre fournisseur.",
            "not_allowed_view_messages_from_this_request": "Vous n'êtes pas autorisé(e) à consulter les messages de cette demande.",
            "attempting_to_access_another_users_message": "Tentative d'accès aux messages d'un autre utilisateur.",
            "attempting_to_access_another_provider": "Tentative d'accès à un autre fournisseur.",
            "not_permitted_to_view_messages_in_this_thread": "Vous n'êtes pas autorisé(e) à consulter les messages de ce fil de discussion.",
            "patients_not_allowed_post_internal_messages": "Les patients ne sont pas autorisés à publier des messages internes.",
            "not_able_top_post_messages_until_provider_response": "Désolé, vous ne pouvez pas envoyer de messages tant que vous n'avez pas reçu de réponse de votre fournisseur.",
            "cannot_delete_other_peoples_messages": "Vous ne pouvez pas supprimer les messages des autres personnes.",
            "this_is_a_test_please_disregard": "Il s'agit d'un test de sécurité. Veuillez l'ignorer.",
            "not_authorised_to_request_video_calls": "Vous n'êtes pas autorisé(e) à demander des appels vidéo.",
            "not_authorised_to_send_video_requests_to_this_thread": "Vous n'êtes pas autorisé(e) à envoyer des demandes vidéo à ce fil de discussion.",
            "not_authorised_to_view_this_document": "Vous n'êtes pas autorisé(e) à consulter ce document.",
            "not_authorised_to_view_documents": "Vous n'êtes pas autorisé(e) à consulter les documents.",
            "permission_denied_to_delete_message_documents": "Vous n'avez pas la permission de supprimer des documents de message.",
            "message_to_closed_request": "Cette demande a été fermée. Si vous souhaitez contacter à nouveau votre fournisseur, veuillez ouvrir une nouvelle demande.",
            "not_authorised_to_view_this_image": "Vous n'êtes pas autorisé(e) à consulter cette image.",
            "not_authorised_to_view_images": "Vous n'êtes pas autorisé(e) à consulter les images.",
            "permission_denied_delete_message_images": "Vous n'avez pas la permission de supprimer les images de message.",
            "not_authorised_to_view_news_items": "Vous n'êtes pas autorisé(e) à consulter les éléments d'actualité.",
            "permission_denied_create_news_items": "Vous n'avez pas la permission de créer des éléments d'actualité.",
            "permission_denied_edit_news_items": "Vous n'avez pas la permission de modifier des éléments d'actualité.",
            "permission_denied_delete_news_items": "Vous n'avez pas la permission de supprimer des éléments d'actualité.",
            "not_authorised_to_view_user": "Vous n'êtes pas autorisé(e) à consulter cet utilisateur.",
            "practice_code_supplied_does_not_exist": "Le code de la pratique fourni n'existe pas.",
            "permission_denied_update_verification_statuses": "Vous n'avez pas la permission de mettre à jour les statuts de vérification.",
            "permission_denied_view_subject_access_requests": "Vous n'avez pas la permission de consulter les demandes d'accès aux sujets.",
            "permission_denied_merge_patient_accounts": "Vous n'avez pas la permission de fusionner des comptes de patients.",
            "can_only_merge_patients_belonging_to_your_provider": "Vous ne pouvez fusionner que des patients appartenant à votre fournisseur.",
            "permission_denied_view_preset_messages": "Vous n'avez pas la permission de consulter les messages prédéfinis.",
            "permission_denied_create_preset_messages": "Vous n'avez pas la permission de créer des messages prédéfinis.",
            "permission_denied_edit_preset_messages": "Vous n'avez pas la permission de modifier des messages prédéfinis.",
            "permission_denied_delete_preset_messages": "Vous n'avez pas la permission de supprimer des messages prédéfinis.",
            "permission_denied_edit_item": "Vous n'avez pas la permission de modifier cet élément.",
            "permission_denied_delete_item": "Vous n'avez pas la permission de supprimer cet élément.",
            "user_not_found_for_preset_message_assignment": "Utilisateur introuvable pour l'attribution de message prédéfini.",
            "permission_denied_view_tags": "Vous n'avez pas la permission de consulter les étiquettes.",
            "permission_denied_create_tags": "Vous n'avez pas la permission de créer des étiquettes.",
            "permission_denied_edit_tags": "Vous n'avez pas la permission de modifier des étiquettes.",
            "permission_denied_delete_tags": "Vous n'avez pas la permission de supprimer des étiquettes.",
            "permission_denied_view_item": "Vous n'avez pas la permission de consulter cet élément.",
            "permission_denied_view_custom_action": "Vous n'avez pas la permission de consulter cet élément.",
            "permission_denied_create_custom_action": "Vous n'avez pas la permission de créer des actions personnalisées.",
            "permission_denied_edit_custom_action": "Vous n'avez pas la permission de modifier des actions personnalisées.",
            "permission_denied_delete_custom_action": "Vous n'avez pas la permission de supprimer des actions personnalisées.",
            "permission_denied_view_cohort": "Vous n'avez pas la permission de consulter cet élément.",
            "permission_denied_create_cohort": "Vous n'avez pas la permission de créer des cohortes.",
            "permission_denied_edit_cohort": "Vous n'avez pas la permission de modifier des cohortes.",
            "permission_denied_delete_cohort": "Vous n'avez pas la permission de supprimer des cohortes.",
            "permission_denied_view_campaign": "Vous n'avez pas la permission de consulter cet élément.",
            "permission_denied_create_campaign": "Vous n'avez pas la permission de créer des campagnes.",
            "permission_denied_edit_campaign": "Vous n'avez pas la permission de modifier des campagnes.",
            "permission_denied_delete_campaign": "Vous n'avez pas la permission de supprimer des campagnes.",
            "not_authorised_to_list_logs": "Vous n'êtes pas autorisé(e) à répertorier les journaux.",
            "not_authorised_to_view_log_items": "Vous n'êtes pas autorisé(e) à consulter les éléments de journal.",
            "not_authorised_to_view_this_log_item": "Vous n'êtes pas autorisé(e) à consulter cet élément de journal.",
            "permission_denied_delete_activity_log_entries": "Vous n'avez pas la permission de supprimer des entrées de journal d'activité.",
            "not_authorised_to_update_provider_details": "Vous n'êtes pas autorisé(e) à mettre à jour les détails du fournisseur.",
            "not_authorised_to_update_other_providers": "Vous n'êtes pas autorisé(e) à mettre à jour les autres fournisseurs.",
            "not_authorised_to_create_providers": "Vous n'êtes pas autorisé(e) à créer des fournisseurs.",
            "not_authorised_to_delete_providers": "Vous n'êtes pas autorisé(e) à supprimer des fournisseurs.",
            "not_authorised_to_access_smsp": "Vous n'êtes pas autorisé(e) à accéder à SMSP.",
            "not_authorised_to_check_duplicate_staff": "Vous n'êtes pas autorisé(e) à vérifier les doublons de membres du personnel.",
            "not_authorised_grant_access_external_staff": "Vous n'êtes pas autorisé(e) à accorder l'accès à des membres du personnel externes.",
            "not_authorised_to_submit_response_for_thread": "Vous n'êtes pas autorisé(e) à soumettre des réponses à cette demande.",
            "not_authorised_to_view_this_form_subimission": "Vous n'êtes pas autorisé(e) à consulter ce formulaire.",
            "not_authorised_to_view_this_thread": "Vous n'êtes pas autorisé(e) à consulter ce fil de discussion.",
            "not_authorised_to_assign_threads": "Vous n'êtes pas autorisé(e) à attribuer des fils de discussion.",
            "not_authorised_set_wait_state_on_threads": "Vous n'êtes pas autorisé(e) à définir l'état d'attente des fils de discussion.",
            "not_authorised_set_follow_up_for_threads": "Vous n'êtes pas autorisé(e) à planifier un suivi des fils de discussion.",
            "not_authorised_to_prioritise_threads": "Vous n'êtes pas autorisé(e) à donner la priorité aux fils de discussion.",
            "not_authorised_to_prioritise_threads_from_other_providers": "Vous n'êtes pas autorisé(e) à donner la priorité aux fils de discussion d'autres fournisseurs.",
            "not_authorised_close_threads_you_do_not_own": "Vous n'êtes pas autorisé(e) à clôturer des fils de discussion qui ne vous appartiennent pas.",
            "not_authorised_to_access_this_thread": "Vous n'êtes pas autorisé(e) à accéder à ce fil de discussion.",
            "not_authorised_to_reopen_threads_you_do_not_own": "Vous n'êtes pas autorisé(e) à rouvrir des fils de discussion qui ne vous appartiennent pas.",
            "not_authorised_to_create_threads_on_behalf_of_this_user": "Vous n'êtes pas autorisé(e) à créer des fils de discussion au nom de cet utilisateur.",
            "not_authorised_to_create_threads_on_behalf_of_other_users": "Vous n'êtes pas autorisé(e) à créer des fils de discussion au nom d'autres utilisateurs.",
            "not_authorised_to_delete_threads": "Vous n'êtes pas autorisé(e) à supprimer des fils de discussion.",
            "not_authorised_to_list_users": "Vous n'êtes pas autorisé(e) à répertorier les utilisateurs.",
            "not_authorised_to_view_users_from_other_providers": "Vous n'êtes pas autorisé(e) à consulter les utilisateurs d'autres fournisseurs.",
            "permission_denied_update_other_user_accounts": "Vous n'avez pas la permission de mettre à jour les comptes d'autres utilisateurs.",
            "permission_denied_update_non_patient_user_accounts": "Vous n'avez pas la permission de mettre à jour les comptes d'utilisateurs autres que les patients.",
            "permission_denied_modify_user_roles": "Vous n'avez pas la permission de modifier les rôles des utilisateurs.",
            "permission_denied_create_non_patient_user_accounts": "Vous n'avez pas la permission de créer des comptes d'utilisateurs autres que les patients.",
            "permission_denied_add_users_with_roles": "Vous n'avez pas la permission d'ajouter des utilisateurs avec des rôles.",
            "permission_denied_add_superusers": "Vous n'avez pas la permission d'ajouter des superutilisateurs.",
            "patients_cannot_be_added_with_roles": "Les patients ne peuvent pas être ajoutés avec des rôles.",
            "permission_denied_delete_this_user_account": "Vous n'avez pas la permission de supprimer ce compte utilisateur.",
            "permission_denied_delete_multi_provider_accounts_yet": "Vous n'avez pas la permission de supprimer les comptes multi-fournisseurs (pour l'instant).",
            "permission_denied_send_emails_to_user_accounts": "Vous n'avez pas la permission d'envoyer des e-mails aux comptes utilisateur.",
            "permission_denied_create_demo_questions": "Vous n'avez pas la permission de créer des questions de démonstration.",
            "permission_denied_create_demo_questions_for_staff_in_other_providers": "Vous n'avez pas la permission de créer des questions de démonstration pour le personnel d'autres fournisseurs.",
            "not_authorised_to_list_duplicate_users": "Vous n'êtes pas autorisé(e) à répertorier les utilisateurs en double.",
            "non_staff_user_attempting_access_usergroup_index": "Utilisateur non membre du personnel tentant d'accéder à l'index des groupes de support.",
            "permission_denied_view_user_groups": "Vous n'êtes pas autorisé(e) à consulter les groupes d'utilisateurs.",
            "permission_denied_edit_user_groups": "Vous n'êtes pas autorisé(e) à modifier les groupes d'utilisateurs.",
            "not_allowed_add_non_staff_users_to_groups": "Vous n'êtes pas autorisé(e) à ajouter des utilisateurs non membres du personnel aux groupes.",
            "permission_denied_create_user_groups": "Vous n'êtes pas autorisé(e) à créer des groupes d'utilisateurs.",
            "not_authorised_to_send_video_control_requests_to_this_thread": "Vous n'êtes pas autorisé(e) à envoyer des demandes de contrôle vidéo à ce fil de discussion.",
            "permission_denied_delete_appointment": "Vous n'êtes pas autorisé(e) à supprimer ce rendez-vous.",
            "permission_denied_edit_network_settings": "Vous n'êtes pas autorisé(e) à modifier les paramètres du réseau.",
            "not_authorised_to_set_ownership": "Vous n'êtes pas autorisé(e) à définir la propriété des demandes.",
            "only_owner_can_transfer_ownership": "Seul le propriétaire peut transférer la propriété d'une demande.",
            "token_not_found": "Jeton de compte nouvellement créé introuvable."
        },
        "qa": {
            "new": "S'agit-il de : ",
            "sc_new": "Nouveau/Existant/Autre",
            "about": "Votre demande en quelques mots. Il y a de l'espace pour plus de détails ensuite.",
            "sc_about": "À propos de",
            "about_medication_subject": "La ligne d'objet de votre demande. Il y a de l'espace pour plus de détails ensuite.",
            "sc_about_medication_subject": "À propos de",
            "how_long": "Depuis combien de temps avez-vous ce problème ?",
            "sc_how_long": "Combien de temps ?",
            "symptoms": "Veuillez décrire vos symptômes et une idée de la cause. Quelles sont vos préoccupations aujourd'hui ? Comment aimeriez-vous que nous vous aidions ?",
            "sc_symptoms": "Symptômes/Causes/Préoccupations/Attentes",
            "contact_by": "Comment préférez-vous que nous résolvions votre demande ?",
            "sc_contact_by": "Préférez le contact par",
            "call_time": "Quand aimeriez-vous que nous vous appelions ?",
            "sc_call_time": "Horaire d'appel préféré",
            "availability": "Veuillez indiquer quand vous êtes disponible. Nous essayerons de nous arranger.",
            "sc_availability": "Disponibilité",
            "changes": "Veuillez décrire les changements récents.\\n Quelles sont vos préoccupations aujourd'hui ?\\n Comment aimeriez-vous que nous vous aidions ?",
            "sc_changes": "Changements/Préoccupations/Attentes",
            "clinician": "Nous ne pouvons pas garantir, mais nous ferons de notre mieux si vous avez un clinicien préféré",
            "sc_clinician": "Clinicien choisi",
            "appointment_time": "Si le médecin décide que vous avez besoin d'une consultation en personne, avez-vous une heure préférée, normalement aujourd'hui ?",
            "sc_appointment_time": "Horaire de rendez-vous préféré",
            "like_help_from": "De qui aimeriez-vous recevoir de l'aide ?",
            "sc_like_help_from": "Souhaiterait l'aide de",
            "resolve_by": "Comment cette demande a-t-elle été résolue ?",
            "sc_resolve_by": "Résolution",
            "if_notes_resolve_by": "Si des notes étaient disponibles, je résoudrais en :",
            "explain_question": "Veuillez expliquer votre question",
            "sc_explain_question": "Question",
            "explain_medication_query": "Plus de détails sur votre demande de médicaments",
            "sc_explain_medication_query": "Demande",
            "completed_by_other": "Cette demande a-t-elle été résolue au nom d'un autre clinicien ?",
            "sc_completed_by_other": "Complété par un autre clinicien",
            "completed_behalf_of": "Clinicien pour lequel la demande a été traitée",
            "sc_completed_behalf_of": "Traitée pour le compte de",
            "option_new_medical_problem": "Nouveau problème médical",
            "option_val_new_medical_problem": "Nouveau problème médical",
            "option_existing_problem": "Problème existant",
            "option_val_existing_problem": "Problème existant",
            "option_any_other_question": "Toute autre question",
            "option_val_any_other_question": "Autre question",
            "option_medication_query": "Demande de médicaments",
            "option_val_medication_query": "Demande de médicaments",
            "option_email_message": "Message électronique",
            "option_val_email_message": "Message électronique",
            "option_telephone": "Téléphone",
            "option_val_telephone": "Téléphone",
            "option_face_to_face_appointment": "Consultation en personne",
            "option_val_face_to_face_appointment": "Consultation en personne",
            "option_asap": "Dès que possible",
            "option_val_asap": "Dès que possible",
            "option_explain_availability": "Je dois expliquer ma disponibilité",
            "option_val_explain_availability": "Expliquer",
            "option_anyone": "N'importe qui",
            "option_val_anyone": "N'importe qui",
            "option_someone_by_name": "Quelqu'un par son nom",
            "option_val_someone_by_name": "Quelqu'un par son nom",
            "option_female_clinician": "Clinicienne femme",
            "option_val_female_clinician": "Clinicienne femme",
            "option_male_clinician": "Clinicien homme",
            "option_val_male_clinician": "Clinicien homme",
            "option_message": "Message",
            "option_val_message": "Message",
            "option_face_to_face": "En personne",
            "option_val_face_to_face": "En personne",
            "option_abandoned": "Abandonné",
            "option_val_abandoned": "Abandonné",
            "option_admin": "Administration",
            "option_val_admin": "Administration",
            "option_other_clinician": "Autre clinicien",
            "option_val_other_clinician": "Autre clinicien",
            "option_anytime_not_urgent": "N'importe quand, pas urgent",
            "option_val_anytime_not_urgent": "N'importe quand, pas urgent",
            "option_video": "Vidéo",
            "option_val_video": "Vidéo",
            "option_visit": "Visite",
            "option_val_visit": "Visite",
            "option_yes": "Oui",
            "option_val_yes": "Oui",
            "option_no": "Non",
            "option_val_no": "Non",
            "option_view_online_resources": "Voir les ressources en ligne",
            "option_val__view_online_resources": "Lancement de la recherche",
            "option_continue_to_askmyGP": "Continuer avec askmyGP",
            "option_val_continue_to_askmyGP": "Continuer avec askmyGP"
        },
        "pagination": {
            "previous": "Précédent",
            "next": "Suivant"
        },
        "validation": {
            "phone": "Le champ {attribute} contient un nombre invalide.",
            "accepted": "Le champ {attribute} doit être accepté.",
            "active_url": "Le champ {attribute} n'est pas une URL valide.",
            "after": "Le champ {attribute} doit être une date après le {date}.",
            "after_or_equal": "Le champ {attribute} doit être une date après ou égale à {date}.",
            "alpha": "Le champ {attribute} ne peut contenir que des lettres.",
            "alpha_dash": "Le champ {attribute} ne peut contenir que des lettres, des chiffres et des tirets.",
            "alpha_num": "Le champ {attribute} ne peut contenir que des lettres et des chiffres.",
            "array": "Le champ {attribute} doit être un tableau.",
            "before": "Le champ {attribute} doit être une date avant {date}.",
            "before_or_equal": "Le champ {attribute} doit être une date avant ou égale à {date}.",
            "between": {
                "numeric": "Le champ {attribute} doit être entre {min} et {max}.",
                "file": "Le champ {attribute} doit être entre {min} et {max} kilo-octets.",
                "string": "Le champ {attribute} doit être entre {min} et {max} caractères.",
                "array": "Le champ {attribute} doit comporter entre {min} et {max} éléments."
            },
            "boolean": "Le champ {attribute} doit être vrai ou faux.",
            "confirmed": "La confirmation du champ {attribute} ne correspond pas.",
            "date": "Le champ {attribute} n'est pas une date valide.",
            "date_format": "Le format du champ {attribute} ne correspond pas à {format}.",
            "different": "Le champ {attribute} et {other} doivent être différents.",
            "digits": "Le champ {attribute} doit comporter {digits} chiffres.",
            "digits_between": "Le champ {attribute} doit comporter entre {min} et {max} chiffres.",
            "dimensions": "Les dimensions de l'image du champ {attribute} sont invalides.",
            "distinct": "Le champ {attribute} comporte une valeur en double.",
            "email": "Le champ {attribute} doit être une adresse e-mail valide.",
            "exists": "Le {attribute} sélectionné est invalide.",
            "file": "Le champ {attribute} doit être un fichier.",
            "filled": "Le champ {attribute} doit avoir une valeur.",
            "image": "Le champ {attribute} doit être une image.",
            "in": "Le {attribute} sélectionné est invalide.",
            "in_array": "Le champ {attribute} n'existe pas dans {other}.",
            "integer": "Le champ {attribute} doit être un nombre entier.",
            "ip": "Le champ {attribute} doit être une adresse IP valide.",
            "ipv4": "Le champ {attribute} doit être une adresse IPv4 valide.",
            "ipv6": "Le champ {attribute} doit être une adresse IPv6 valide.",
            "json": "Le champ {attribute} doit être une chaîne JSON valide.",
            "max": {
                "numeric": "Le champ {attribute} ne peut pas être supérieur à {max}.",
                "file": "Le {attribute} ne peut pas dépasser {max} kilo-octets.",
                "string": "Le {attribute} ne peut pas dépasser {max} caractères.",
                "array": "Le {attribute} ne peut pas avoir plus de {max} éléments."
            },
            "mimes": "Le {attribute} doit être un fichier de type {values}.",
            "mimetypes": "Le {attribute} doit être un fichier de type {values}.",
            "min": {
                "numeric": "Le {attribute} doit être d'au moins {min}.",
                "file": "Le {attribute} doit être d'au moins {min} kilo-octets.",
                "string": "Le {attribute} doit être d'au moins {min} caractères.",
                "array": "Le {attribute} doit avoir au moins {min} éléments."
            },
            "not_in": "Le {attribute} sélectionné est invalide.",
            "not_regex": "Le format du {attribute} est invalide.",
            "numeric": "Le {attribute} doit être un nombre.",
            "present": "Le champ {attribute} doit être présent.",
            "regex": "Le format du {attribute} est invalide.",
            "required": "Le champ {attribute} est requis.",
            "required_if": "Le champ {attribute} est requis lorsque {other} est {value}.",
            "required_unless": "Le champ {attribute} est requis à moins que {other} ne soit dans {values}.",
            "required_with": "Le champ {attribute} est requis lorsque {values} est présent.",
            "required_with_all": "Le champ {attribute} est requis lorsque {values} est présent.",
            "required_without": "Le champ {attribute} est requis lorsque {values} n'est pas présent.",
            "required_without_all": "Le champ {attribute} est requis lorsqu'aucune des {values} n'est présente.",
            "same": "Le {attribute} et {other} doivent correspondre.",
            "size": {
                "numeric": "Le {attribute} doit être {size}.",
                "file": "Le {attribute} doit être de {size} kilo-octets.",
                "string": "Le {attribute} doit être de {size} caractères.",
                "array": "Le {attribute} doit contenir {size} éléments."
            },
            "string": "Le {attribute} doit être une chaîne de caractères.",
            "timezone": "Le {attribute} doit être une zone valide.",
            "unique": "Le {attribute} a déjà été pris.",
            "uploaded": "Échec du téléchargement du {attribute}.",
            "url": "Le format du {attribute} est invalide.",
            "password": "Mot de passe invalide.",
            "custom": {
                "tags_tag_use": {
                    "required": "Veuillez sélectionner au moins une utilisation pour l'étiquette."
                },
                "forenames": {
                    "required": "Veuillez entrer le(s) prénom(s)."
                },
                "surname": {
                    "required": "Veuillez entrer le nom de famille."
                },
                "dob": {
                    "required": "Veuillez entrer la date de naissance.",
                    "date": "Veuillez entrer une date de naissance valide.",
                    "before": "Veuillez entrer une date de naissance valide.",
                    "in": "La date de naissance saisie ne correspond pas aux données détenues par le cabinet.",
                    "regex": "Veuillez entrer la date de naissance au format JJ/MM/AAAA."
                },
                "gender": {
                    "required": "Veuillez sélectionner le sexe."
                },
                "provider": {
                    "site_id": {
                        "required": "Veuillez sélectionner le site préféré."
                    },
                    "id": {
                        "required": "Veuillez sélectionner un fournisseur."
                    },
                    "user_role_id": {
                        "required": "Veuillez sélectionner un rôle d'utilisateur."
                    }
                },
                "capacity": {
                    "*": {
                        "capacity": {
                            "*": "La capacité doit être un nombre entier, zéro ou plus."
                        }
                    }
                },
                "verification_status_id": {
                    "required": "Veuillez sélectionner un statut d'identification (ID)."
                },
                "demand": {
                    "*": {
                        "demand": {
                            "*": "La demande doit être un nombre entier, zéro ou plus."
                        }
                    }
                },
                "email": {
                    "required": "Veuillez entrer votre adresse e-mail."
                },
                "phone_number": {
                    "required": "Veuillez entrer votre numéro de téléphone."
                },
                "postcode": {
                    "required": "Veuillez entrer votre code postal.",
                    "regex": "Veuillez entrer un code postal valide."
                },
                "terms": {
                    "required": "Veuillez accepter l'accord de licence de l'utilisateur final."
                },
                "locale": {
                    "required": "Veuillez sélectionner une langue."
                },
                "user_relationship_type_id": {
                    "required": "Veuillez sélectionner la relation entre vous-même et le patient."
                },
                "site_id": {
                    "required": "Veuillez sélectionner votre site préféré."
                },
                "message": {
                    "required": "Veuillez saisir quelque chose dans la zone de message."
                },
                "attached_images": {
                    "*": {
                        "*": "Votre image jointe ne semble pas être un fichier image valide (seuls les formats jpg, jpeg et png sont pris en charge)."
                    }
                },
                "attached_documents": {
                    "*": {
                        "mimetypes": "Votre document joint ne semble pas être un fichier de document valide (seuls les formats pdf, doc, docx, odt, xls, xlsx, ods sont pris en charge).",
                        "clamav": "Un virus a été détecté lors du téléchargement de votre fichier. Vous voudrez peut-être exécuter un programme antivirus sur votre ordinateur pour vérifier la présence de virus. Le téléchargement a été rejeté.",
                        "*": {
                            "mimetypes": "Votre document joint ne semble pas être un fichier de document valide (seuls les formats pdf, doc, docx, odt, xls, xlsx, ods sont pris en charge).",
                            "clamav": "Un virus a été détecté lors du téléchargement de votre fichier. Vous voudrez peut-être exécuter un programme antivirus sur votre ordinateur pour vérifier la présence de virus. Le téléchargement a été rejeté."
                        }
                    }
                }
            }
        },
        "errors": {
            "too_many_page_requests": "Le serveur signale que vous effectuez trop de demandes de données/pages. Veuillez patienter et réessayer ultérieurement.",
            "data_sending_too_large_rejected": "Le serveur a signalé que les données que vous envoyez sont trop volumineuses et les a rejetées. Essayez d'utiliser une pièce jointe plus petite.",
            "item_requested_not_found_maybe_deleted_by_another": "L'élément que vous demandez n'a pas été trouvé. Cela peut être dû à sa suppression par un autre utilisateur.",
            "data_endpoint_not_found": "L'endpoint de données que vous essayez d'accéder n'a pas été trouvé.",
            "an_error_occured_try_again": "Une erreur s'est produite. Veuillez réessayer.",
            "security_risk": "Le serveur a détecté un contenu considéré comme un risque de sécurité. Si vous pensez qu'il s'agit d'une erreur, veuillez le signaler à l'adresse suivante : <ul><li><a href='mailto:askmyGP@evergreen-life.co.uk?Subject=askmyGP%20user%20report'>askmyGP@evergreen-life.co.uk</a></li></ul>Notre équipe de sécurité a été informée de cet incident, et vos coordonnées d'utilisateur et votre adresse IP ont été enregistrées pour nous aider à prendre les mesures appropriées.",
            "unexpected_response_from_server": "Une réponse inattendue a été reçue du serveur. Si cela continue de se produire, veuillez en informer un administrateur.",
            "application_version_too_old": "La version de l'application que vous utilisez est obsolète. Cliquez sur le bouton ci-dessous pour forcer l'application à se rafraîchir. Si vous continuez à voir ce message après un rafraîchissement, vous devrez peut-être réessayer ultérieurement.\n        <br /><div style=\"\"text-align: center\"\"><button onclick=\"\"window.location.reload(true)\"\" class=\"\"btn btn-primary\"\">Rafraîchir pour utiliser la dernière version de l'application</button></div>\"",
            "admin_restricted_patient_not_found": "Aucun patient trouvé avec cet identifiant ou cette adresse e-mail.",
            "max_websocket_reconnects": "L'application a des difficultés à se connecter au serveur. Cliquez sur le bouton ci-dessous pour forcer l'application à se rafraîchir. Si vous continuez à voir ce message après un rafraîchissement, vous devrez peut-être réessayer ultérieurement.\n        <br /><div style=\"\"text-align: center\"\"><button onclick=\"\"window.location.reload(true)\"\" class=\"\"btn btn-primary\"\">Rafraîchir l'application</button></div>\"",
            "writeback_max_pending_age_warning": "Il y a des envois en attente dans votre file d'attente de retour d'écriture qui datent de plus de {hours} heures. Veuillez vous assurer que votre système de dépôt fonctionne correctement, car les demandes ne seront pas enregistrées dans votre système clinique tant que cela ne sera pas résolu. Pour les centres médicaux (\"GP practices\") utilisant Systmone, vérifiez que votre processus de sondage fonctionne et que SystmOne est connecté à celui-ci. <a target=\"helpdesk\" href=\"https://evergreenlife.freshdesk.com/support/solutions/articles/14000145209-systmone-poller-troubleshooting\">Des conseils supplémentaires peuvent être trouvés ici</a>."
        }
    }
}
